{
  "commissions": {
    "title": "Commissions",
    "subtitle": "Review earned commissions by salesperson and state.",
    "dateRange": "Date range",
    "allTime": "All time",
    "clearDates": "Clear dates",
    "category": "Commission category",
    "allCategories": "All categories",
    "allSalespeople": "All salespeople",
    "loadingSalespeople": "Loading salespeople…",
    "salespeopleLoadError": "Couldn't load salesperson choices.",
    "intro": "Intro Pack",
    "closer": "Closer Pack",
    "moment5Pack": "Moment 5-Pack",
    "neer": "Neer",
    "crystal": "Crystal",
    "resetFilters": "Reset filters",
    "dateHint": "Showing all time by default. Select a start and end date to filter; both days are included in your local time zone.",
    "invalidDates": "Select a valid date range or clear it to show all time.",
    "invalidDateRange": "The end date must be on or after the start date.",
    "loading": "Loading commissions…",
    "loadError": "We couldn't load the commission report. Please try again.",
    "retry": "Try again",
    "summary": "Commission summary",
    "totalCommission": "Total commission",
    "filteredTotal": "Earned across all matching salespeople",
    "salespeople": "Salespeople",
    "salespeopleHint": "Includes unassigned commissions",
    "statesRepresented": "States represented",
    "statesHint": "Known states with earned commissions",
    "bySalesperson": "Commission by salesperson",
    "currencyHint": "Amounts in USD",
    "salesperson": "Salesperson",
    "states": "States",
    "unassigned": "Unassigned",
    "unknownState": "Unknown state",
    "emptyTitle": "No commissions found",
    "emptyDescription": "Try another date range, category or salesperson.",
    "details": "Details",
    "viewDetails": "View details",
    "backToSalespeople": "Back to salespeople",
    "detailsSubtitle": "Commission entries matching the selected report filters.",
    "detailsLoadError": "We couldn't load these commission details. Please try again.",
    "entries": "Entries",
    "categoryBreakdown": "Commission by category",
    "breakdownView": "Commission breakdown view",
    "byState": "By state",
    "sourceIdentity": "User email / Order ID",
    "unitsCounted": "Units counted",
    "commission": "Commission",
    "viewAward": "View commission entry",
    "unavailable": "Unavailable",
    "awardDate": "Award date",
    "commissionDetail": "Commission detail",
    "awardDetails": "Award details",
    "closeDetails": "Close commission details",
    "awardUnavailable": "This commission entry is no longer available. Close the details and refresh the report.",
    "sourceType": "Source type",
    "packagePurchase": "Package purchase",
    "order": "Order",
    "purchasingUsers": "Purchasing users",
    "contributingOrders": "Contributing orders",
    "contributionHint": "All purchases counted toward this award are shown, including purchases before the selected report period.",
    "contributionsUnavailable": "The purchase details for this historical commission are unavailable.",
    "orderId": "Order ID",
    "datePurchased": "Date purchased",
    "invoice": "Invoice #",
    "transactionAmount": "Transaction amount",
    "totalCounted": "Total counted",
    "paymentStatus": { "paid": "Paid", "refunded": "Refunded" }
  },
  "adminManagement": {
    "unsupportedRole": "This account’s role is not supported for editing here. You can still change its password or status from the user list.",
    "navigation": "Administration navigation",
    "labAdminNavigation": "Lab Admin navigation",
    "title": "Admin",
    "management": "Management",
    "navUsers": "Users",
    "navOrders": "Treatments",
    "navPrintLabs": "Print labs",
    "users": "Users",
    "usersDescription": "Manage user accounts, roles, and access.",
    "createUser": "Create user",
    "searchPlaceholder": "Search by name or email",
    "userCount": "{{count}} users",
    "user": "User",
    "roles": "Roles",
    "assignment": "Office / Lab",
    "organization": "Organization",
    "lastLogin": "Last login",
    "status": "Status",
    "actions": "Actions",
    "active": "Active",
    "inactive": "Inactive",
    "edit": "Edit",
    "connect": "Connect",
    "connectTo": "Connect to {{name}}",
    "adminModeTitle": "Admin mode",
    "adminModeMessage": "You are operating as {{name}} ({{email}}).",
    "exitAdminMode": "Exit admin mode",
    "connectionUserLoading": "Loading connected account…",
    "connectionUserLoadError": "Unable to load the connected account.",
    "changePasswordFor": "Change password for {{name}}",
    "changePassword": "Change password",
    "deactivate": "Disable",
    "activate": "Enable",
    "noUsers": "No users found",
    "noUsersDescription": "Try adjusting or clearing your search and filters.",
    "loading": "Loading…",
    "retry": "Retry",
    "loadError": "Unable to load users. Please try again.",
    "detailsError": "Unable to load user details and options. Please try again.",
    "saveError": "Unable to save changes. Please check the details and try again.",
    "created": "User created. An account email will be sent to the user.",
    "updated": "User details updated.",
    "passwordUpdated": "Password updated.",
    "statusUpdated": "User status updated.",
    "editUser": "Edit user",
    "newPassword": "New password",
    "currentPassword": "Current password",
    "confirmPassword": "Confirm password",
    "passwordHint": "Use at least 8 characters and at least 3 of: uppercase letters, lowercase letters, numbers, and special characters.",
    "passwordValidation": "Complete all password fields and meet the password requirements.",
    "passwordMismatch": "The passwords do not match.",
    "cancel": "Cancel",
    "saving": "Saving…",
    "save": "Save",
    "deactivateUser": "Disable user",
    "activateUser": "Enable user",
    "deactivateConfirmation": "Disable {{email}}? This user will no longer be able to sign in.",
    "activateConfirmation": "Enable {{email}} to restore access to the account?",
    "createHint": "Create an account and assign its role. The user will receive an account email.",
    "editHint": "Update user details and role.",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "emailReadOnlyHint": "Email cannot be changed here.",
    "role": "Role",
    "selectRole": "Select a role",
    "office": "Office",
    "selectOffice": "Select an office",
    "lab": "Lab",
    "selectLab": "Select a lab",
    "noOrganization": "No organization",
    "formValidation": "Complete all required fields and enter a valid email address.",
    "orders": "Treatments",
    "ordersDescription": "Find any treatment by the user who placed it, the patient's name or ID, its treatment ID, treatment type, print lab, or status. Select a row to open the treatment details.",
    "ordersDescriptionLabScoped": "Find any treatment routed to your lab by the user who placed it, the patient's name or ID, its treatment ID, treatment type, or status. Select a row to open the treatment details.",
    "orderCount": "{{count}} treatments",
    "ordersLoadError": "Unable to load treatments. Please try again.",
    "filterUser": "User or email",
    "filterRole": "Role",
    "filterUserPlaceholder": "Name or email address",
    "filterOrderId": "Treatment ID",
    "filterOrderIdPlaceholder": "e.g. ABCD-EFGH",
    "filterPatient": "Patient name or ID",
    "filterPatientPlaceholder": "Name or patient ID",
    "filterOrderType": "Treatment type",
    "printLab": "Print lab",
    "allPrintLabs": "All print labs",
    "allRoles": "All roles",
    "allStatuses": "All statuses",
    "clearFilters": "Clear filters",
    "order": "Treatment",
    "orderType": "Treatment type",
    "submittedBy": "Submitted by",
    "lastUpdated": "Last updated",
    "shipmentTracking": "Shipment tracking",
    "shippingLabel": "Shipping Label",
    "viewShippingLabel": "View label",
    "viewShippingLabelForOrder": "View shipping label for treatment {{id}} (opens in a new tab)",
    "treatmentAction": "Action",
    "shippingActionsForOrder": "Shipping actions for treatment {{id}}",
    "generateShippingLabelError": "Unable to generate the shipping label for treatment {{id}}. Please try again.",
    "generateLabSlipError": "Unable to generate the Lab Slip for treatment {{id}}. Please try again.",
    "generatingShippingLabel": "Generating the shipping label for treatment {{id}}…",
    "generatingLabSlip": "Generating the Lab Slip for treatment {{id}}. This may take a moment…",
    "archivingShippingLabel": "The Lab Slip for treatment {{id}} has opened. Saving the shipping label…",
    "shippingLabelGenerated": "Shipping label generated for treatment {{id}}.",
    "labSlipOpened": "Lab Slip opened for treatment {{id}}.",
    "openOrder": "Open treatment {{id}}",
    "sampleOrder": "Sample",
    "editOrderPrintLab": "Edit treatment print lab",
    "editOrderPrintLabDescription": "Choose the print lab for treatment {{id}}.",
    "selectPrintLab": "Select a print lab",
    "updateOrderPrintLabError": "Unable to update the treatment print lab. Please try again.",
    "noOrders": "No treatments found",
    "noOrdersDescription": "Try another user, treatment ID, treatment type, print lab, or status.",
    "noOrdersDescriptionLabScoped": "Try another user, treatment ID, treatment type, or status.",
    "printLabs": "Print lab management",
    "printLabsDescription": "Manage the print labs available to your organization and assign the treatment types they receive.",
    "createPrintLab": "Create print lab",
    "editPrintLab": "Edit print lab",
    "printLabName": "Print lab name",
    "location": "Location",
    "speciality": "Specialty",
    "noPrintLabs": "No print labs found",
    "noPrintLabsDescription": "Create a print lab before assigning treatment types.",
    "printLabCreated": "Print lab created.",
    "printLabUpdated": "Print lab updated.",
    "printLabStatusUpdated": "Print lab status updated.",
    "disablePrintLab": "Disable print lab",
    "enablePrintLab": "Enable print lab",
    "disablePrintLabConfirmation": "Disable {{name}}? It can no longer receive new assignments.",
    "enablePrintLabConfirmation": "Enable {{name}} so it can receive assignments again?",
    "assignmentRules": "Treatment type assignments",
    "assignmentRulesDescription": "Choose the print lab that receives new treatments for each treatment type.",
    "assignedPrintLab": "Assigned print lab",
    "defaultPrintLab": "Default print lab",
    "assignmentHint": "Default print lab uses the configured fallback when no lab is selected.",
    "unavailableAssignment": "Current assignment to {{labName}} is unavailable. Choose an active Neer print lab or clear this field to use the default.",
    "assignmentRulesUpdated": "Treatment type assignments updated.",
    "assignmentRulesLoadError": "Unable to load print lab assignments. Please try again.",
    "moment": "Moment",
    "neer": "Neer",
    "neerCrystal": "Neer Crystal",
    "nightGuard": "Night Guard"
  },
  "days": {
    "friday": "Friday",
    "monday": "Monday",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "thursday": "Thursday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday"
  },
  "guide": {
    "patient-info-patient-details-title": "Patient details",
    "patient-info-patient-details-description": "Add a new patient or select one to begin this sample order.",
    "patient-info-patient-details-prev-btn-text": "Select Patient",
    "patient-info-select-existing-patient-title": "Select Existing Patient",
    "patient-info-expand-select-existing-patient-description": "Click here to select an existing patient.",
    "patient-info-expand-select-existing-patient-next-btn-text": "Next",
    "patient-info-expand-select-existing-patient-prev-btn-text": "New Patient instead",
    "patient-info-select-existing-patient-description": "Select an existing patient from the list.",
    "patient-info-select-existing-patient-prev-btn-text": "Add Patient Instead?",
    "patient-info-submit-title": "Patient Information Complete",
    "patient-info-submit-description": "You have completed the patient information step.",
    "patient-info-expand-add-patient-title": "Add new patient",
    "patient-info-expand-add-patient-description": "Click here to add a new patient.",
    "patient-info-expand-add-patient-next-btn-text": "Next",
    "treatment-type-select-title": "Treatment type",
    "treatment-type-select-description": "Choose the treatment type that matches this sample case.",
    "treatment-type-select-next-btn-text": "Select Neer Treatment Type",
    "treatment-type-select-neer-title": "Neer treatment type",
    "treatment-type-select-neer-description": "Click to select the Neer treatment type.",
    "treatment-type-submit-title": "Submit treatment type",
    "treatment-type-submit-description": "Submit the selected treatment type to proceed.",
    "upload-scans-title": "Upload scans",
    "upload-scans-description": "Upload required files here. Continue when all required items are complete.",
    "upload-scans-prev-btn-text": "Use pre-uploaded Files",
    "patient-smile-qr-title": "Upload the Smile Photo from your phone",
    "patient-smile-qr-description": "Scan the QR code with your phone, then capture or choose the patient's Smile Photo and submit it. The photo will appear here when the upload is complete.",
    "patient-smile-qr-prev-btn-text": "Use Pre-Uploaded Image",
    "save-as-draft-title": "Save as Draft",
    "save-as-draft-description": "Save the current progress as a draft.",
    "save-as-draft-prev-btn-text": "Upload Scans",
    "save-as-draft-next-btn-text": "Submit Scans",
    "submit-upload-scans-title": "Submit upload scans",
    "submit-upload-scans-description": "Submit the uploaded scans to proceed.",
    "submit-upload-scans-incomplete-description": "You cannot proceed until the Upper Scan, Lower Scan, Bite Scans, and Smile Photo are uploaded.",
    "submit-upload-scans-upload-files-btn-text": "Upload Scans",
    "submit-upload-scans-prev-btn-text": "Previous",
    "design-style-select-title": "Design Style",
    "design-style-select-description": "Select the design style for the order.",
    "design-style-select-next-btn-text": "Submit Design Style",
    "design-style-submit-title": "Submit design style",
    "design-style-submit-description": "Submit the selected design style to proceed.",
    "review-and-submit-continue-title": "Continue review and submit",
    "review-and-submit-continue-description": "Continue reviewing the case details before final submission.",
    "treatment-info-select-title": "Treatment Info",
    "treatment-info-select-description": "Fill in the treatment information for the order.",
    "treatment-info-select-next-btn-text": "Continue",
    "treatment-info-submit-title": "Submit treatment info",
    "treatment-info-submit-description": "Submit the treatment information to proceed.",
    "treatment-info-advanced-select-title": "Advanced Treatment Info",
    "treatment-info-advanced-select-description": "Select the advanced treatment options for the order.",
    "treatment-info-advanced-select-next-btn-text": "Continue",
    "treatment-info-advanced-submit-title": "Submit advanced treatment info",
    "treatment-info-advanced-submit-description": "Submit the advanced treatment information to proceed.",
    "review-and-submit-title": "Review and submit",
    "review-and-submit-description": "Review the case details and submit when you are ready."
  },
  "general": {
    "sampleOrderPromptTitle": "Order a Neer sample",
    "sampleOrderPromptDescription": "Try Neer for free and we ship it for free! Follow our guided sample ordering flow by clicking \"Get Started\" below.",
    "sampleOrderPromptPatient": "Patient",
    "sampleOrderPromptTreatment": "Treatment",
    "sampleOrderPromptGetStarted": "Get Started",
    "sampleOrderPromptNotInterested": "I am not interested",
    "sampleOrderPromptNotNow": "Not Now",
    "05mm": "0.5 mm",
    "05mmDeepPostDam": "0.5 mm deep Post Dam",
    "0mmFromTheSulcus": "0 mm from the sulcus",
    "10mm": "10 mm",
    "1mmDeepPostDam": "1.0 mm deep Post Dam",
    "1mmFromSulcus": "1 mm from sulcus",
    "2To4BusinessDaysAfterApproval": "2-4 Business Days After Approval",
    "2mmFromTheSulcus": "2 mm from the sulcus",
    "30Degrees": "30 Degrees",
    "3BusinessDays": "3 Business Days",
    "3DPreView": "3D Preview",
    "3DPrintedRestorations": "3D Printed Restorations",
    "3ShapeConsent": "3Shape Consent",
    "3dPrinters": "3D Printers",
    "3rdParty": "3rd Party",
    "ID": "ID",
    "IHaveReadTheSprintRayDesignLiabilityWaiverAndAgree": "I have read the SprintRay Design Liability Waiver and agree",
    "aICrown": "AI Crown",
    "aIDesignChecklist": "AI Design Checklist",
    "aIGeneratingDesign": "Generating your design...",
    "aIGeneratingDesignDescription": "This should only take a few minutes",
    "aINightGuard": "AI Upper Nightguard",
    "aIReceivedRequest": "Our AI has received your design request and is getting started right away.",
    "aiStudio": "AI Studio",
    "aITreatmentRequestReceived": "AI Treatment Request Received",
    "aIRevisionReason": "AI revision reason:",
    "aIRevisionRequested": "AI Revision Requested",
    "aboBase": "ABO Base",
    "about": "About",
    "abutmentNameAndPartNumber": "Abutment name and Part number",
    "abutmentModelInformation": "Abutment Model Information",
    "abutmentModelInformationSubTitle": "Abutment model information",
    "abutmentModelBrand": "Abutment Model Brand",
    "abutmentPartNumber": "Abutment Model Part Number",
    "abutmentType": "Abutment Type",
    "acceptedFileTypes": "Accepted file types:",
    "access": "Access",
    "accept": "Accept",
    "account": "Account",
    "accountManagement": "Account Management",
    "accountExpiration": "Your account will be delete after",
    "accountPreferences": "Account Preferences",
    "activate": "Activate",
    "activateDevice": "Activate The Device",
    "activateMidas": "Activate Midas",
    "activateTheGroup": "Activate The Group",
    "activateUser": "Activate The User",
    "active": "Active",
    "activeNow": "Active Now",
    "activePlural": "Active",
    "activeTreatments": "Active Treatments",
    "activateYourPrinter": "Activate Your Printer",
    "actions": "Actions",
    "add": "Add",
    "addAFolder": "Add a Folder",
    "addAPatient": "Add a Patient",
    "addATreatment": "Add a Treatment",
    "addAdditionalExplanation": "Add additional explanation",
    "addAllToPrintJob": "Add All to Print Job",
    "addAnIntegration": "Add an integration with a SprintRay partner to get started",
    "addAnswer": "Add Answer",
    "addDeviceToGroup": "Add device to group",
    "addDiscountForAll": "Add discount for all",
    "addFiles": "Add Files",
    "addFilesByDragAndDrop": "Upload a model by Drag & Drop or by choosing a printjob type",
    "addFilesToPrintJob": "Add to Print Job",
    "addFirstPatientText": "Add your first patient without starting a new treatment.",
    "addFromSprFile": "Add From SPR File",
    "addLab": "Add Lab",
    "addMissingTeeth": "Add missing teeth",
    "addMoreFiles": "Add More Files",
    "addNewPatient": "Add New Patient",
    "addNewPromoCode": "Add new promo code",
    "addNewStep": "Add New Step",
    "addNightGuard": "Add Night Guard",
    "addNightGuardOptionsTitle": "Extra Night Guard",
    "addOperation": "Add Operation",
    "addPatient": "Add Patient",
    "addPatientToNeer": "Add Patient to Neer",
    "continuePatientToNeer": "Continue Patient Setup",
    "viewPatientInNeer": "View Patient in Neer",
    "addPaymentMethod": "Add payment method",
    "addQuestion": "Add Question",
    "addRemoveIndividualSupports": "Add/Remove individual Supports",
    "addScannerIntegration": "Add Scanner Integration",
    "addToPrintJob": "Add to Print Job",
    "addToTreatment": "Add to Treatment",
    "addUser": "Add new user",
    "added": "Added",
    "additionalCharge": "Additional charge",
    "additionalComments": "Additional Comments",
    "additionalFitment": "Additional Fitment Notes",
    "additionalInstructions": "Additional Instructions",
    "additionalItems": "Additional Items",
    "additionalNotes": "Additional Notes",
    "address": "Address",
    "addressLine1": "Address line 1",
    "addressLine2": "Address line 2",
    "addNow": "Add Now",
    "addCreditCard": "Add credit card",
    "addCreditCardCloudDesignService": "Add your credit card to use our Cloud Design service.",
    "admin": "Admin",
    "personalizationSettings": "Personalization Settings",
    "afterPromoCodeExpired": "after promo code expired",
    "afterward": "afterward",
    "aiCrownSettings": "AI Crown Settings",
    "aiNgErrorCode301Tips": "The design is ready for preview and approval",
    "alert": "Oops",
    "aligner": "Aligner",
    "alignerModels": "Aligner Models",
    "all": "All",
    "allProducts": "All products",
    "allPrinters": "All printers",
    "allTreatments": "All treatments",
    "allTransactionSecured": "All transactions are secure and encrypted",
    "allTreatmentsRelatedToThisPatientWillBeShownHere": "All treatments related to this patient will be shown here.",
    "allVersions": "All versions",
    "allow": "Allow",
    "amazing": "Amazing",
    "amount": "Amount",
    "analyzingMesh": "Analyzing Mesh",
    "anatomicalOcclusion": "Anatomical Occlusion/Indentations",
    "anatomicalOcclusionIndentations": "Anatomical Occlusion/Indentations",
    "anatomy": "Anatomy",
    "and": "and",
    "andBeBilledAt": "and be billed at",
    "andTheRest": "and the rest",
    "annotation": "Annotation",
    "annual": "annual",
    "annualTeamReport": "Annual Team Report",
    "anonymous": "Anonymous",
    "anonymousF": "Anonymous",
    "anonymousM": "Anonymous",
    "answer": "Answer",
    "answeredQuestions": "Аnswered Questions",
    "answers": "Answers",
    "anteriorAesthetics": "Anterior aesthetics",
    "anteriorCrown": "Anterior Crown",
    "anteriorBuildup": "Anterior Buildup",
    "anteriorPosteriorRelationshipOfCanines": "Anterior Posterior Relationship of Canines",
    "anyCrownsAndImplantsAnyDiastemasThatDoNotNeedToBeAltered": "Any crowns and implants? Any diastemas that do not need to be altered?",
    "anythingYouWantUsToLookOut": "Anything you want us to look out for",
    "detailOfVdoModification": "Provide details about this treatment, i.e. VDO modification",
    "appId": "App Id",
    "appartment": "Appartment",
    "appearAway": "Appear Away",
    "applianceConversation": "Appliance Conversation",
    "applianceRevenue": "Appliance Revenue",
    "applianceType": "Appliance Type",
    "applianceTypeStepOf": "Appliance type {{ step }} of",
    "apply": "Apply",
    "applyCode": "Apply Code",
    "appointment": "Appointment",
    "appointmentDate": "Appointment date",
    "approvalDate": "Approval date",
    "approve": "Approve",
    "approveAndPay": "Approve & Pay",
    "approveAllDesigns": "Approve All Designs",
    "approveDesign": "Approve Design",
    "approveCharge": "Approve Charge",
    "approveFiles": "Approve Files",
    "approveFilesAndPay": "Approve Files & Pay",
    "approveFilesToDownload": "Approve Files to Download",
    "approveImagesToReceiveFiles": "Approve Images to Receive Files",
    "approveTreatment": "Approve Treatment",
    "approved": "Approved",
    "approvalNeeded": "Approval Needed",
    "apptDate": "Appt. Date",
    "arch": "Arch",
    "archKit": "Arch Kit",
    "archMode": "Arch Mode",
    "arches": "Arches",
    "archive": "Add to archive",
    "archived": "Archived",
    "archivePrintJob": "Archive Print Job",
    "assembledView": "Assembled View",
    "asSoonAsPaymentsWillbeAddedTheyWillBeShown": "As soon as the payments will be added they will be shown here",
    "asSoonAsTreatmentsWillbeAddedTheyWillBeShown": "As soon as the treatments will be added they will be shown here",
    "aspenApprovalDisabledTooltip": "Waiting on Aspen admin approval",
    "assign": "Assign",
    "assignApplianceType": "Assign Appliance Type",
    "assignDesigner": "Assign designer",
    "assignDevices": "Assign Devices",
    "assignPrintJobToPatient": "Assign Print Job to Patient",
    "assignedTo": "Assigned to:",
    "assignToANewPatient": "Assign to a New Patient",
    "assignToAnExistingPatient": "Assign to an Existing Patient",
    "assignToDifferentPatient": "Assign to Different Patient",
    "assignToGroup": "Assign to Group",
    "assignToLab": "Assign to Lab",
    "assignToMe": "Assign to me",
    "assignToPatient": "Assign to Patient",
    "assignment": "Assignment",
    "assignmentSuccessful": "Assignment Successful",
    "attachedFiles": "Attached Files",
    "attachment": "Attachment",
    "attachmentConfigurationUnavailable": "Unable to attach files",
    "attachmentConfigurationUnavailableDetail": "No attachment configuration is available for this treatment type.",
    "attachments": "Attachments",
    "attachFiles": "Attach Files",
    "attention": "Attention",
    "attentionTreatments": "Attention Required",
    "autoAdjustments": "Auto Adjustments",
    "autoFix": "Auto fix",
    "autoLayout": "Auto Layout",
    "autoLayoutOnPlatform": "Auto Layout on platform",
    "autoLayoutType": "Auto Layout Type",
    "autoMeshRepair": "Auto Mesh Repair",
    "autoOrient": "Auto Orient",
    "autopilotMode": "Autopilot Mode",
    "autopilotPreferences": "Autopilot preferences",
    "autoSupport": "Auto Support",
    "autoDetectedbyAI": "Auto-detected by AI",
    "autofix": "autofix",
    "automatic": "Automatic",
    "automaticScanRepairPlaneCut": "Automatic Scan Repair, Plane cut",
    "automatically": "automatically",
    "available": "Available",
    "availablePlans": "Available plans",
    "availableAppointments": "Available appointments",
    "availableForWindowsOnly": "Available for Windows only.",
    "averageTimeToDesign": "Average Time To Design",
    "averageTurnaroundTime": "Average Turnaround Time By Submitted Date",
    "avgRating": "Rating",
    "awaitingApproval": "Message\nReceived/Approval",
    "back": "Back",
    "brand": "Brand",
    "backToBusinessInfo": "Back to business information",
    "backToJob": "Back to Job",
    "backToHome": "BACK TO HOMESCREEN",
    "backToPatient": "Back to Patient",
    "backToPlanSelectoin": "Back to plan selection",
    "backup": "Backup",
    "backupPrint": "Backup Print",
    "bad": "Bad",
    "balance": "Balance",
    "balancedRecommended": "Balanced (Recommended)",
    "banners": "Banners",
    "base": "Base",
    "baseHeight": "Base Height",
    "baseMaterial": "Base Material",
    "baseSpr": "Base (Spr)",
    "baseStl": "Base (Stl)",
    "baseSupports": "Base Supports",
    "basic": "Basic",
    "batchOwners": "Batch owners:",
    "beta": "Beta",
    "billing": "Billing",
    "billingAddress": "Billing address",
    "billingHistory": "Billing History",
    "billingInfo": "Billing information",
    "billingInfoSameAsBusiness": "Billing information is the same as business information",
    "billingPeriod": "Billing period",
    "billings": "Billings",
    "bitePositionPins": "Bite Position Pins",
    "biteScanType": "Bite Scan Type",
    "biteScans": "Bite Scans",
    "bleachingMaterialReservoir": "Bleaching Material Reservoir",
    "bookAnAppointment": "Book an appointment",
    "boltSpeed": "Bolt Speed",
    "boltSpeedInfo": "Bolt Speed makes your printer even faster. Enable it from your printer's touchscreen.",
    "both": "Both",
    "bio": "Biography",
    "bracketRemoval": "Bracket Removal",
    "bracketRemovalDesign": "Bracket Removal Design",
    "bridge": "Bridge",
    "browse": "Browse",
    "browseFiles": "Browse Files",
    "brushSize": "Brush Size",
    "buccalCoverage": "Buccal Coverage",
    "buildPlatform": "Build Platform",
    "businessAddress": "Business Address",
    "businessDay": "business day",
    "businessDays": "business days",
    "businessInformation": "Business Information",
    "businessIntelligenceReport": "Business Intelligence Report",
    "businessName": "Business Name",
    "buyMore": "Buy more",
    "buyMoment5Pack": "Buy Moment 5-Pack",
    "buyResin": "Buy Resin",
    "byDownloadingTheseFiles": "By downloading these files",
    "case": "Case",
    "campaign": "Campaign",
    "campaignEndDate": "Campaign end day",
    "campaignName": "Campaign name",
    "campaignStartDate": "Campaign start day",
    "campaignType": "Campaign Type",
    "campaigns": "Campaigns",
    "canSubmitTreatment": "Can submit treatment.",
    "cancel": "Cancel",
    "cancelAt": "Cancel at",
    "cancelDelete": "Cancel Delete",
    "cancelDeleteAccount": "You can cancel the deletion within 14 days.",
    "cancelDownload": "Cancel Download",
    "cancelFuturePlan": "Cancel Future Plan",
    "cancelImport": "Cancel Import",
    "cancelRequest": "Cancel request",
    "cancelRevision": "Cancel Revision",
    "cancelRevisionAndUseTheseDesign": "Cancel Revision and use this Design",
    "cancelOrder": "Cancel Order",
    "continueToCancel": "Continue to Cancel",
    "cancelTreatment": "Cancel Treatment",
    "cancelSubscription": "Cancel subscription",
    "cancelled": "Cancelled",
    "cantileverStyle": "Cantilever Style",
    "cardExpired": "Card expired",
    "cardInfo": "Card Information",
    "cardNumber": "Card number",
    "cardholderName": "Cardholder Name",
    "caseCancelled": "Case Cancelled",
    "caseDescription": "Case Description / Patient Chief Complaint",
    "cases": "Cases",
    "category": "Category",
    "cbctScans": "CBCT Scans",
    "cementedRestorations": "Cemented Restorations",
    "cementedRestorationSpr": "Cemented Restoration (Spr)",
    "cementedRestorationStl": "Cemented Restoration (Stl)",
    "centralEuropeanTime": "Central European Time",
    "centralAreFlaredOutDistally": "Central are flared out distally",
    "cephXRayJpgJpegPng": "CEPH X-RAY (JPG/JPEG/PNG)",
    "change": "Change",
    "changeClinic": "Change Clinic",
    "changeEmail": "Change Email",
    "changeEmailStep1": "Step 1: Please enter the user’s current email and new email.",
    "changeEmailStep2": "Step 2: To ensure security, please ask the user for the verification code received by the user’s current email and the new email.",
    "changePassword": "Change Password",
    "changePlan": "Change Plan",
    "changePrinterType": "Change Printer Type",
    "changePriority": "Change Priority",
    "changedToClosedBite": "Changed to Closed Bite",
    "changedToOpenBite": "Changed to Open Bite",
    "changeView": "Change View",
    "chargesFor": "Charges For",
    "chat": "Chat",
    "checkout": "Checkout",
    "checkProgressOfRequest": "You can check the progress of this treatment from the Home Screen or Treatment Details.",
    "choose": "Choose",
    "choosePlan": "Choose plan",
    "chooseDifferentInterval": "Choose different interval",
    "city": "City",
    "claimedBy": "Claimed By",
    "claimedOn": "Claimed On",
    "claimReward": "Claim Reward",
    "clasps": "Clasps",
    "classOne": "Class I",
    "classOneBite": "Class one bite",
    "classOneBiteWithAnteriorContact": "Class one bite with anterior contact",
    "classOneWithAnteriorContact": "Class one with anterior contact",
    "classThree": "Class III",
    "classThreeUnderbite": "Class three underbite",
    "classThreeUnderbiteWithClassOnePlacement": "Class three underbite with class one placement",
    "classThreeUnderbiteWithEdgeToEdgeOcclusion": "Class three underbite with edge to edge occlusion",
    "classTwo": "Class II",
    "classTwoOverbite": "Class two overbite",
    "clear": "Clear",
    "clearAligner": "Models for Clear Aligner Fabrication",
    "clearAll": "Clear All",
    "clickForCategory": "Click here to choose a category",
    "clickForMoreInfo": "Click for more info",
    "clickOrDragAndDropToImportFilesHere": "Click or drag and drop to import files to print job",
    "clickToDownloadDesktopClient": "Click here to download the desktop client and start syncing your files.",
    "clickToLoadMore": "Click To Load More",
    "clientId": "Client ID",
    "clinic": "Clinic",
    "clinicId": "Clinic ID",
    "clinicOrLab": "Clinic/Lab",
    "clinicReview": "Clinical review",
    "clinicSearch": "Search Clinic ID...",
    "clinicTag": "Clinic Tag",
    "clinicalConditions": "Clinical Conditions:",
    "clinics": "Clinics",
    "close": "Close",
    "closeAndRefund": "Close the treatment and issue a refund",
    "closeJob": "Close Job",
    "closeWithCreditRefund": "Close this treatment and issue a design credit refund",
    "closeWithoutRefund": "Close this treatment and do not issue a refund",
    "closed": "Closed",
    "closedBite": "Closed Bite",
    "closedBiteScansTitle": "Closed Bite Scans",
    "cloudDesign": "Cloud Design",
    "cloudDrive": "Cloud Drive",
    "cloudDriveSetup": "Cloud Drive Setup",
    "cloudDriveSetupContent": "Connect your local folders to Cloud Drive by installing the desktop client. Connections made with Cloud Drive will be available anywhere in the SprintRay ecosystem.",
    "cloudDriveSetupTitle": "Install Cloud Drive",
    "cloudDriveWelcomeContent": "Connect your files, folders, and scanners to Cloud Drive, then access them anywhere in the SprintRay ecosystem.",
    "cloudDriveWelcomeTitle": "Welcome to Cloud Drive",
    "cloudLogs": "Cloud Logs",
    "code": "Code",
    "codesUsage": "Codes Usage",
    "coin": "Coin",
    "collapse": "Collapse",
    "combinableWith": "Combinable with campaigns",
    "comingSoon": "Coming Soon",
    "commaSeparatedTags": "Comma separated tags",
    "commentForThisTreatment": "Comment for this treatment",
    "commentTreatment": "Comment this treatment",
    "comments": "Comments",
    "communication": "Communication",
    "community": "Community",
    "company": "Company",
    "companyAdmin": "Company Admin",
    "compatiblePrinters": "Compatible Printers",
    "completed": "Completed",
    "completeYourProfile": "Complete your profile",
    "completedDate": "Completed Date",
    "completedRequests": "Completed Requests",
    "computer": "Computer",
    "completePrintsToUnlockFunPrintFilesAndDesignCredits": "Complete prints to unlock fun print files and design credits.",
    "connectPrinter": "Connect Printer",
    "connectYourPrinter": "Connect Your Printer",
    "confirm": "Confirm",
    "confirmed": "Confirmed",
    "confirmation": "Confirmation",
    "confirmChange": "Confirm Change",
    "confirmChanges": "Confirm Changes",
    "confirmFilesToImport": "Confirm files to import",
    "connect": "Connect",
    "connectTheDots": "Connect the Dots",
    "connectedPrinter": "a connected SprintRay Pro 3D printer",
    "connectedPrinters": "Connected Printers",
    "connectDevice": "Connect Device",
    "connectDeviceStep1": "Connect Your Device to the Internet",
    "connectDeviceStep2": "Connect Your Device to SprintRay Cloud",
    "contactDesigner": "Contact Designer",
    "contactsDistance": "Contacts Distance",
    "contactsDistanceThreeLevels": "Contacts Distance [3levels] *",
    "contactSupport": "Contact Support",
    "contactUs": "Contact Us",
    "continue": "Continue",
    "continueAnyway": "Continue Anyway",
    "continueEditingJob": "Continue Editing Job",
    "continueTowardsAchievingTheSameResultAsThePreviousTreatmentPlan": "Continue towards achieving the same result as the previous treatment plan",
    "copy": "Copy",
    "copies": "Copies",
    "unit": "Unit",
    "units": "Units",
    "copyDenture": "Copy Denture",
    "copyDentureOrReferenceDenture": "Copy Denture Or Reference Denture? *",
    "copyright": "Copyright © {{year}} Dental Makeup Inc. All rights reserved.",
    "costOfThisTreatment": "Cost of this treatment",
    "count": "Count",
    "country": "Country",
    "countryOrTerritory": "Country / Territory",
    "countryRegion": "Country/Region",
    "coupon": "Coupon",
    "coverageType": "Coverage type",
    "costSavings": "cost savings",
    "create": "Create",
    "createCampaign": "Create Campaign",
    "createClinic": "Create Clinic",
    "createDevice": "Create Device",
    "createGroup": "Create Group",
    "createNewClinic": "Create New Clinic",
    "createNewGroup": "Create New Group",
    "createNewNotification": "Create New Notification",
    "createNewPatient": "Create New Patient",
    "createNewPatientAndAssign": "Create new patient and assign",
    "createPrintJob": "Create Print Job",
    "createRegion": "Create Region",
    "createUser": "Create User",
    "created": "Created",
    "createdDate": "Created Date",
    "creatingSupports": "Creating Supports",
    "credit": "Credit",
    "creditBalanceAdjustments": "Credit balance adjustments",
    "creditApplied": "Credit Applied",
    "creditCard": "Credit Card",
    "creditCardNumber": "Credit Card Number",
    "crowding": "Crowding",
    "crown": "Crown",
    "crown&Bridge": "Crown & Bridge",
    "crownAndBridge": "Crown and Bridge",
    "crownKit": "Crown Kit",
    "crownKitPlatform": "Crown Kit Platform",
    "crownMode": "Crown Mode",
    "crownPlatform": "Crown Platform",
    "crownType": "Crown type",
    "crowns": "Crowns",
    "cureDevices": "Cure Devices",
    "cureMaintenance": "Cure Maintenance",
    "current": "Current",
    "currentCard": "Current card",
    "currentCharge": "Current Charge",
    "currentEmail": "Current Email",
    "currentEmailVerificationCode": "Current Email Verification Code",
    "currentLayer": "Current Layer",
    "currentPlan": "Current Plan",
    "currentPlatform": "Current platform",
    "currentToothMoldsIfKnown": "Current tooth molds if known",
    "currentVersion": "Current version",
    "custom": "Custom",
    "customBleachingTray": "Models for Custom Bleaching Tray Fabrication",
    "customBleachingTraySpr": "Custom Bleaching Tray Models(Spr)",
    "customBleachingTrayStl": "Custom Bleaching Tray Models(Stls)",
    "customerBalanceAdjustments": "Customer balance adjustments",
    "customerSupport": "Customer Support",
    "customerSupportVisibility": "Customer Support Visibility",
    "customerSupportVisibilityIntroduction": "Turn this feature on when talking to SprintRay customer service team to give them visibility over the print status and report. This feature is off by default to protect your privacy.",
    "cut": "Cut",
    "cvcCode": "CVC Code",
    "dailyLimit": "Daily limit",
    "dashboard": "Dashboard",
    "dashboardV2": "DashboardV2",
    "dataLoaded": "Data Loaded",
    "date": "Date",
    "dateAdded": "Date added",
    "dateOfBirth": "Date of Birth",
    "datePublished": "Date Published",
    "dateRange": "Date range",
    "day": "Day",
    "days": "Days",
    "daysLowercase": "days",
    "daysOngoing": "Days ongoing",
    "deactivate": "Deactivate",
    "deactivateDevice": "Deactivate the device",
    "deactivateTheGroup": "Deactivate the group",
    "deactivateUser": "Deactivate the user",
    "deboss": "Deboss",
    "decline": "Decline",
    "decrypting": "Decrypting",
    "deepBite": "Deep Bite",
    "deepestPartOfSulcus": "Deepest part of sulcus",
    "default": "Default",
    "default00mm": "Default 0.0 mm",
    "default0Cantilever": "Default 0 Cantilever (Right after screwhole)",
    "defaultOrientationDegrees": "Default Orientation Degrees",
    "definitiveCrown": "Definitive Crown",
    "degreeOfOrientation": "Degree of Orientation",
    "delete": "Delete",
    "deleteAccount": "Delete Account",
    "deleteAccountData": "Delete your account and data",
    "deleteAll": "Delete All",
    "deleteAllJobs": "Delete All Jobs",
    "deleteCurrentPlatform": "Delete Current Platform",
    "deleteDraft": "Delete Draft",
    "deleteExtLabRelation": "Delete External Lab Relation",
    "deleteFile": "Delete File",
    "deleteFileWarning": "This data will be removed from Cloud Drive",
    "deleteFiles": "Delete Files",
    "deleteGroup": "Delete Group",
    "deleteGroupJob": "Delete Multi-Platform?",
    "deleteGroupSuccess": "Group “{{groupName}}” deleted",
    "deleteGroupWarning": "This will permanently delete group",
    "deleteInvoice": "Delete Invoice",
    "deleteJob": "Delete Job",
    "deleteMyAccount": "Delete My Account",
    "deletePatient": "Delete patient",
    "deletePatientWarning": "This will also delete all treatment history for this patient. Data will be stored for {{days}} days, after that it will be permanently deleted.",
    "deletePrintJob": "Delete Print Job",
    "deletePrintProfile": "Delete Print Profile",
    "deleteProfile": "Delete Profile",
    "deleteTemplateTreatments": "Delete treatment templates",
    "deleteTreatments": "Delete treatments",
    "deleted": "Deleted",
    "deletedPatient": "Patient deleted",
    "deletedPatientUndone": "Patient deletion undone",
    "delivery": "Delivery",
    "delivered": "Delivered",
    "deliveryDate": "Delivery Date",
    "deliveryAddress": "Delivery address",
    "dentalLab": "Dental Lab",
    "dentalModel": "Dental Model",
    "dentalModelType": "Dental Model Type",
    "dentalNotation": "Dental notation",
    "dentist": "Dentist",
    "dentistRevisionRequestRate": "Dentist Revision Request Rate",
    "denture": "Denture",
    "dentureAsReference": "Submitting a Denture as Reference?",
    "dentureBase": "Denture Base",
    "dentureBorder": "Denture Border",
    "dentureBorder1mmFromTheSulcus": "1 mm From the Sulcus",
    "dentureBorder2mmFromTheSulcus": "2 mm From the Sulcus",
    "dentureBorderDeepestPartOfSulcus": "Deepest Part of Sulcus",
    "dentureBorderFollowReferenceDenture": "Follow Reference Denture (Deepest Part of Sulcus)",
    "dentureBorderFollowWaxRimImpression": "Follow Wax Rim Impression (Deepest part of sulcus)",
    "dentureGumBaseSpr": "Denture Gum Base (Spr)",
    "dentureGumBaseStl": "Denture Gum Base (Stl)",
    "dentureStyle": "Denture Style",
    "dentureTeeth": "Denture Teeth",
    "dentureTeethSpr": "Denture Teeth (Spr)",
    "dentureTeethStl": "Denture Teeth (Stl)",
    "dentureWaxSetupScan": "Denture/Wax Setup Scan",
    "dentureWaxSetupScanIfApplicable": "Denture/Wax Setup Scan (If Applicable)",
    "depth": "Depth",
    "description": "Description",
    "descriptionOfficialVersion": "Description (Official Version)",
    "deselectAll": "Deselect All",
    "design": "Design",
    "designInProgress": "Design in Progress",
    "designDeadline": "Design deadline",
    "designTeamReceivedRequest": "The design team has received your request and will get started right away.",
    "designTurnaroundTime": "Design Turnaround Time",
    "designType": "Design Type",
    "designer": "Designer",
    "designerPerformance": "Designer Performance",
    "designerReport": "Designer Report",
    "designerRevisionRequestRate": "Designer Revision Request Rate",
    "designers": "Designers",
    "designStyle": "Design Style",
    "dess": "Dess",
    "details": "Details",
    "detailsAndOrders": "Details & orders",
    "device": "Device",
    "deviceActivation": "Device Activation",
    "deviceId": "Device Id",
    "deviceType": "Device type",
    "devices": "Devices",
    "diameter": "Diameter",
    "didYouKnow": "Did you know?",
    "digitalAllOnX": "Digital All-On-X",
    "directPrint": "Direct Print",
    "directPrintAvailable": "Direct print available",
    "directToMUA": "Direct to MUA",
    "disabled": "Disabled",
    "discardChanges": "Discard Changes",
    "disconnect": "Disconnect",
    "discount": "Discount",
    "discountType": "Discount type",
    "discounted": "Discounted",
    "discountedItems": "Discounted Items",
    "discountedItemsDuration": "Discounted items duration",
    "discoverNeerRewardStatus": "Discover Neer reward statuses",
    "dislikeInputPlaceholder": "Help us deliver a better experience",
    "dismiss": "Dismiss",
    "displayingFiles": "Displaying Files",
    "ditchedModel": "Ditched Model",
    "divers": "Divers",
    "doNotPlaceAttachmentsOnTheFollowingTeeth": "DO not place attachments on the following teeth",
    "doctor": "Doctor",
    "doctorPreference": "Doctor preference",
    "doctorRevenue": "Doctor Revenue",
    "doctors": "Doctors",
    "done": "Done",
    "doNotShowThisAgain": "Do not show this again",
    "doNotCancel": "Do not Cancel",
    "dontSave": "Don't Save",
    "didntReceiveTheEmail": "Didn’t receive the email?",
    "dontShowAgain": "Don't Show Again",
    "download": "Download",
    "downloadAll": "Download all",
    "downloadScans": "Download scans",
    "downloadUrl": "Download Url",
    "downloading": "Downloading",
    "downloadFiles": "Download Files",
    "draft": "Draft",
    "dragAndDropFilesHere": "Drag & Drop files here",
    "dragAndDropFilesHereOr": "Drag and drop files here or",
    "dragAndDropFilesHereOrImport": "Drag and drop files here or import them from:",
    "dragAndDropScanUpload": "<span style=\"color: #0077c7;\">Browse</span> files or drag and drop",
    "dragToPan": "and drag to pan",
    "dragToRotate": "and drag to rotate",
    "dsoRegion": "Organization region",
    "duplicate": "Duplicate",
    "duplicateDenture": "Duplicate Denture",
    "duplicateModel": "Duplicate Model",
    "dynamicPassword": "Dynamic Password",
    "dynamicSecurityKey": "Dynamic Security Key",
    "earlierThisMonth": "Earlier this month",
    "earlierThisWeek": "Earlier this week",
    "earlierThisYear": "Earlier this year",
    "earlyAccess": "Early Access",
    "edit": "Edit",
    "editACopy": "Edit a Copy",
    "editCampaign": "Edit Campaign",
    "editClinic": "Edit Clinic",
    "editFeedback": "Edit Feedback",
    "editNotifications": "Edit Notifications",
    "editInRWC": "Edit in RayWare",
    "editLab": "Edit Lab",
    "editPatient": "Edit Patient",
    "editPatientName": "Edit patient name",
    "editPatientInfo": "Edit patient",
    "editPrivacyPreference": "Edit Privacy Preference",
    "editProfile": "Edit Profile",
    "editPaymentMethod": "Edit payment method",
    "editedOn": "Edited on",
    "editing": "Editing",
    "email": "Email",
    "emailAddress": "Email Address",
    "emailConfirmed": "Email Confirmed",
    "emboss": "Emboss",
    "enabled": "Enabled",
    "end": "End",
    "endDate": "End Date",
    "endTime": "End Time",
    "ended": "Ended",
    "endingDay": "Ending day",
    "endingIn": "ending in",
    "endingMonth": "Ending month",
    "endodontics": "Endodontics",
    "endodontist": "Endodontist",
    "enhanced": "Allure DS3 Real View Library (Enhanced)",
    "enhancedAsTitle": "Enhanced",
    "enhancedDesignStyle": "Enhanced Design Style",
    "enter": "Enter",
    "enterAbutmentType": "Enter abutment type",
    "enterActivationCode": "Enter Activation Code",
    "enterBrand": "Enter brand",
    "enterDetails": "Enter Details",
    "enterJobName": "Enter job name",
    "enterNotes": "Enter your notes here.",
    "enterPartNumber": "Enter part number",
    "enterPersonalInformation": "Enter Personal Information",
    "enterPromoCode": "Enter promo code",
    "enterToothLibrary": "Enter Tooth Library",
    "enterTreatmentDetails": "Enter Treatment Details",
    "enterYourOnetimeCode": "Enter your one-time code",
    "equipmentInformationMayBeOutdated": "Equipment information may be outdated",
    "error": "Error",
    "error-occurred": "An unexpected error occurred",
    "errorCode": "Error Code:",
    "estheticCosmetic": "Esthetic/Cosmetic",
    "estimatedCompletion": "Estimated completion:",
    "estimateDelivery": "Est. delivery",
    "estimatedTurnaroundTime": "Estimated turnaround time",
    "event": "Event",
    "events": "Events",
    "everyMonth": "Every month",
    "exJane": "ex. Jane",
    "exactReplica": "Exact Replica",
    "exactReplicaOrImproved": "Looking for an exact replica or improved?",
    "examplePlaceholder": "Ex. JD",
    "exitIndividualSupportMode": "Exit Individual support mode",
    "exitPreviewMode": "Exit Preview Mode",
    "exitSelectBase": "Exit Select Base",
    "expert": "Expert",
    "expertGuidanceRequired": "Expert guidance required",
    "expirationDate": "Expiration date (MM/YY)",
    "expired": "Expired",
    "expires": "Expires",
    "explanation": "Explanation",
    "export": "Export",
    "exportMonthlyTreatmentsToCSV": "Export Monthly Treatments To CSV",
    "exportMyData": "Export your data",
    "exportPatientData": "Export patient data",
    "exportSTL": "Export STL",
    "exportToCSV": "Export To CSV",
    "ext": "Ext",
    "extendPapillaDownToInterproximalContact": "Extend papilla ⅔ down to interproximal contact",
    "external": "External",
    "externalLogin": "External Login",
    "fabricationMethod": "Fabrication Method",
    "fabricated&Shipped": "Fabricated & Shipped",
    "fabrication&Shipping": "Fabrication & Shipping",
    "facilityNumber": "Facility Number",
    "factory": "Factory",
    "failedToUploading": "Failed to uploading",
    "faq": "FAQ",
    "fastestPrint": "Fastest Print",
    "feedback": "Feedback",
    "female": "Female",
    "feminine": "Feminine",
    "field": "The field",
    "file": "File",
    "fileAssignment": "File Assignment",
    "fileAttached": "File Attached",
    "fileDeleted": "File {{filename}} deleted",
    "fileHistory": "File History",
    "fileList": "File List",
    "fileMoved": "File moved",
    "fileName": "File Name",
    "fileNotSuitable": "File not suitable?",
    "fileSize": "File Size",
    "fileType": "File Type",
    "file_s": "File(s)",
    "files": "Files",
    "filesAdded": "files added",
    "filesApproved": "Files Approved",
    "filesAttached": "Files Attached",
    "filesDeleted": "{{count}} files deleted",
    "filesSentOn": "Files sent on",
    "filesSelected": "Files Selected",
    "filesUnassigned": "{{count}} files have been removed",
    "filesUploaded": "Files uploaded",
    "fillCommentsTags": "Please add any additional comments and notes relevant to the treatment",
    "filter": "Filter",
    "filterCategory": "Filter by Category",
    "filterStatus": "Filter by Status",
    "filterTreatment": "Filter by Treatment",
    "find": "Find",
    "finish": "finish",
    "finishAndCloseJob": "Finish and close job",
    "finishCancellation": "Finish Cancellation",
    "finishJob": "Finish",
    "viewOnMap": "View on map",
    "finishTreatment": "Finish Treatment",
    "finished": "Finished",
    "first": "First",
    "firstName": "First Name",
    "firstRevision": "First Revision",
    "firstPrint": "First Print",
    "firstPrintOnMidas": "Your First Print on Midas",
    "fitOffset": "Fit Offset",
    "fitOffsetMicrons": "Fit Offset (Microns)",
    "fitment": "Fitment",
    "fixedRestorations": "Fixed Restorations",
    "flat": "Flat",
    "flatContour": "Flat",
    "contoured": "Contoured",
    "rounded": "Rounded",
    "smooth": "Smooth",
    "square": "Square",
    "textured": "Textured",
    "triangular": "Triangular",
    "flatPlane": "Flat Plane",
    "flatOcclusalGuard": "Flat Occlusal Guard",
    "fleetManagement": "Fleet Management",
    "folder": "Folder",
    "folderName": "Folder name",
    "folders": "Folders",
    "followAnatomyFollowPalatineSuture": "Follow Anatomy (Follow palatine suture)",
    "followAnatomyMiddleOfCupidSBow": "Follow Anatomy (middle of cupid’s bow)",
    "followPreOpInDesign": "Follow Pre-Op In Design?",
    "followReferenceDenture": "Follow reference denture",
    "followSubmittedReferenceDentureOrSWaxTryIn": "Follow submitted reference denture or s/wax try-in",
    "for": "for",
    "forFirst3Months": "for the first 3 months",
    "forTeeth": "For teeth No.",
    "forTooth": "For tooth No.",
    "forcedUpdate": "Forced update",
    "forgotYourPassword": "Forgot password?",
    "free": "Free",
    "freeTrial": "free trial",
    "freeDesign": "Free design",
    "freeDesignsPerMonth": "free designs/month",
    "freeFlow": "Free Flow",
    "freeItems": "Free items",
    "freeItemsDuration": "Free items duration",
    "frenumRelief": "Frenum relief",
    "frequentlyAskedQuestions": "Frequently asked questions",
    "friendlyName": "Friendly Name",
    "from": "from",
    "fromAi": "From AI",
    "fromCloudDrive": "From Cloud Drive",
    "fromComputer": "From Computer",
    "fromDate": "From Date",
    "fromInbox": "From Inbox",
    "frontFace": "Front Face",
    "frontSmile": "Front Smile",
    "frontTeeth": "Front Teeth",
    "full": "Full",
    "fullCoverage": "Full Coverage",
    "fullFrenumRelief": "Full Frenum Relief",
    "fullname": "Full Name",
    "fullPrice": "Full price",
    "fullyGuided": "Fully Guided",
    "future": "future",
    "futurePlan": "Future plan",
    "gender": "Gender",
    "general": "General",
    "generalDentistry": "General Dentistry",
    "generalFolderDescription": "All unassigned files",
    "generalInfo": "General info",
    "generalPractitioner": "General Practitioner",
    "generate": "Generate",
    "generateBiReport": "Generate BI Report",
    "generatePassword": "Auto-generate password",
    "generatePromoCodes": "Generate promo codes",
    "generateStandingBase": "Generate Standing Base",
    "generateSupportsOnModels": "Generate Supports on Models",
    "generatingSupports": "Generating supports",
    "generatingSupportsStructure": "Generating Support Structure",
    "getCases": "Get cases",
    "getStarted": "Get Started",
    "getSubscription": "Get Subscription",
    "gingivalCoverage": "Gingival Coverage",
    "gingivalEdge": "Gingival Edge",
    "getUnlimitedAI": "Get Unlimited AI",
    "gingivaStippling": "Gingiva Stippling",
    "gingivalFestooning": "Gingival festooning",
    "giveFeedback": "Give Feedback",
    "giveUsFeedback": "Give us Feedback",
    "goBack": "Go Back",
    "goHome": "Go Home",
    "goToFiles": "Go to files",
    "goToInbox": "Go To Inbox",
    "goToPatientFiles": "Go to Patient Files",
    "goToPaymentSettings": "Go To Payment Setting",
    "goToRedraft": "Go To Redraft",
    "goldenProportions": "Golden Proportions",
    "good": "Good",
    "gotItHideThis": "Got it, hide this",
    "graphs": "Graphs",
    "gridPlatform": "Grid Platform",
    "gridView": "Grid View",
    "group": "Group",
    "groupBy": "Group By",
    "groupDevices": "Group Devices",
    "groupName": "Group Name",
    "groups": "Groups",
    "guardType": "Guard Type",
    "guideOffset": "Guide Offset",
    "guideType": "Guide Type",
    "guidedSurgeryKitBrand": "Guided Surgery Kit Brand",
    "halfCoverage": "Half Coverage",
    "handling": "Handling",
    "hasBeenApplied": "has been applied!",
    "hasTemplate": "Has Template",
    "help": "Help",
    "here": "here",
    "hide": "hide",
    "hidden": "hidden",
    "hideAdvancedSettings": "Hide Advanced Settings",
    "hideOptionalFields": "Hide optional fields",
    "hideDevice": "Hide Device",
    "high": "High",
    "hinge": "Hinge",
    "hollow": "Hollow",
    "hollywood": "Culp Mature Library (Hollywood)",
    "hollywoodAsTitle": "Hollywood",
    "hollywoodDesignStyle": "Hollywood Design Style",
    "home": "Home",
    "hour": "hour",
    "hours": "hours",
    "howAreTheDesigns": "How are the designs?",
    "howCanWeImprove": "How can we improve?",
    "howPleasedWereYouWithTheDesigner": "How pleased were you with the designer?",
    "howPleasedWereYouWithTheDesigns": "How pleased were you with the designs?",
    "howPleasedWereYouWithThePrintedAppliance": "How pleased were you with the printed appliance?",
    "howToSignIn": "How to Sign In",
    "howToUse": "How to Use",
    "howWouldYouLikeTheNewTreatmentPlanSetUp": "How would you like the new treatment plan set up?",
    "hybrid": "Hybrid",
    "hybridDenture": "Hybrid Denture",
    "hybridDentures": "Hybrid Dentures - Same Day by Appointment",
    "iAgree": "I agree to use the credit card above for current and future charges",
    "iAgreeToThe": "I agree to the",
    "iTeroScannerTipsForAiNg": "If you are using an iTero scanner, re-export your scans from the scanner software, selecting the ‘file per arch (arches in occlusion)‘ in the export settings.",
    "iTeroScannerTipsVideoTitle": "How to Re-Export iTero Scans",
    "iTeroScannerVideoTime": "Video • 2 min",
    "iWouldNotLikeAnyIPROnTheFollowingTeeth": "I would not like any IPR on the following teeth:",
    "id": "Id",
    "ignore": "ignore",
    "immediateDenture": "Immediate Denture",
    "implantBrand": "Implant Brand",
    "implantCrown": "Implant Crown",
    "implantDiameter": "Implant Diameter",
    "implantDimensions": "Implant Dimensions",
    "implantLength": "Implant Length",
    "implantModel": "Implant Model",
    "implantModelName": "Implant Model Name",
    "implantModels": "Implant Models",
    "implantSurgery": "Implant Surgery",
    "import": "Import",
    "importFailed": "Import Failed",
    "importFiles": "Import Files",
    "importFilesToPrintJob": "Import files to print job",
    "importFromCloudDrive": "Import from Cloud Drive",
    "importFromComputer": "Import from Computer",
    "importSavedPrintJobSpr": "Import Saved Print Job (SPR)",
    "importSucceeded": "Import Succeeded",
    "importantDatesMessage": "Please let us know if there are any particular deadlines or important dates pertaining to this treatment",
    "imported": "Imported",
    "importedSupports": "Imported Supports",
    "importing": "Importing",
    "improve": "Improve",
    "improved": "Improved",
    "inProgress": "In progress",
    "designed": "Designed",
    "designing": "Designing",
    "inactive": "Inactive",
    "inbox": "Inbox",
    "includePalate": "Include palate",
    "incompatiblePrinters": "Incompatible Printers",
    "incompleteRequests": "Incomplete Requests",
    "incompleted": "Incompleted",
    "index": "Index",
    "indicateSpecialPreference": "Indicate any special preference for the pressure relieved areas of the design.",
    "indicatedMaterials": "Indicated Materials",
    "indications": "Indications",
    "info": "Info",
    "information": "Information",
    "infoAndSettings": "Info & Settings",
    "infoAndTreatment": "Info & Treatment",
    "initial": "Initial",
    "inlay": "Inlay",
    "inlayAndOnlay": "Inlay & Onlay",
    "inlayOrOnlay": "Inlay / Onlay",
    "inputDiameterManually": "Input implant diameter manually",
    "inputField": "Input Field",
    "inputLengthManually": "Input implant length manually",
    "insights": "Insights",
    "installed": "Installed",
    "installNow": "Install Now",
    "instructions": "Instructions",
    "integration": "Integration",
    "integrationAuthUrl": "Learn How to Setup",
    "integrations": "Integrations",
    "integrationsFolderDescription": "Files sent from your scanners",
    "integrationsSetting": "Integration Settings",
    "intense": "Intense",
    "interfaceDesign": "Interface Design",
    "internal": "Internal",
    "intermediate": "Intermediate",
    "invoicePdfFormat": "Invoice in pdf format",
    "invoiceReceipt": "Invoice/Receipt",
    "ipr": "IPR:",
    "iprAsNeeded": "IPR as needed",
    "isForcedUpdate": "Is forced update?",
    "isRevisionRequest": "Is Revision Request",
    "issuesWithThisDesign": "Issues with this design?",
    "item": "Item",
    "items": "items",
    "jaw": "Jaw",
    "jobName": "Job name",
    "jobs": "Jobs",
    "jobSentToQueue": "Job Sent To Queue",
    "justNow": "Just Now",
    "keepEditing": "Keep Editing",
    "keyboardShortcuts": "Keyboard Shortcuts",
    "fullCoverageAnteriorDeprogrammer": "Full Coverage Anterior Deprogrammer",
    "funPrintFile": "Fun Print File",
    "verifyYourCloudAccount": "Verify Your Cloud Account",
    "verifyEmail": "Verify Email",
    "lab": "Lab",
    "labAdmin": "Lab Admin",
    "labId": "Lab ID",
    "labServices": "Lab Services",
    "label": "Label",
    "labelImprint": "Label Imprint",
    "labelManagement": "Label Management",
    "labelName": "Label Name",
    "labels": "Labels",
    "labs": "Labs",
    "language": "Language",
    "lastActive": "Last Active",
    "lastAdded": "Last Added",
    "lastDetectedEquipment": "Last detected equipment",
    "lastJob": "Last Job",
    "lastLoginDate": "Last Login Date",
    "lastModified": "Last Modified",
    "lastMonth": "Last Month",
    "lastName": "Last Name",
    "lastSeen": "Last seen ",
    "lastSubmitted": "Last Submitted",
    "lastUpdate": "Last Update",
    "lastUpdated": "Last Updated",
    "lastWeek": "Last Week",
    "lastYear": "Last Year",
    "lastUpdatedAt": "Last updated at",
    "latestReleaseNotes": "Latest Release Notes",
    "latestVersion": "Latest Version",
    "lateralIncisorLength": "Lateral incisors 0.5mm shorter",
    "layerThickness": "Layer Thickness",
    "layerThicknessMicrons": "Layer Thickness (Microns)",
    "layout": "Layout",
    "learnMore": "Learn More",
    "leastProcessing": "Least Processing",
    "leavePage": "Leave Page?",
    "leaveSpacesOpenDistalToCanines": "Leave spaces open distal to canines",
    "leaveSpacesOpenDistalToLaterals": "Leave spaces open distal to laterals",
    "left": "Left",
    "leftClick": "Left Click",
    "leftClickAndDragToRotateCamera": "Left Click and Drag to rotate camera",
    "leftSide": "Left side",
    "leftSideFace": "Left side face",
    "leftSideTeeth": "Left Side Teeth",
    "legacy": "Legacy",
    "length": "Length",
    "lessTight": "Less Tight",
    "level": "Level",
    "licenseCertificate": "License Certificate",
    "licenseNumber": "License Number",
    "licenseStates": "License States",
    "licenseValidityStart": "License Validity Start",
    "licenseValidityEnd": "License Validity End",
    "lifetime": "lifetime",
    "liabilityWaiver": "Liability Waiver",
    "library": "Library",
    "libraryFolderDescription": "SprintRay community files",
    "light": "Light",
    "limitCharacters": "Limit {{maxLength}} characters.",
    "limitedTimePromoPricing": "Limited Time Promotional Pricing",
    "lineCut": "Line Cut",
    "link": "Link",
    "linkTeeth": "Link teeth",
    "listView": "List View",
    "livePrintMonitoring": "Live Print Monitoring",
    "loadData": "Load Data",
    "loadMore": "Load More",
    "loading": "Loading",
    "localFiles": "Local Files",
    "localProviderName": "Local",
    "location": "Location",
    "locationManagement": "Location Management",
    "locations": "Locations",
    "login": "Login",
    "logout": "Log out",
    "lookingForPrinters": "Looking for printers...",
    "loose": "Loose",
    "looser": "Looser",
    "looserFit": "Looser Fit",
    "lower": "Lower",
    "lowerArch": "Lower Arch",
    "lowerEsthetic": "Lower esthetic",
    "lowerJaw": "Lower Jaw",
    "lowerRange": "Not likely.",
    "lowerScan": "Lower Scan",
    "lowerTissueScan": "Lower Tissue Scan",
    "maintain": "Maintain",
    "maintainMayRequireIPR": "Maintain (may require IPR)",
    "makeFinishingImprovementsToTheCurrentToothPosition": "Make finishing improvements to the current tooth position",
    "makeThisJobPrintableWithASingleClick": "Make this job printable with a single click",
    "male": "Male",
    "manageAccount": "Manage Account",
    "manageApplianceTypes": "Manage Appliance Types",
    "manageCreditCards": "Manage Credit Cards",
    "manageDeviceGroups": "Manage Device Groups",
    "manageIndications": "Manage Indications",
    "manageSubscription": "Manage subscription",
    "mandibular": "Mandibular",
    "mandibularBorder": "Mandibular border",
    "mandibularScan": "Mandibular scan",
    "manualDesign": "Manual Design",
    "manualDesignRequested": "Manual Design requested",
    "manualInput": "Manual input",
    "margin": "Margin",
    "markAsClosed": "Mark As Closed",
    "markAsInternal": "Mark As Internal",
    "markAsRead": "Mark as read",
    "markAsUnread": "Mark as unread",
    "markForReview": "Mark for Review",
    "markTreatmentDone": "Mark Treatment as Done",
    "markedTeeth": "Marked Teeth",
    "marylandBridge": "Maryland Bridge",
    "masculine": "Masculine",
    "masterDashboard": "Master Dashboard",
    "material": "Material",
    "materialSelection": "Material Selection",
    "materialUsage": "Material Usage",
    "materialUsageAnalytics": "Material Usage Analytics",
    "materialUsageAndPrinterStatistics": "Material usage and printer statistics",
    "materialVolumeRequired": "Material volume required",
    "materials": "Materials",
    "mature": "Vita Physiodens T2S RealView (Mature)",
    "matureAsTitle": "Mature",
    "matureCuspsMoreWorn": "Mature (cusps more worn)",
    "matureDesignStyle": "Mature Design Style",
    "max": "Max",
    "maxCapacity": "Max Capacity",
    "maxDensity": "Max Density",
    "maxFileSizeUpload": "Maximum upload file size: 100mb.",
    "maxFilesNumberTip1": "Won't allow more than",
    "maxFilesNumberTip2": "models in one upload",
    "maxStrength": "Max Strength",
    "maxUploadCrownAndBridgeFilesNumberTips": "Max upload Crown & Bridge number is 3 for midas, please remove others",
    "maxUploadImplantCrownFilesNumberTips": "Max upload implant crown number is 3 for midas, please remove others",
    "maxUploadVeneerFilesNumberTips": "Max upload veneer number is 9 for midas, please remove others",
    "maxillary": "Maxillary",
    "maxillaryBorder": "Maxillary border",
    "maxillaryScan": "Maxillary scan",
    "maximumAllowedImplantDimensionsWillBeUsed": "Maximum allowed implant dimensions will be used",
    "maximumFileSize": "Maximum file size:",
    "maximumTeethSelected": "Maximum Teeth Selected",
    "measurementsAreInMM": "Measurements are in mm",
    "medit": "Medit",
    "medium": "Medium",
    "megabytes": "MB",
    "membership": "Membership",
    "menu": "Menu",
    "meshEdit": "Mesh Edit",
    "meshRepair": "Mesh Repair",
    "message": "Message",
    "messagedLab": "Message sent to lab",
    "messageFromOurCEO": "Message from our CEO, Amir Mansouri ",
    "messagedReceived": "Message received",
    "messagedReceivedOrApproval": "Message received/approval",
    "methods": "Methods",
    "michiganSplint": "Michigan Splint",
    "midas": "Midas",
    "midasDiscount": "Midas discount",
    "midasConnected": "Midas connected",
    "midline": "Midline",
    "midlineAdditionalNotes": "Midline Additional Notes",
    "midlineFollowAnatomyMiddleOfCupidsBow": "Follow Anatomy - Middle of Cupid’s Bow",
    "midlineFollowAnatomyPalatineSuture": "Follow Anatomy - Palatine Suture",
    "midlineFollowCurrentMidlinePresent": "Follow Current Midline Present",
    "midlineFollowReferenceDenture": "Follow Reference Denture",
    "midlineFollowSubmittedPhotosAsReference": "Follow Submitted Photos as Reference",
    "midlineFollowWaxRimImpression": "Follow Wax Rim Impression",
    "midlines": "Midlines",
    "minCharacters": "Please, type at least {{min}} characters",
    "minute": "minute",
    "minutes": "minutes",
    "misshapenTeeth": "Misshapen Teeth",
    "missingResin": "Missing Resin",
    "missingTeeth": "Missing Teeth",
    "mm": "mm",
    "mobileNumber": "Mobile Number",
    "model": "Model",
    "modelAndRemovableDie": "Model and Removable Die",
    "modelList": "Model List",
    "models": "Models",
    "modifiedDate": "Modified Date",
    "modules": "Modules",
    "monolithicTryInDentureSpr": "Monolithic Try-In Denture (Spr)",
    "monolithicTryInDentureStl": "Monolithic Try-In Denture (Stl)",
    "month": "Month",
    "monthReport": "Month Report",
    "monthly": "monthly",
    "months": "months",
    "monthsOngoing": "Months ongoing",
    "more": "More",
    "moreInfo": "More Info",
    "moreTight": "More Tight",
    "mostUsed": "Most Used",
    "move": "Move",
    "movedFrom": "Moved from",
    "moveObjects": "Move Objects",
    "moveToADifferent": "Move to a different",
    "moveToCirclePlatform": "Move to Circle Platform",
    "moveToDifferentPlatform": "Move to Different Platform",
    "moveToSquarePlatform": "Move to Square Platform",
    "moveToTrianglePlatform": "Move to Triangle Platform",
    "movedTo": "Moved to",
    "multipleApps": "Multiple Apps",
    "multipleVersions": "Multiple Versions",
    "myPrinters": "My Printers",
    "myAccount": "My Account",
    "name": "Name",
    "nameOfCardholder": "Cardholder Name",
    "nameOnCard": "Name on card",
    "names": "Names",
    "naturalAtTheMidpointOfInterProximalContact": "Natural at the midpoint of inter-proximal contact",
    "nBackup": "{{n}} Backup",
    "needAttention": "Need Attention",
    "needHelp": "Need help?",
    "needsApproval": "Needs Approval",
    "needsAttention": "Needs Attention",
    "new": "New",
    "newAIOcclusalGuardTreatment": "New AI Occlusal Guard Treatment",
    "newCampaign": "New Campaign",
    "newDenture": "New Denture",
    "newEmail": "New Email",
    "newEmailVerificationCode": "New Email Verification Code",
    "newF": "New",
    "newJob": "New Print Job",
    "newManualTreatment": "New Manual Treatment",
    "newNote": "New note",
    "newPassword": "New Password",
    "newPatient": "New Patient",
    "newPaymentMethod": "Add new payment method",
    "newRayWare": "New RayWare",
    "newRequest": "New Request",
    "newRequests": "New Requests",
    "newTreatment": "New Treatment",
    "newOrder": "New order",
    "newPrintJob": "New Print Job",
    "next": "Next",
    "nextBill": "Next bill",
    "nextBillDate": "Next Bill Date",
    "nextBusinessDayByNoon": "Next Business Day by Noon",
    "nextStep": "Next Step",
    "nickname": "Nickname",
    "nightGuard": "Occlusal Guard",
    "nightGuardAi": "Night Guard AI",
    "nightGuardFlex": "NightGuard Flex - Blue",
    "nightGuardFlex2": "NightGuard Flex 2 - Simply Clear",
    "nightGuardFlex2OceanBlue": "NightGuard Flex 2 - Ocean Blue",
    "nightGuardStl": "Occlusal Guard (Stl)",
    "nightGuardStlWithSupports": "Occlusal Guard with Supports (Stl)",
    "nightGuardType": "Occlusal Guard type",
    "no": "No",
    "no-prepVeneers": "No-prep Neer",
    "noActivity": "No activity",
    "noActiveSubscription": "No active subscription",
    "noAddressDetails": "No address details",
    "noAttachments": "No Attachments",
    "noBackups": "No Backup",
    "noCardPaymentMethod": "No card payment method",
    "noCampaigns": "No Campaigns",
    "noDeviceRegistered": "No device registered",
    "NoDevicesYet": "No Devices Yet!",
    "noFiles": "No Files",
    "noFilesUpload": "No files uploaded",
    "noFrenumRelief": "No Frenum Relief",
    "noGroup": "No Group",
    "noIntegrations": "No Integrations",
    "noItemsInProgressOrQueue": "No jobs in progress or in queue.",
    "noJobsFound": "No Jobs Found",
    "noMoreData": "No More Data",
    "noNotifications": "No Notifications",
    "noLengthening": "No Lengthening",
    "noLicenseCertificate": "No license certificate yet.",
    "noPalate": "Do not include palate",
    "noPatientData": "No patient data",
    "noPatients": "No patients",
    "noPatientsFound": "No patients found",
    "noPatientsYet": "No patients yet!",
    "noPayments": "No payments yet",
    "noPostDam": "No Post Dam",
    "noPrinterFound": "No Printer Found!",
    "NoPrintJobsYet": "No Print Jobs Yet!",
    "noPrintersFound": "No Printers Found",
    "noPromoCodes": "No promo codes",
    "noRecentActivity": "No Recent Activity",
    "noResultsFoundInYourPatientsOrFiles": "No results found in your patients or files",
    "noResultsSubtitle": "Try changing your search terms or use the filters to browse by category.",
    "noResultsTitle": "No results found",
    "noResults": "No Results",
    "noRevenue": "noRevenue",
    "noTreatments": "No treatments",
    "noReleaseNotes": "No release notes yet.",
    "noTreatmentsFound": "No treatments found",
    "noTreatmentsYet": "No treatments yet",
    "noms": "Nomenclatures",
    "none": "None",
    "noneOfTheAbove": "None of the above",
    "normal": "Normal",
    "normalOcclusion": "Normal occlusion",
    "notAvailable": "N/A",
    "notCompleted": "Not Completed",
    "notEnoughSpace": "Not enough space",
    "notProvided": "Not Provided",
    "notSaved": "Not saved",
    "notSupported": "Not supported",
    "note": "Note",
    "notes": "Purpose of Treatment",
    "notesForClinicalConditions": "Additional Notes",
    "notesForMidlines": "Notes For Midlines:",
    "notesToDesigner": "Notes to designer",
    "notification": "Notification",
    "notificationCenter": "Notification Center",
    "notificationType": "Notification Type",
    "notifications": "Notifications",
    "notify": "Notify",
    "notifyCount": "Notify Count",
    "notifyDashboard": "Notify Dashboard",
    "notifyPrintOS": "Notify PrintOS",
    "notifyRayWare": "Notify RayWare",
    "notifyUntil": "Notify Until",
    "npi": "NPI",
    "number": "Number",
    "numberOfCases": "Number Of Cases",
    "numberOfRevisions": "Number Of Revisions",
    "onboardingVideos": "Onboarding Videos",
    "onOrdersAndAddOnProducts": "on orders and add-on products",
    "occlusalDistance": "Occlusal Distance",
    "occlusalGuard": "Occlusal Guard",
    "occlusalGuardAnterior": "Occlusal Guard with Anterior Ramp",
    "occlusalGuardDesign": "Occlusal Guard Design",
    "occlusalGuardNoAnterior": "Without Anterior Coverage",
    "occlusalGuardWithAnteriorRamp1": "Buccal Raised Anterior Ramp",
    "occlusalGuardWithAnteriorRamp2": "Lingual Raised Anterior Ramp",
    "occlusalGuardWithoutAnteriorCoverage": "Occlusal Guard Without Anterior Coverage",
    "occlusalPlaneSmoothness": "Occlusal Surface",
    "occlusalStyle": "Occlusal Style",
    "occlusalThickness": "Occlusal Thickness",
    "occlusalThicknessAdjustment": "Occlusal Thickness Adjustment",
    "occlusion": "Occlusion",
    "occlusionClass": "Occlusion Class",
    "occlusionClassAdditionalNotes": "Occlusion Class Additional Notes",
    "occlusionClassClassOneBite": "Class One Bite",
    "occlusionClassClassThreeUnderbite": "Class Three Underbite",
    "occlusionClassClassThreeUnderbiteWithEdgeToEdgeOcclusion": "Class Three Underbite with Edge to Edge Occlusion",
    "occlusionClassClassTwoOverbite": "Class Two Overbite",
    "occlusionDistance": "Occlusion Distance",
    "occlusionStyle": "Occlusion Style",
    "of": "of",
    "off": "Off",
    "officeClinic": "Office/Clinic",
    "officialName": "Official Name",
    "officePhoneNumber": "Office Phone Number",
    "officialVersion": "Official Version",
    "offline": "Offline",
    "offset": "Offset",
    "ok": "OK",
    "okay": "Okay",
    "old": "Old",
    "oldPassword": "Old password",
    "older": "Older",
    "on": "On",
    "onHold": "On Hold",
    "onOurWebsite": "on our website.",
    "onceYouOrder": "Once you order a treatment it will show up here.",
    "onceYouStart": "Once you start adding patients and treatments, you’ll be able to see them here.",
    "oneBackup": "1 Backup",
    "oneCentralOverlapsOtherCentral": "One central overlaps other central",
    "oneLateralMesiallyRotatedAndTuckedBehindCentrals": "One lateral mesially rotated and tucked behind centrals",
    "onlineNow": "Online Now",
    "oneTime": "One time",
    "oneTimeUse": "One time use",
    "oneYear": "1 Year",
    "oneYearFree": "1 year free",
    "onlay": "Onlay",
    "only": "Only",
    "onlyCompatibleWithProSPrinters": "Only compatible with Pro S printers",
    "onlyForProd": "This Page is the Production Environment Status",
    "open": "Open",
    "openBite": "Open Bite",
    "openBiteScansTitle": "Open Bite Scans",
    "openCertifiedResins": "Open Certified Resins",
    "openInNewTab": "Open in New Tab",
    "optFor": "Opt for",
    "optMarketingUpdates": "Marketing Updates",
    "optProductUpdates": "Product Updates",
    "optimizingLayout": "Optimizing layout",
    "optimizingOrientation": "Optimizing Orientation",
    "optional": "Optional",
    "optionalTips": "(optional)",
    "optionalSupportingImages": "Optional supporting images",
    "optPublicProfile": "Opt-in for Public Profile",
    "optSmsPromotionUpdates": "SMS Promotions Updates",
    "optSmsCaseUpdates": "SMS Case Updates",
    "or": "or",
    "oralSurgeon": "Oral Surgeon",
    "oralSurgery": "Oral Surgery",
    "order": "Order",
    "ordered": "Ordered",
    "orderId": "Order ID",
    "orderPreferences": "Order preferences",
    "orders": "Orders",
    "orderShipped": "Case Update",
    "shipmentFabricationStarted": "We have started the fabrication of your case.",
    "shipmentTrackingAvailable": "Your case is on the way. You can track your shipment using the link below.",
    "orgAdmin": "Org Admin",
    "organization": "Organization",
    "orientation": "Orientation",
    "orientationPreferences": "Orientation Preferences",
    "orientingModels": "Orienting Models",
    "orthodontics": "Orthodontics",
    "orthodontist": "Orthodontist",
    "other": "Other",
    "otherMaterials": "Other Materials",
    "otherPrint": "Other Print",
    "otherProviders": "Other providers",
    "others": "Others",
    "outOf": "out of",
    "overbite": "Overbite",
    "overbiteAndOverjet": "Overbite And Overjet",
    "overdentureCase": "Overdenture Case",
    "overjet": "Overjet",
    "overtime": "Overtime",
    "owner": "Owner",
    "ownerDescription": "Owner description",
    "ownerEmail": "Owner email",
    "pack": "Pack",
    "pacificTime": "Pacific Time",
    "pageNotFound": "Page not found!",
    "paid": "Paid",
    "palate": "Palate",
    "panScrollHorizontally": "Pan to scroll horizontally",
    "panoXRayJpgJpegPng": "PANO X-RAY (JPG/JPEG/PNG)",
    "papilla": "Papilla",
    "parseLogFile": "Parse Log File",
    "partNumber": "Part Number",
    "password": "Password",
    "passwordConfirmed": "Password Confirmed",
    "passwordLength": "Password Length",
    "passwordReset": "Password reset successfully.",
    "pasteAnyLinkHere": "Paste any link here",
    "patentTreatmentName": "Patient name and treatment",
    "patient": "Patient",
    "patientAdded": "Patient Added",
    "patientAgeRange": "Patient Age Range:",
    "patientCreated": "New Patient created successfully",
    "patientDesiredResult": "Patient Desired Result",
    "patientDetailsSaved": "Patient details saved",
    "patientEmails": "Patients emails",
    "patientFiles": "Patient Files",
    "patientId": "Patient ID",
    "patientName": "Patient Name",
    "patientPhoto": "Patient Photo",
    "patientPhotos": "Patient Photos",
    "patientPhotosOptional": "Patient photos (optional)",
    "pictureOfPatientSmiling": "Picture of patient smiling",
    "momentDirectPatient": "Moment Direct Patient",
    "patientPresentingEdentulous": "Is the Patient Presenting Edentulous?",
    "patientRecords": "Patient Records *",
    "patientRecordsAndFiles": "Patient Records and Files",
    "patientSChiefComplaint": "Goal of Treatment",
    "patientSince": "Patient since",
    "patientUpdated": "Patient Updated",
    "patientsAndTreatments": "Patients & Treatments",
    "patientsFolderDescription": "Files assigned to your patients",
    "patientInfo": "Patient info",
    "pause": "Pause",
    "pauseSync": "Pause Sync",
    "pauseSyncQuestion": "Pause sync?",
    "payAsYouGo": "Pay as you go",
    "payment": "Payment",
    "paymentManagement": "Payment Management",
    "paymentAndPlans": "Payment and plans",
    "paypal": "PayPal",
    "perAdditionalDesign": "per additional design",
    "perArch": "Per Arch",
    "perMonth": "per month",
    "perTooth": "Per Tooth",
    "perUnit": "per unit",
    "perTreatment": "Per Treatment",
    "perYear": "per year",
    "period": "Period",
    "periodontics": "Periodontics",
    "periodontist": "Periodontist",
    "permissions": "Permissions",
    "permissionsTo": "Permissions to",
    "personal": "Personal data",
    "personalInformation": "Personal Information",
    "phone": "Phone",
    "phoneNumber": "Phone Number",
    "phones": "Phones",
    "photoBracketRemoval": "Photo of Bracket Removal Treatment",
    "photoSmileDesign": "Photo of Smile Design Treatment",
    "photogrammetryData": "Photogrammetry Data",
    "pilotGuided": "Pilot Guided",
    "placeAttachmentsAsNeeded": "Place attachments as needed",
    "placeLabel": "Place Label",
    "plan": "Plan",
    "planChange": "Plan change",
    "planUsage": "Plan usage",
    "planeCut": "Plane Cut",
    "platform": "Platform",
    "platformJobsSelectModalTitle": "Select a Job For {{applianceType}} {{targetName}}",
    "platformSetup": "Platform Setup",
    "platformType": "Platform Type",
    "platforms": "platforms",
    "pleaseProvideExplanation": "Please Provide Explanation",
    "pleaseUploadPicturesOfPatientSmiling": "Please upload pictures of patient smiling",
    "pleaseUploadScansThatIncludeThePreppedToothTeethTakenAfterPrepIsCompletedIfThePreppedToothTeethAreNotInTheScan": "Please upload scans that include the prepped tooth/teeth taken after prep is completed. If the prepped tooth/teeth are not in the scan, we will not be able to complete the design.",
    "points": "Points",
    "pontic": "Pontic",
    "ponticSites": "Pontic sites",
    "ponticSpr": "Pontic (Spr)",
    "ponticStl": "Pontic (Stl)",
    "pontics": "Pontics",
    "position": "Position",
    "positions": "Positions",
    "post": "Post",
    "pointsSelected": "Points Selected:",
    "portalReleaseNotes": "Portal Release Notes",
    "postDam": "Post dam",
    "posteriorBar": "Posterior Bar",
    "posterirCrown": "Posterior Crown",
    "postPrepLowerScan": "Post-Prep Lower Scan",
    "postPrepScansTitle": "Upload Post-prep Scans",
    "postPrepUpperScan": "Post-Prep Upper Scan",
    "postProcessing": "Post-processing",
    "postalCode": "Postal code",
    "powerball": "Powerball",
    "practice": "Practice",
    "practiceName": "Practice Name",
    "practiceInfo": "Practice info",
    "practiceManagement": "Practice Management",
    "practiceLeads": "Patient Leads",
    "preferenceSetting": "Preference Setting",
    "preferredSleeve": "Preferred Sleeve Brand",
    "prepaid": "Prepaid",
    "preparePrint": "Prepare Print",
    "preparefilesAppointment": "Prepare Files for Appointment",
    "preppedVeneers": "Prepped Neer",
    "presentingEdentulous": "Presenting Edentulous",
    "presentEmail": "Present email",
    "preview": "Preview",
    "previous": "Previous",
    "price": "Price",
    "pricePerTooth": "Price per tooth",
    "primary": "Primary",
    "fabrication&shipping": "Fabrication & Shipping",
    "fabrication&print": "Fabrication & Print",
    "print": "Print",
    "print&Ship": "Print & ship",
    "printAndShip": "Print and Ship",
    "printHistory": "Print History",
    "printJob": "Print Job",
    "printJobAndMaterial": "Print Job & Material",
    "printJobAssignedTo": "Print job assigned to",
    "printJobEmails": "Print Job emails",
    "printJobFinished": "Print Job Finished",
    "printJobPause": "Print Job Pause",
    "printJobCancel": "Print Job Cancel",
    "printJobName": "Print job name",
    "printJobSent": "Print Job Sent",
    "printJobStarting": "Print Job Starting",
    "printJobSuccessfullySend": "This job was successfully sliced and sent to your 3D printer.",
    "printJobSuccessfullySentToPrint": "Print Job Successfully Sent to Print",
    "printJobType": "Print Job Type",
    "printJobs": "Print jobs",
    "printjobUnassigned": "Print job unassigned",
    "printList": "Print List",
    "printListEmpty": "Print list is empty",
    "printMonitoring": "Print monitoring",
    "printNow": "Print Now",
    "printPlate": "Print Plate",
    "printProfile": "Print Profile",
    "printReadinessChecklist": "Print Readiness Check",
    "printSettings": "Print Settings",
    "printSetup": "Print Setup",
    "printThisJob": "Print This Job",
    "printTime": "Print time",
    "printTurnaroundTime": "Print Turnaround Time",
    "printability": "Printability",
    "printer": "Printer",
    "printerList": "Printer list",
    "printerStatus": "3D Printer Status",
    "printerStatusAvailable": "Available",
    "printerStatusBusy": "Busy",
    "printerStatusIncompatible": "Incompatible",
    "printerStatusOffline": "Offline",
    "printerStatusSleeping": "Sleeping",
    "printerType": "Printer Type",
    "printers": "Printers",
    "printerMaintenance": "Printer Maintenance",
    "printing": "Printing",
    "printingNow": "Printing Now",
    "printCompletedProgress": "{{progress}} Prints Completed",
    "printJobSentToQueue": "Print Job Sent to Queue",
    "priority": "Priority",
    "privacyAndTerms": "Privacy and Terms",
    "privacyConditions": "Privacy Conditions",
    "privacyPolicy": "Privacy Policy",
    "privacyPreference": "Privacy Preference",
    "privacyStatement": "Privacy Statement",
    "pro": "Pro",
    "proSArchKit": "Pro S Arch Kit",
    "proSCrownKit": "Pro S Crown Kit",
    "proSeries": "Pro Series",
    "processing": "processing",
    "proceed": "Proceed",
    "processingMesh": "Processing Mesh",
    "product": "Product",
    "profile": "Profile",
    "profileImage": "Profile Image",
    "profileManagement": "Profile Management",
    "profilePhoto": "Profile photo",
    "project": "Project",
    "projectManagement": "Project Management",
    "projects": "Projects",
    "promoCode": "Promo Code",
    "promoCodeUsage": "Promo code usage",
    "promoCodes": "Promo Codes",
    "promoCodeRequired": "Promo code required",
    "promoType": "Promo Type",
    "prosthetics": "Prosthetics",
    "prosthodontics": "Prosthodontics",
    "prosthodontist": "Prosthodontist",
    "provideJobName": "Provide Job Name",
    "provideLabelName": "Provide label name",
    "provider": "Provider",
    "public": "Public",
    "published": "Published",
    "publishedDate": "Published Date",
    "patients": "Patients",
    "printDuration": "Print Duration",
    "qualityTreatmentPlan": "A quality treatment plan depends on good scan data.",
    "quantity": "Quantity",
    "question": "Question",
    "questions": "Questions",
    "questionsCount": "Questions count",
    "queue": "Queue",
    "queueToPrinter": "Queue to Printer",
    "queued": "Queued",
    "quickPrint": "Quick Print",
    "quickActions": "Quick Actions",
    "raft": "Raft",
    "raftBaseShape": "Raft Base Shape",
    "raftSupports": "Raft Supports",
    "rate": "Rate",
    "rateScale": "Scale",
    "rateScales": "Scales",
    "ratioOfRevisionsCases": "Ratio of revisions/cases",
    "rayWare": "RayWare",
    "rayWare2": "RayWare2.0",
    "rayWareCloud": "RayWare Cloud",
    "rayWareIsDesignedForChromeAndEdge": "RayWare is Designed for Chrome and Edge",
    "rayWarePro": "RayWare Pro Access",
    "rayWareProAccount": "a RayWare Pro account",
    "rayWareTools": "RayWare Tools",
    "rewardBundle": "Reward Bundle",
    "rewardInNumberPrints": "Reward in {{number}} prints",
    "rewardRedeemed": "Reward Redeemed",
    "rewardStatus": "Reward status",
    "redeemPromoCodes": "Redeem Promo Codes",
    "redesign": "Redesign & Reorder",
    "reorder": "Reorder",
    "reOpenTreatment": "Reopen Treatment",
    "readCount": "Read Count",
    "readTheFull": " Read the full",
    "readingRate": "Reading Rate",
    "readyForPrint": "Ready For Print",
    "readyToQueue": "Ready to Queue",
    "reason": "Reason",
    "reasonForAiRevision": "Reason for AI revision",
    "reasonForCancellation": "Reason for Cancellation",
    "reasonForChargingRevisionFee": "Reason for Charging Revision Fee",
    "reasonForManualRevision": "Reason for manual revision",
    "reasonForRefinement": "Reason For Refinement:",
    "reasonForRequest": "Reason for request",
    "reasonForYourRefund": "Reason for your refund",
    "reasonForYourRevision": "Reason for your revision",
    "receipt": "Receipt",
    "recentActivities": "Recent Activities",
    "recentClinics": "Recent Clinics",
    "recentPrintJobs": "Recent Print Jobs",
    "recentlyUploaded": "Recently Uploaded",
    "recentlyUsed": "Recently used",
    "recommended": "Recommended",
    "recordStatus": "Record Status",
    "recurringMonthly": "Recurring Monthly Charges",
    "recurringYearly": "Recurring Yearly Charges",
    "redeemed": "Redeemed",
    "redeemedCodes": "Redeemed Codes",
    "referenceDenture": "Reference Denture",
    "refinement": "Refinement",
    "refresh": "Refresh",
    "refreshing": "Refreshing...",
    "refundAmount": "Refund Amount",
    "refunded": "Refunded",
    "refundRequested": "Refund Requested",
    "region": "Region",
    "regionManager": "Region Manager",
    "regions": "Regions",
    "register": "Register",
    "registerDate": "Register Date",
    "registered": "Registered",
    "registeredDate": "Registered Date",
    "registrationCompleted": "Registration Completed",
    "regular": "Regular",
    "regularAverageLevelOfDetails": "Regular (average level of detail and cusp height)",
    "regularFit": "RegularFit",
    "reject": "Reject",
    "rejectCharge": "Reject Charge",
    "rejected": "Rejected",
    "releaseNotes": "release notes",
    "relevancy": "Relevancy",
    "remaining": "Remaining",
    "remanufacture": "Remanufacture",
    "removableDentures": "Removable Dentures",
    "removableDenturesAdditionalCharge": "Additional Charge",
    "removableDenturesFrenumRelief": "Frenum Relief",
    "removableDenturesGingivalFestooning": "Gingival Festooning",
    "removableDenturesPostDam": "Post Dam",
    "removableDenturesType": "Removable Dentures Type",
    "removableDie": "Removable die",
    "removableDieModel": "Die",
    "removablePartialDenture": "Removable Partial Denture",
    "removablePartialDentureBaseSpr": "Removable Partial Denture Base (Spr)",
    "removablePartialDentureBaseStl": "Removable Partial Denture Base (Stl)",
    "removablePartialDenturePonticSpr": "Removable Partial Denture Pontic (Spr)",
    "removablePartialDenturePonticStl": "Removable Partial Denture Pontic (Stl)",
    "remove": "Remove",
    "removeCurrentImage": "Remove current image",
    "removeFromPatient": "Remove from Patient",
    "removeIntegrationQuestion": "Remove Integration?",
    "removedFromPatient": "Removed from patient",
    "renameJob": "Rename Job",
    "renewalDate": "Renewal Date",
    "renewedMonthly": "Renewed monthly",
    "reopenTreatment": "Reopen Treatment",
    "repairingModels": "Repairing Models",
    "repeatPassword": "Repeat Password",
    "reports": "Reports",
    "reprint": "Reprint",
    "reprintOf": "Reprint of",
    "request": "Request",
    "requestActions": "Request actions",
    "requestChange": "Request change",
    "requestMethod": "request method",
    "requestQuantity": "Request Quantity",
    "requestRefund": "Request Refund",
    "requestReport": "Request Report",
    "requestRevision": "Request Revision",
    "requestRevisionInfo": "Request Revision Information",
    "requestThroughput": "Request Throughput By Submitted Date",
    "requester": "Requester",
    "requestedServices": "Requested Services",
    "requiredFields": "All fields marked with an * are required.",
    "resendEmail": "Resend Email",
    "resendNotification": "Resend notification",
    "resendRegistrationVerificationEmail": "Resend Registration Verification Email",
    "resendResetPasswordEmail": "Resend Reset Password Email",
    "resendVerificationEmail": "Resend Verification Email",
    "reset": "Reset",
    "resetPassword": "Reset Password",
    "resetSize": "Reset size",
    "resin": "Resin",
    "resinVolume": "Resin volume",
    "resize": "Resize",
    "response": "Response",
    "responses": "Responses",
    "restorations": "Restorations",
    "restorationStl": "Restoration (Stl)",
    "restoreDefault": "Restore Default",
    "resubmitFiles": "Resubmit Files",
    "results": "Results",
    "resumeSync": "Resume Sync",
    "retainer": "Retainer",
    "retainOriginal": "Retain Original",
    "retention": "Retention and Tightness",
    "retromolarPadExtension": "Retromolar Pad Extension",
    "retromolarPadExtensionInTheMandible": "Retromolar pad extension in the mandible",
    "retry": "Retry",
    "retypePassword": "Re-type Password",
    "revenue": "revenue",
    "review": "Review",
    "reviewAndApproveDesign": "Review and Approve Design",
    "review&ApproveDesign": "Review & Approve Design",
    "reviewAndApproveYourDesigns": "Review & Approve Your Designs",
    "reviewAndCheckout": "Review & Checkout",
    "reviewAndSubmit": "Review & Submit",
    "reviewBeforeApproval": "Please review before approval",
    "reviewQuestions": "Review Questions",
    "viewDetails": "View details",
    "discard": "Discard",
    "viewYourCredits": "View Your Credits",
    "reviseTreatment": "Revise Treatment",
    "revisionInProgress": "Revision in Progress",
    "revisionAllowed": "Revisions Allowed",
    "revisionCanceled": "Revision canceled",
    "revisionFeeAssessed": "Revision Fee Assessed",
    "revisionFeeRequired": "Revision Fee Required",
    "revisionPolicy": "Revision Policy",
    "revisionRequested": "Revision requested",
    "revisionRequests": "Revision requests",
    "right": "Right",
    "rightBiteScan": "Right bite scan",
    "rightClick": "Right Click",
    "rightClickAndDragToPanCamera": "Right Click and Drag to pan camera",
    "rightSide": "Right side",
    "rightSideFace": "Right side face",
    "rightSideTeeth": "Right Side Teeth",
    "road": "Road",
    "role": "Role",
    "rosen": "Rosen",
    "rpd": "RPD",
    "rules": "Rules",
    "rushDesign": "Rush Design",
    "rushDesignAdditionalToothPrice": "per additional tooth",
    "rushDesignFirstToothPrice": "for the first tooth",
    "rushDesignPrice": "Rush Design Pricing:",
    "rushHours": "Rush Hours",
    "sameAsAccountAddress": "Same as account address",
    "sameDayByAppointment": "Same Day by Appointment",
    "sameLength": "Same length",
    "sampleNeerTreatmentOrder": "Neer Treatment Order Tour",
    "sampleOrderPaymentReminder": "For demo purposes, you will not be charged.",
    "sampleOrderReminder": "This is a sample",
    "sample": "Sample Neer",
    "save": "Save",
    "saveAndAssign": "Save & Assign",
    "saveAndClose": "Save & Close",
    "saveAndQuit": "Save & Quit",
    "saveAndContinue": "Save & Continue",
    "saveCampaign": "Save Campaign",
    "saveCardInfo": "Save card info",
    "saveChanges": "Save Changes",
    "saveChangesTo": "Save Changes to",
    "saveEmail": "Save email",
    "savePaymentMethod": "Save payment method",
    "savePrintJob": "Save Print Job",
    "saveSuccessful": "Save successful",
    "saved": "Saved",
    "savings": "savings",
    "savingTheseChangesWillResetTheBuildPlatform": "Saving these changes will reset the build platform",
    "scale": "Scale",
    "scalloped": "Scalloped",
    "scan": "Scan",
    "scanUpper": "Scan Upper",
    "scanLower": "Scan Lower",
    "scanner": "Scanner",
    "scannerTips": "Scanner Tips",
    "scannerUsage": "Scanner Usage",
    "scanBody": "Scan Body",
    "scanBodyBrand": "Scan Body Brand",
    "scanBodyPartNumber": "Scan Body Part Number",
    "scanRequirements": "Scan Requirements",
    "scheduleAnAppointment": "Schedule Your Appointment",
    "scheduleNow": "Schedule Now",
    "screwName": "Screw Name",
    "screwType": "Screw Type",
    "search": "Search",
    "searchForLab": "Search for lab",
    "searchItem": "Search item...",
    "searchOrders": "Search orders",
    "searchPatients": "Search patients",
    "searchPrintJob": "Search print jobs",
    "seconds": "seconds",
    "section": "Section",
    "seeAll": "See All",
    "seeWhatsNew": "See What's New",
    "select": "Select",
    "selectAPrinter": "Select a Printer",
    "selectAPrinterFirst": "Select a printer first",
    "selectAPrintJob": "Select a Print Job",
    "selectAll": "Select All",
    "selectApplianceType": "Select Appliance Type",
    "selectArch": "Select Arch",
    "selectBase": "Select Base",
    "selectBridge": "Add bridges to this treatment",
    "selectCard": "Select card",
    "selectCountry": "Select country",
    "selectCoverage": "Pick type of coverage",
    "selectCrown": "Add single crowns to this treatment",
    "selectCutTypes": "Select Cut Types",
    "selectDate": "Click on the date picker to search by a date range",
    "selectDentureType": "Select Denture Type *",
    "selectGuidedSurgeryKitBrand": "Select guided surgery kit brand",
    "selectImplantBrand": "Select implant brand",
    "selectIndication": "Select Indication",
    "selectInlay": "Add inlays to this treatment",
    "selectLabToAssignJob": "Select lab to assign job to:",
    "selectLayerThickness": "Select LayerThickness",
    "selectMarylandBridge": "Add Maryland bridges to this treatment",
    "selectMaterial": "Select Material",
    "selectNotificationEvent": "Select Notification Event",
    "selectOnlay": "Add onlays to this treatment",
    "selectOption": "Select option",
    "selectPatient": "Select Patient",
    "selectPatientScanner": "Select Scanner",
    "selectPracticeType": "Select practice type",
    "selectPrintJobType": "Select a print job type to continue",
    "selectPrinter": "Select printer",
    "selectPrintJobFor": "Select print job for",
    "selectRequestRevisionReason": "Please select a reason for your revision:",
    "selectScanner": "Select scanner brand",
    "selectShellTemp": "Add shell temps to this treatment",
    "selectTeeth": "Select Teeth",
    "selectTeethForImplants": "Select Teeth For Implants",
    "selectThePrinter": "Select the printer",
    "selectTooth": "Select Tooth",
    "selectTreatment": "Select a treatment by clicking on it",
    "selectTreatmentType": "Please select revision type",
    "selected": "Selected",
    "selectedFiles": "Selected Files",
    "selectedItems": "Selected Items",
    "selectedPlan": "Selected Plan",
    "selectedPrinter": "Selected printer",
    "selectedTeeth": "Selected Teeth",
    "selection": "Selection",
    "selectionSummary": "Selection Summary",
    "selectiveUpdater": "Selective Updater",
    "selectShade": "Select Shade",
    "selfPrint": "Self Print - Design Only",
    "send": "Send",
    "sendEmails": "Send Emails",
    "sendFeedback": "Send Feedback",
    "sendInvitaions": "Send Invitaions",
    "sendNewPassword": "Send new password",
    "sendNotification": "Send notification",
    "sendPasswordEmail": "Send password in email upon completion",
    "sendSMSSub": "We need copy for additional charges",
    "sendSMSText": "Send me SMS notifications about my treatments in progress.",
    "sendSMSTitle": "Send SMS notifications",
    "sendToJobQueue": "Send to job queue",
    "sendToPrinter": "Send to Printer",
    "sendToQueue": "Send to Queue",
    "sendToRayWare": "Send to RayWare",
    "sendToRayWareCloud": "Send to RayWare Cloud",
    "sendVerificationCode": "Send Verification Code",
    "sendVerificationCodeAgain": "you can resend it",
    "sendVerificationCodeTip": "The verification code is being sent, If there has error or the user does not receive it,",
    "seniorAdvisor": "Senior Advisor",
    "separateDie": "Separate Die",
    "serialNo": "S/N",
    "serialNumber": "Serial Number",
    "servicedRegion": "Serviced Region",
    "servicedRegions": "Serviced Regions",
    "set": "Set",
    "sets": "Sets",
    "setAsActive": "Set as active",
    "setAsDefault": "Set as default",
    "setAsOfficial": "Set as official",
    "setAsTarget": "Set as target",
    "setClinic": "Set Clinic",
    "setLanguage": "Set language",
    "setNewPassword": "Set new Password",
    "setTreatment": "Select Treatment",
    "settings": "Settings",
    "setup": "Setup",
    "setupPrints": "Setup Print(s)",
    "setuptext": "Setup",
    "shade": "Shade",
    "shadeSelection": "Shade Selection",
    "shadeUnavailable": "Shade Unavailable",
    "shape": "Shape",
    "shareYourThoughts": "Share your thoughts",
    "shellTemp": "Shell Temp",
    "shippingOvernight": "Shipping (Overnight)",
    "shippingStandard": "Shipping (Standard)",
    "shippingAddress": "Shipping address",
    "shippingPrice": "Shipping price",
    "shipping": "Shipping",
    "createShipment": "Generate Shipping Label",
    "generateLabSlip": "Generate Lab Slip",
    "generatingLabSlipTitle": "Generating Lab Slip…",
    "generatingLabSlipMessage": "Please wait while we prepare your Lab Slip. This may take a moment. The PDF will open here automatically when it is ready.",
    "generating": "Generating...",
    "shorterPapilla": "Shorter papilla",
    "show": "Show",
    "showingYourApplianceTypeNamePrintJobs": "Showing your {{ applianceTypeName }} print jobs",
    "showAdvancedSettings": "Show Advanced Settings",
    "showAll": "show all",
    "showAllAttachments": "Show all attachments",
    "showDescription": "Show Description",
    "showFewer": "show fewer",
    "showMore": "Show More",
    "showOptionalFields": "Show optional fields",
    "showPowerBi": "Show Power BI report",
    "shownPrintersMessage": "Only printers that are online and compatible with current settings are shown",
    "shortBio": "Share a few sentences about your practice’s mission, values, and what makes your team unique to help patients feel more connected and confident in choosing your care.",
    "side": "Side",
    "signIn": "Sign In",
    "sin": "SIN",
    "singleCrown": "Single Crowns:",
    "singleCrowns": "Single Crowns",
    "singleImplantWithCrown": "Surgical Guide with Temporary Restoration",
    "singleTreatmentPaymentAICrown": "Single treatment payment / AI Crown",
    "size": "Size",
    "skip": "Skip",
    "skipAndCreateGroup": "Skip and Create Group",
    "sku": "Sku",
    "sleeveDiameter": "Sleeve Diameter",
    "sleeveLength": "Sleeve Length",
    "slicerFailed": "Slicer Failed",
    "slicing": "Slicing",
    "slightBuccalCuspElevation": "Slight buccal cusp elevation",
    "slightFrenumRelief": "Slight Frenum Relief",
    "slotRadius": "Slot radius",
    "slots": "Slots",
    "smileCorrect": "Smile Correct",
    "smileDesign": "Smile Design",
    "smileDesignType": "Smile Design Type",
    "smooth&FlatPlaneNoIndentations": "Smooth & Flat Plane/No Indentations",
    "smoothFlatPlane": "Smooth & Flat Plane/No indentations",
    "smoothTime": "Smooth Time",
    "softened": "Matt Roberts Improved Library (Softened)",
    "softenedAsTitle": "Softened",
    "softenedDesignStyle": "Softened Design Style",
    "softwareVersion": "Software Version",
    "someSpaceAvailable": "Some space available",
    "someTreatmentsInProgress": " Treatments in Progress",
    "somethingWentWrong": "Something went wrong!",
    "sortBy": "Sort by",
    "spaceOccupied": "Space Occupied",
    "spacing": "Spacing",
    "speciality": "Speciality",
    "spent": "Spent",
    "splintCrowns": "Splint Crowns:",
    "splitInto": "split into",
    "sprFile": "Spr File",
    "sprUpload": "SPR Upload",
    "sprintRay": "SprintRay",
    "sprintRayDentalModelStone": "SprintRay Dental Model Stone",
    "sprintRaySPR": "SprintRay SPR",
    "sprintRayDesignLiabilityWaiver": "SprintRay Design Liability Waiver",
    "sprintRayLiabilityWaiver": "SprintRay Liability Waiver",
    "sprintRayPro55": "SprintRay Pro 55 (DIRECT PRINT AVAILABLE)",
    "sprintRayPro55S": "SprintRay Pro 55S (DIRECT PRINT AVAILABLE)",
    "sprintRayPro95": "SprintRay Pro 95 (DIRECT PRINT AVAILABLE)",
    "sprintRayPro95S": "SprintRay Pro 95S (DIRECT PRINT AVAILABLE)",
    "sprintRayTermsOfLiability": "SprintRay Terms of Liability",
    "stakeholderDescription": "Stakeholder description",
    "stakeholderEmail": "Stakeholder email",
    "stakeholders": "Stakeholders",
    "standard": "Standard",
    "standardPrintMode": "Standard Print Mode",
    "standardSpeed": "Standard Speed",
    "standardTimeSetByOrganization": "Standard Time Set By Organization",
    "standing": "Standing",
    "standardKit": "Standard Kit",
    "start": "Start",
    "startATreatment": "Start a Treatment",
    "startByAdding": "Start by either adding a new patient, or selecting an existing one.",
    "startDate": "Start Date",
    "startFromTemplate": "Start from template",
    "startMeshRepair": "Start Mesh Repair",
    "startNewTreatment": "Start new treatment",
    "startPreview": "Start Preview",
    "startSpookyPrintJob": "START SPOOKY PRINT JOB",
    "startTest": "Start Test",
    "startTime": "Start Time",
    "startTreatment": "START TREATMENT",
    "started": "Started",
    "startingDay": "Starting day",
    "startingAt": "Starting at",
    "startingFrom": "Starting from",
    "startingMonth": "Starting month",
    "startCloudDesignTreatment": "Start a Cloud Design Treatment",
    "startYourPrintingJourney": "Start Your Printing Journey",
    "status": "Status",
    "statusDetails": "Status Details",
    "statusOfTreatment": "Status of this treatment:",
    "statusPage": "Status Page",
    "stageGrantsHaveDiscount": "Your status grants you a {{percent}}% discount.",
    "stageGrantsNoDiscount": "Your status grants you no discount.",
    "stageGrantsNextDiscount": "You’re only <span style=\"font-weight: 600;\">{{count}} orders</span> away from <span style=\"font-weight: 600;\">{{percent}}%</span> off!",
    "stageGrantsAdditionalDiscount": "You’re only <span style=\"font-weight: 600;\">{{count}} orders</span> away from an additional <span style=\"font-weight: 600;\">{{percent}}%</span> off!",
    "stageGrantsDiscountAchieve": "Enjoy these exclusive savings! ",
    "stageGrantsNotApplicable": "Neer reward doesn’t apply to this purchase.",
    "step": "Step",
    "stepFive": "Step 5",
    "stepFour": "Step 4",
    "stepN": "Step #",
    "stepOne": "Step 1",
    "stepThree": "Step 3",
    "stepTwo": "Step 2",
    "stop": "Stop",
    "storage": "Storage",
    "store": "Store",
    "straight": "Straight",
    "street": "Street",
    "streetAddress1": "Street Address 1",
    "streetAddress2": "Street Address 2",
    "strength": "Strength",
    "stronglyEncouraged": "Strongly encouraged for best results",
    "studio": "Studio",
    "studioCrown": "Studio Crown",
    "subject": "Subject",
    "submit": "Submit",
    "submitAndPay": "Submit and Pay",
    "submitAiCownDesign": "Submitting an AI Crown Design",
    "submitted": "Submitted",
    "submittedDate": "Submitted Date",
    "submittedDoctorNumber": "Submitted Doctor Number",
    "subscription": "subscription",
    "subscriptionActiveSince": "You'll still have full access to AI Studio and your files until",
    "subscriptionAndPayment": "Subscription & Payment",
    "subscriptionCancelled": "Subscription cancelled",
    "subscriptionDiscount": "Subscription Discount",
    "subscribeToUnlimitedAI": "Subscribe to Unlimited AI",
    "subtotal": "Subtotal",
    "success": "Success",
    "successfullyDeleted": "Successfully deleted",
    "summary": "Summary",
    "superAdmin": "Super Admin",
    "supportCode": "Support code:",
    "supportPreferences": "Support Preferences",
    "supportRaft": "Support Raft",
    "supportStyle": "Support Style",
    "supportingImages": "Supporting Images",
    "supports": "Supports",
    "supportsLegend": "Surface that requires supports",
    "surgicalGuide": "Implant Planning and Surgical Guide",
    "surgicalGuideAppliance": "Surgical Guide",
    "surgicalGuideSpr": "Surgical Guide (Spr)",
    "surgicalGuideStl": "Implant Planning and Surgical Guide(Stl)",
    "surgicalGuideStlType": "Surgical Guide (Stl)",
    "survey": "Survey",
    "surveyCampaign": "Survey Campaign",
    "surveyCampaigns": "Survey Campaigns",
    "surveys": "Surveys",
    "switch": "switch",
    "switchToManualDesign": "Switch to Manual Design",
    "switchToPlan": "Switch to plan",
    "switchToRayWareEarlyAccess": "Switch to RayWare Early Access",
    "switchToRayWareLegacy": "Switch to RayWare Legacy",
    "switchedToManualDesign": "Switched to Manual Design",
    "switchesOn": "Plan switches on",
    "symbol": "Symbol",
    "symbols": "symbols",
    "syncBox": "Sync box",
    "syncFolder": "Sync folder",
    "syncingChanges": "Syncing changes",
    "system": "System",
    "systemUpdate": "System Update",
    "tag": "Tag",
    "tags": "Tags",
    "targetVersion": "Target Version",
    "tax": "Tax",
    "taxes": "Taxes",
    "itemTax": "Item Tax",
    "overnightShippingTax": "Overnight Shipping Tax",
    "team": "Team",
    "teams": "Teams",
    "technician": "Technician",
    "teeth": "Teeth",
    "teeth2029": "Teeth 20-29",
    "teeth413": "Teeth 4-13",
    "teethAreNotTracking": "Teeth are not tracking",
    "teethExtraAttention": "Teeth that need extra attention",
    "teethMaterial": "Teeth Material",
    "teethMustBeExtracted": "Teeth Must Be Extracted",
    "teethNotToMove": "Teeth not to move",
    "teethNumber": "Teeth Number",
    "teethForTreatment": "Teeth for Treatment",
    "teethSelectedForTreatment": "Teeth Selected for Treatment",
    "teethSelection": "Teeth selection",
    "tellUsAboutYourPractice": "Tell us about your practice",
    "template": "Template",
    "templateTreatments": "Treatment Templates",
    "templates": "Templates",
    "temporaryCrown": "Temporary Crown",
    "termsAndConditions": "Terms and conditions!",
    "termsConditions": "Terms & Conditions",
    "termsOf": "terms of",
    "termsOfUse": "Terms of Use",
    "terrible": "Terrible",
    "text": "Text",
    "textAnnotation": "Text Annotation",
    "textLabel": "Text Label",
    "the": "The",
    "theFirstAestheticRedesignForThisTreatmentIsComplementary": "The first aesthetic redesign for this treatment is complementary.",
    "theFolderIsEmpty": "The Folder is Empty",
    "theShorterTheModelTheFasterThePrint": "The shorter the model, the faster the print",
    "theseTeethShouldNotBeMoved": "These Teeth Should Not Be Moved",
    "thickness": "Thickness",
    "thirdPartySetup": "Third Party Setup",
    "thisAmount": "This amount",
    "thisIsMomentTreatment": "This is moment treatment",
    "thisMonth": "This Month",
    "thisWeek": "This Week",
    "thisYear": "This Year",
    "threeDScannner": "3D Scanner",
    "ti-baseDess15007": "Ti-Base Dess 15.007",
    "tier": "Tier",
    "tight": "Tight",
    "tightness": "Tightness",
    "tighter": "Tighter",
    "tighterFit": "Tighter Fit",
    "time": "Time",
    "timeInterval": "Time Interval",
    "timePeriod": "Time Period",
    "timeSheet": "Time Sheet",
    "timeStamp": "Timestamp",
    "timeToDesign": "Time To Design",
    "timeToPrint": "Time To Print",
    "timeToSla": "Time to SLA",
    "timeline": "Timeline",
    "tinVatNumber": "TIN/VAT #",
    "tissuePressureToGingiva": "Tissue Pressure To Gingiva",
    "title": "Title",
    "to": "to",
    "toDate": "To Date",
    "toPlanSelection": "To Plan Selection",
    "today": "Today",
    "todayCharge": "Today Charge",
    "tools": "Tools",
    "tooth": "Tooth",
    "toothLibrary": "Tooth Library",
    "toothLibraryName": "Tooth Library Name",
    "toothMould": "Tooth Mould",
    "toothMouldIfKnown": "Tooth Mould If Known",
    "toothNoteHeader": "Please write a comment regarding marked tooth",
    "toothNumber": "Tooth Number",
    "toothSelection": "Tooth Selection",
    "toothSizeDiscrepancy": "Tooth size discrepancy",
    "tos": "terms of service",
    "total": "Total",
    "totalAmount": "Total Amount",
    "totalAverageTurnaroundTime": "Total Average Turnaround Time",
    "totalCharge": "Total Charge",
    "totalCharges": "Total Charges",
    "totalCompleted": "Total Completed",
    "totalDaysPaid": "Total Paid",
    "totalIncomplete": "Total Incomplete",
    "totalJobCompleted": "Total Job Completed",
    "totalMaterialUsed": "Total material used",
    "totalPrintJobs": "Total print jobs",
    "totalPrintTime": "Total print time",
    "totalRequests": "Total Requests",
    "totalRevenue": "Total Revenue",
    "totalTreatments": "Total Treatments",
    "totalTreatmentsLastMonth": "Total Treatments Last Month",
    "totalUsage": "Total Usage",
    "totalUsers": "Total Users",
    "toStartPrintingWithRayWare": "To start printing with RayWare, you’ll need to connect your printer to SprintRay Cloud. ",
    "tracking": "Tracking",
    "trackingNumber": "Tracking Number:",
    "viewTracking": "View Tracking",
    "trackingUnavailable": "Tracking information is unavailable. Please try again later.",
    "trainingPlatform": "Training Platform",
    "transactionId": "Transaction ID",
    "transactions": "Transactions",
    "treatment": "Treatment",
    "treatmentApproved": "Treatment Approved",
    "treatmentAssign": "Treatment Assign",
    "treatmentCanceled": "Treatment Canceled",
    "treatmentDetails": "Treatment Details",
    "treatmentDetailsDisplayed": "Your treatment details are displayed here",
    "treatmentEmails": "Treatments emails",
    "treatmentFiles": "Treatment Files",
    "treatmentFinished": "Treatment finished",
    "treatmentId": "Treatment ID",
    "treatmentInfo": "Treatment Info",
    "treatmentInfoAdvanced": "Treatment Info Advanced",
    "treatmentInstructions": "Treatment Instructions",
    "treatmentInstructionsIncludingAnyPostOrthodonticsRestorativeTreatmentPlan": "Treatment Instructions (Including Any Post Orthodontics Restorative Treatment Plan):",
    "treatmentIsInProgress": "Treatment is in Progress",
    "treatmentList": "Treatment List",
    "treatmentMoved": "Treatment Moved",
    "treatmentNotes": "Treatment Notes",
    "treatmentOptions": "Treatment Options:",
    "treatmentPayments": "Treatment Payments",
    "treatmentPlan": "Treatment Plan",
    "treatmentPlanChange": "Treatment plan change",
    "treatmentRequestReceived": "Treatment Request Received",
    "treatmentRules": "Treatment rules",
    "treatmentSpecification": "Treatment Specification",
    "treatmentSpecifications": "Treatment Specifications",
    "treatmentStatus": "Treatment status",
    "treatmentSubType": "Treatment Subtype",
    "treatmentSubmitted": "Treatment Submitted",
    "treatmentSummary": "Treatment summary",
    "treatmentType": "Treatment type",
    "treatmentTypeSelect": "Select which treatment you’d like to order. ",
    "treatmentTypeWithColon": "Treatment Type:",
    "treatmentUpdated": "Treatment Updated",
    "treatmentUpdates": "Treatment Updates",
    "treatments": "Treatments",
    "treatmentsCreated": "Treatment created",
    "treatmentsSearch": "Treatments Search",
    "trialSmile": "Trial Smile",
    "tryDifferentFilters": "Try using different filters.",
    "tryIn": "Try-in",
    "tryInDenture": "Try-in Denture",
    "tryInMaterial": "Try-In Material",
    "tryTheNewRayWare": "Try the New RayWare",
    "tryUsingADifferentTerm": "Try using a different term.",
    "turnaroundTime": "Turnaround Time",
    "turnaroundTimeByTimePeriod": "Turnaround Time By Time Period(Hours)",
    "turnaroundTimeForDesign": "Tuanaround Time for Design",
    "turnaroundTimeForPrint": "Turnaround Time for Print",
    "twoLateralsMesiallyRotatedAndTuckedBehindCentrals": "Two laterals mesially rotated and tucked behind centrals",
    "type": "Type",
    "typeDegreeOfOrientation": "Type degree of orientation",
    "typePromoCode": "Type promo code",
    "typeToSearch": "Type to search...",
    "typeYourPreferredSleeveBrand": "Type your preferred sleeve brand",
    "typesOfDentistryPracticed": "Types of dentistry practiced",
    "unassign": "Unassign",
    "unassignDevicesFromGroup": "Unassign devices from group",
    "unassignFromGroup": "Unassign from group",
    "unassignFromPatient": " Unassign From Patient",
    "unassigned": "Unassigned",
    "uncheckAll": "Uncheck all",
    "undercutBlockOutTitle": "Undercut Block-Out",
    "undefinedIndication": "Undefined Indication",
    "undo": "Undo",
    "unevenSmile": "Uneven Smile",
    "universalNumberingSystem": "Universal Numbering System (UTN)",
    "unKnown": "Unknown",
    "unlimited": "Unlimited",
    "unlimitedAi": "Unlimited AI",
    "unlimitedUsage": "Unlimited usage",
    "unmarkAsInternal": "Unmark As Internal",
    "unregisterDate": "Unregister Date",
    "unsaved": "Unsaved",
    "unset": "Unset",
    "unsupportedResin": "Unsupported Resin",
    "until": "Until",
    "up": "Up",
    "upToDate": "Up To Date",
    "upcomingAppointments": "Upcoming Appointments",
    "update": "Update",
    "updateClinic": "Update Clinic",
    "updateYourProfile": "Update your profile",
    "updateComm": "Edit Communication Preferences",
    "updateDevice": "Update Device",
    "updateGroup": "Update Group",
    "updateInvoice": "Update Invoice",
    "updateOfficialVersion": "Update Official Version",
    "updatePassword": "Update Password",
    "updateRegion": "Update Region",
    "updateTargetVersion": "Update Target Version",
    "updateUser": "Update User",
    "updated": "Updated",
    "updatePaymentMethodWarning": "This will update your default payment method",
    "upgrade": "Upgrade",
    "upload": "Upload",
    "uploadAdditionalImages": "Upload any additional images.",
    "uploadApplianceScan": "Upload Appliance Scan",
    "uploadArchScans": "Upload Full Arch Scans",
    "uploadArchScansLower": "Upload Lower Arch Scan",
    "uploadArchScansUpper": "Upload Upper Arch Scan",
    "uploadBiteScan": "Upload Bite Scan",
    "uploadBiteScans": "Upload bite scans",
    "uploadDentureScansLower": "Upload Lower Denture Scans",
    "uploadDentureScansUpper": "Upload Upper Denture Scans",
    "uploadFileOrImage": "Upload file or image",
    "uploadFiles": "Upload files",
    "uploadFileScanIssueFound": "Scan issue found",
    "uploadFilesToPrintJob": "Upload files or drag and drop to print job",
    "uploadFolder": "Upload folder",
    "uploadImportFile": "Upload Import File",
    "uploadInvoice": "Upload Invoice",
    "uploadMaxillaryAndMandibularScans": "Upload maxillary and mandibular scans",
    "uploadModelPreviewTips": "Preview available for first 24 files",
    "uploadModelPreviewTitle": "Print job is being processed",
    "uploadModelPreviewTitleWhenUploading": "Uploading files",
    "uploadNewFiles": "Upload new files",
    "uploadNewImage": "Upload new image",
    "uploadNewScans": "Upload new scans",
    "uploadNumberOfFiles": "Uploading {{number}} files",
    "uploadPatientFiles": "Upload Patient Files",
    "uploadPatientPhotos": "Upload Patient Photos",
    "uploadPhotogrammetryData": "Upload Photogrammetry Data",
    "uploadPhotos": "Upload Photos",
    "uploadPreppedScans": "Upload Prepped Scans",
    "uploadScans": "Upload Scans",
    "uploadPatientSmileWithQrCode": "Upload from phone with QR code",
    "scanPatientSmileQrCode": "Scan this QR code with your phone to upload a patient smile photo.",
    "patientSmileQrCodeAlt": "Secure patient smile upload QR code",
    "patientSmileQrRefreshNote": "For your security, this QR code is valid for a short time.",
    "patientSmileQrError": "We couldn't prepare the secure upload. Please try again.",
    "patientSmileUploadPreparing": "Preparing a secure upload...",
    "patientSmileUploadReceived": "Photo received. It is now available in this order.",
    "patientSmileUploadTitle": "Upload patient smile photo",
    "patientSmileUploadDescription": "Choose a photo from your library or take a new photo.",
    "patientSmileChoosePhoto": "Choose or take photo",
    "patientSmileUploadError": "The secure link expired or the upload failed. Scan a new QR code and try again.",
    "patientSmileInvalidFile": "That photo couldn't be uploaded. Choose a JPG or PNG photo and try again.",
    "patientSmileUploadFailed": "The photo couldn't be uploaded. Check your connection and try again.",
    "patientSmileModificationDenied": "This order has already been submitted and can no longer be changed.",
    "patientSmileUploadCompleteTitle": "Photo uploaded",
    "patientSmileUploadCompleteDescription": "You can return to the order on your computer.",
    "patientSmileTryAgain": "Try again",
    "patientSmileSampleAlt": "Example of a patient smile photo",
    "uploadScansWrongType": "Only {{types}} files can be uploaded here. Everything else was skipped.",
    "uploadScansSingleFileOnly": "Only one file can be uploaded here. Choose a single file.",
    "uploadScansTooManyFiles": "Up to {{count}} files can be uploaded here. The rest were skipped.",
    "uploadScansFileTooSmall": "That file is empty or damaged. Choose a different file.",
    "uploadScansHeicFailed": "That iPhone photo couldn't be converted. Choose a JPG or PNG photo instead.",
    "uploadScansTooLarge": "The selected files add up to more than {{size}} MB. Choose smaller files.",
    "uploadScansAfterPrepping": "Upload Scans After Prepping",
    "uploadScansAfterImplantPlacement": "Upload Scans After Implant Placement",
    "uploadUpperAndLowerPostOpScans": "Upload upper and lower post-op scans in bite relation, and a picture of patient smiling.",
    "uploadSprFile": "Upload Spr File",
    "uploadTime": "Upload Time",
    "uploadTissueScans": "Upload Tissue Scans",
    "uploadWaxRimScansLower": "Upload Lower Wax Rim Scans",
    "uploadWaxRimScansUpper": "Upload Upper Wax Rim Scans",
    "uploadWithoutAssigning": "Upload Without Assigning",
    "uploaded": "Upload Lower Wax Rim Scans",
    "uploadedNumberOfFiles": "{{number}} files uploaded",
    "uploading": "Uploading",
    "uploadYourDesigns": "Upload Your Designs",
    "uploadYourDesignsDescription": "Neer now supports your own custom designs. Design your case and upload it, Neer handles the rest!",
    "upper": "Upper",
    "upperArch": "Upper Arch",
    "upperEsthetic": "Upper esthetic",
    "upperJaw": "Upper Jaw",
    "upperRange": "Very likely.",
    "upperScan": "Upper Scan",
    "upperTissueScan": "Upper Tissue Scan",
    "usage": "Usage",
    "usageDetails": "Usage details",
    "usageRestrictions": "Usage Restrictions",
    "usageThisMonth": "Usage this month",
    "use": "Use",
    "useADifferentBillingAddress": "Use a different billing address",
    "useAi": "Use AI Design",
    "useExistingScans": "use existing scans",
    "useLastDate": "Last Date",
    "useLastProject": "Last Project",
    "useMaximumAllowedDiameter": "Use maximum allowed implant diameter",
    "useMaximumAllowedLength": "Use maximum allowed implant length",
    "useSubmittedPhotosAsAReference": "Use submitted photos as a reference",
    "used": "Used",
    "usedBy": "Used By",
    "usedOn": "Used On",
    "usedPromoCode": "Used Promo Code",
    "usedThisMonth": "Used this month",
    "user": "User",
    "userManagement": "User Management",
    "userPasswordSettings": "Password Settings",
    "username": "Username",
    "users": "Users",
    "usingaDifferentBrowserMayCausePerformanceIssues": "Using a different browser may cause performance issues.",
    "validatingAuthorization": "Validation Authorization",
    "validUntil": "Valid until",
    "value": "Value",
    "values": "Values",
    "variance": "Variance (%)",
    "vatCollected": "Vat Collected",
    "vatNumber": "VAT Number",
    "veneerType": "Type of Neer",
    "veneers": "Neer",
    "neerCrystal": "Neer Crystal",
    "veneersMode": "Neer Mode",
    "versionHistory": "Version History",
    "versions": "Versions",
    "vertical": "Vertical",
    "veryDispleased": "Very Displeased",
    "veryPleased": "Very Pleased",
    "view": "View",
    "viewAll": "View All",
    "viewInCloudDrive": "View in Cloud Drive",
    "viewNewTreatment": "View New Treatment",
    "viewOnDashboard": "View on dashboard",
    "viewLicenseCertificate": "View License Certificate",
    "viewPatientDetails": "View Patient Details",
    "viewPreviousDesign": "View Previous Design",
    "viewSpr": "View SPR",
    "vigorous": "Priti_Q_M (Vigorous)",
    "vigorousAsTitle": "Vigorous",
    "vigorousDesignStyle": "Vigorous Design Style",
    "virtualPrinters": "Virtual Printers",
    "visitStore": "Visit Store",
    "videoHidden": "video hidden",
    "volumeOfResin": "Volume Of resin",
    "warning": "Warning",
    "washDevices": "Wash Devices",
    "watchFolder": "Watch Folder",
    "waxUpModel": "Wax-Up Model",
    "weAreAlwaysAddingTreatmentOptions": "We’re always adding new treatment options, so use these filters to sort by type.",
    "website": "Website",
    "week": "week",
    "welcome": "Welcome",
    "welcomeTo": "Welcome To",
    "welcomeToSprintRay": "Welcome to SprintRay",
    "washMaintenance": "Wash Maintenance",
    "were": "were",
    "whenPaidAnnually": "when paid annually",
    "whenYouUploadFilesToThisFolder": "When you upload files to this folder",
    "whenYouUploadUnassignedFiles": "When you upload unassigned files from your computer",
    "willCost": "will cost",
    "willBeAdded": "Will Be Added",
    "wings": "Wings",
    "with": "with",
    "withCloudDesign": "With Cloud Design, you can easily order designs for your 3D printer. Our expert team of designers and cutting-edge AI technology enable rapid turnaround times at affordable prices.",
    "withInactiveUsers": "with inactive users",
    "wontBeAdded": "Won't Be Added",
    "workTimeType": "Work Time Type",
    "worldDentalFederationNotation": "World Dental Federation notation (FDI)",
    "worstCaseTurnaroundTimeByTimePeriod": "Worst Case Turnaround Time By Time Period(Hours)",
    "wouldYouLikeToAddBleachingMaterialReservoirsOnTeethSurfaces": "Would You Like To Add Bleaching Material Reservoirs On Teeth Surfaces?",
    "wouldYouLikeToRemoveLingualRetainer": "Would You Like To Remove Lingual Retainer?",
    "writeMessage": "Write a message ...",
    "whyCanceling": "Why are you canceling?",
    "year": "Year",
    "yearly": "yearly",
    "yes": "Yes",
    "yesterday": "Yesterday",
    "you": "You",
    "yesProceed": "Yes, proceed",
    "youAgreeToTheConditionsOutlined": "you agree to the conditions outlined in the",
    "youAreXxxOrdersAwayFromXxxDiscount": "You’re only <strong>{{nextStateRequiredOrders}} orders</strong> away from a <strong>{{nextStageDiscount}}%</strong> discount!",
    "youCanUpload": "You can upload models, pictures and videos.",
    "youHaveMadeItToFinalStatusEnjoyTheDiscount": "Congratulations, you’ve made it to the final status! Enjoy a <strong>{{currentStageDiscount}}%</strong> discount.",
    "yourCredit": "Your credit",
    "yourDesignsAreBeingPrinted": "Your Designs Are Being Printed",
    "yourDesignsAreReadyToPrint": "Your Design is Ready to Print",
    "yourDesignCouldNotBeCompleted": "Your design could not be completed",
    "youWillBeRedirectedToTheTreatmentPageInAFewMoments": "You will be redirected to the treatment page in a few moments.",
    "youWillReceive": "You will receive",
    "youWillSeeThemHere": "You will see them here",
    "yourAnswer": "Your answer",
    "yourDevices": "Your Devices",
    "yourPlan": "Your plan",
    "yourPlanWillBeSwitchedTo": "Your plan will be switched to",
    "yourSubscription": "your subscription",
    "youthful": "Vita Physiodens O2L (Youthful)",
    "youthfulAsTitle": "Youthful",
    "youthfulDesignStyle": "Youthful Design Style",
    "youEarnedReward": "You earned a reward!",
    "youCanNowStartUsingCloudDesign": "You can now start using Cloud Design.",
    "zeroTreatmentsInProgress": "No Treatments in Progress",
    "zipCode": "Zip Code"
  },
  "messages": {
    "shippingAddressValidationFailed": "The shipping address you have entered is invalid. Please provide a valid shipping address.",
    "shippingAddressValidationUnavailable": "Unable to validate the shipping address. Please try again.",
    "shippingAddressSuggestionTitle": "Confirm shipping address",
    "shippingAddressSuggestion": "We found a suggested address for your delivery. Please review it before continuing.",
    "suggestedShippingAddress": "Suggested address",
    "useSuggestedAddress": "Use this address",
    "editShippingAddress": "Edit my address",
    "shippingZipCodeFormat": "Enter a valid 5-digit ZIP code.",
    "EnterProfileInfo": "Enter your profile info",
    "IncorrectSortOrder": "Cannot automatically sort these STL files. Incorrect steps order.",
    "IsThereAnythingWrongWithTheFile": "Is there anything wrong with the file? Tell the designer what needs to be fixed and request a revision!",
    "a24HourNoticeIsRequiredToChangeAnAppointment": "A 24-hour notice is required to change an appointment. Cancellations will not be accepted within 24 hours of the appointment. Consult the SprintRay Cloud Terms & Conditions to learn more.",
    "aICannotProccessThisIssue": "AI can’t proccess this issue",
    "addScannerIntegration": "Add Scanner Integration",
    "aICannotProccessThisIssuePromptContent": "AI can only process too thick/too thin design issues for closed bite. Your case is for open bite, please request a manual design or refund etc.",
    "aIDesignChecklistImportant": "Please request a manual night guard if your case does not meet all the criteria.",
    "aIDesignChecklistOne": "The patient needs an <b>upper</b> night guard",
    "aIDesignChecklistThree": "The patient is <b>not missing</b> any teeth",
    "aIDesignChecklistTwo": "I have scanned the <b>closed bite</b> and exported the scans <b>in occlusion</b>",
    "aIDesignChecklistTwoAlt": "The <b>closed bite</b> is scanned and exported in <b>occlusion</b>",
    "aboBaseDescription": "ABO is the standard in dentistry and ideal for thermoforming.",
    "abutmentTypeTooltip": "We can design the restoration for most abutments. If your abutment is not available, we will provide an eggshell temporary.",
    "abutmentModelInformationTooltip": "It is important that the exact part numbers of components are provided. If a component is unavailable in our software, a shell temporary will be provided.",
    "access3rdPartyFiles": "Access files directly from a scanner or other participating third parties here.",
    "accessToCases": "Access to your cases list",
    "accessToProfile": "Access to your profile",
    "accountLinkedSuccessfully": "The account has been linked successfully!",
    "accountUnlinkedSuccessfully": "The account has been unlinked successfully!",
    "alreadyOwnMidas": "Already own Midas?",
    "alreadyPaidMessage": "You have already paid for this treatment. Approve files to add to print the design.",
    "activateOneYearFree": "Activate for 1 year of Unlimited AI for free",
    "addBridge": "Add a Bridge",
    "addPracticeDetails": "Add Practice Details",
    "addToPrintJob": "To Add to Print Job this file, you have to approve it first.",
    "additionalChargeCanceledRevisionRequestClosed": "Additional charge canceled, revision request closed",
    "additionalChargeWasPayedAutomaticallyReason": "Additional charge was payed automatically, reason:",
    "additionalCommentsExplanation": "Include any additional instructions or relevant information. Should any teeth NOT be moved? Should any teeth NOT have engagers/buttons placed? Should any spaces be left open?",
    "additionalNotesPlaceholder": "Any additional instructions or preferences you would like the designer to consider. For example, should we only include a certain part of the model?",
    "addressIsIncomplete": "The address field is incomplete",
    "advancedSettingsAICrownMsg": "Set custom parameters for this treatment, including occlusal distance and aesthetics.",
    "adjacentToothTips": "Adjacent crowns not allowed. Picking one deselects its neighbor.",
    "personalizationSettingsDescription": "Access settings for denture border, midline, occlusion class, post dam, and frenum relief",
    "aiCrownCheckListDescription": "AI design has limited capabilities. Review the list below and request a manual design if your case doesn’t meet the criteria.",
    "aiCrownCheckListStepOne": "Patient needs 1 or more crowns",
    "aiCrownCheckListStepOnePointOne": "Inlay/onlay not accepted",
    "aiCrownCheckListStepOnePointTwo": "Crowns cannot be adjacent to each other",
    "aiCrownCheckListStepTwo": "Scans include fully prepped teeth",
    "aiCrownCheckListStepTwoPointOne": "Scans cannot have preps adjacent to each other",
    "aiCrownCheckListStepThree": "Upper & lower scans are in bite relation",
    "aiCrownCheckListStepThreePointOne": "Bite scans and model scans are not accepted",
    "aiCrownDescriptionFour": "Please request a manual crown if your case does not meet all of the criteria.",
    "aiCrownDescriptionOne": "Patient needs a single posterior crown",
    "aiCrownDescriptionOnePointOne": "No inlays or onlays accepted",
    "aiCrownDescriptionOnePointTwo": "Premolars and molars only",
    "aiCrownDescriptionThree": "Upper & lower intraoral scans are in bite relation",
    "aiCrownDescriptionThreePointOne": "Bite scans and model scans are not accepted",
    "aiCrownDescriptionTwo": "The prep scan includes exactly 1 fully prepped tooth",
    "aiCrownDescriptionTwoPointOne": "Min incisal shoulder width 0.5 mm",
    "aiCrownDescriptionTwoPointTwo": "Min occlusal shoulder width 1.0 mm",
    "aiCrownErrorBiteAlignmentHasBeenAdjustedManually": "It appears the bite alignment has been adjusted manually, which is not supported by Al. Switch to a manual design to continue.",
    "aiCrownErrorDataDeemsCorrupted": "Some of the data for this treatment seems corrupted. Switch to a manual design and re-upload scans to continue.",
    "aiCrownErrorHeaderBiteManuallyAdjusted": "Bite Manually Adjusted",
    "aiCrownErrorHeaderCannotCreateAiDesign": "Cannot Create AI Design",
    "aiCrownErrorHeaderCannotFindMargins": "Cannot Find Margins",
    "aiCrownErrorHeaderDataAppearsCorrupted": "Data Appears Corrupted",
    "aiCrownErrorHeaderOutsideDesignParameters": "Outside Design Parameters",
    "aiCrownErrorHeaderScanDataIssue": "Scan Data Issue",
    "aiCrownErrorMarginsWereNotClearEnough": "The margins in the scan data were not clear enough for Al design. Switch to a manual design to continue.",
    "aiCrownErrorOurAiSystemEncounteredAnIssue": "Our Al system encountered an issue when designing this treatment. Switch to manual design to continue.",
    "aiCrownErrorParameterOfThisDesignIsOutsideTheScopeOfAi": "One or more parameter of this design is outside the scope of Al. Switch to a manual design to continue.",
    "aiCrownErrorThereIsAnIssueWithTheScanData": "There's an issue with the scan data or this case is too complex for Al design. Switch to a manual design to continue.",
    "aiCrownErrorThereIsAnIssueWithTheScans": "There is an issue with one of the scans or they are in closed bite format. Switch to manual design to continue.",
    "aiCrownTreatmentNotesPartFour": "If your case doesn’t meet all the requirements, request a manual design instead.",
    "aiCrownTreatmentNotesPartOne": "For single or multiple non-adjacent crowns, use AI to get a design in minutes.",
    "aiCrownTreatmentNotesPartThree": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li>Clear scan of the patient after their teeth have been prepped<ul style=\"padding-left: 1.5rem;\"><li>Adjacent preps not accepted</li></ul></li><li>Upper and lower scans in bite relation</li></ul>",
    "aiCrownTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>A crown design for each selected prepped tooth to be 3D printed in your office</li><li>A printable die for each crown that can be 3D printed to test the fit and margins</li><li>A treatment plan for each crown including occlusal heat map and margin line</li></ul>",
    "aiNightguardTreatmentNotesPartFour": "If your case doesn’t meet <b>all</b> the requirements, request a manual design instead.",
    "aiNightguardTreatmentNotesPartOne": "Use advanced SprintRay AI to get a night guard in just a few minutes.",
    "aiNightguardTreatmentNotesPartThree": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li>Upper and lower scans with an open or closed bite, exported in occlusion</li><li>Patient needs a flat plane night guard</li><li>All teeth are present in the patient scans</li></ul>",
    "aiNightguardTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>One upper or lower night guard design file that you can 3D print in your office</li></ul>",
    "aiNightguardTreatmentNotesForNgComPartOne": "The design will be ready for approval within a few minutes. After approval, it will ship within 48 hours.",
    "aiNightguardTreatmentNotesForNgComPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>Printed night guard shipped directly to your office</li><li>One night guard upper or lower night guard design file that you can 3D print it at any time</li><li>Night guard care instructions</li></ul>",
    "aiNightguardTreatmentNotesForNgComPartThree": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li>Upper and lower scans with an open or closed bite, exported in occlusion</li><li>Patient needs a flat plane night guard</li><li>All teeth are persent in the scans</li></ul>",
    "aiRetainerScanRequirementsOne": "Upper and lower scans are required",
    "aiRetainerScanRequirementsTwo": "Scans must be exported in occlusion",
    "aiRetainerScanRequirementsThree": "2 mm of tissue data beyond the margin in the anterior buccal region",
    "aiRetainerTreatmentNotesPartOne": "Use AI to get a directly printable retainer in minutes. This treatment is compatible only with SprintRay Retainer.",
    "aiRetainerTreatmentNotesPartTwo": "You’ll get:<p>A retainer design that can be directly printed in your office. No thermoforming required.</p>",
    "aiRetainerTreatmentNotesPartThree": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li>Upper and lower scans are required</li><li>Scans must be exported in occlusion</li><li>2 mm of tissue data beyond the margin in the anterior buccal region</li></ul>",
    "aiRetainerProgressFeatureDetectionError": "Our algorithm encountered an issue while reading the scan data. Check that your scans properly captured the gingival margin, were exported in occlusion, and used the scanner’s hole-filling feature.",
    "aiRetainerProgressRetainerGenerationError": "Our algorithm had an issue generating the retainer. Check that your scans don’t have mesh issues and that your patient isn’t an anatomical outlier. If everything looks good, try resubmitting this case.",
    "aiProccesFailed": "The NightGuard algorithm was not able to process correctly. Please request a revision and re-upload your scans. Common reasons for failed AI Upper Nightguards can be found",
    "aiProgressFailedAiRetainerError": "This scan has missing teeth, partial crowns, prepped teeth, or other issues that increase the complexity of the design. Please upload new files to proceed with the design.",
    "aiProccesFailedPartFour": "• Too many holes exist in the scans and need to be closed.",
    "aiProccesFailedPartOne": "We were not able to process your scans correctly. Please submit new scans after reviewing some common reasons for failed scans:",
    "aiProccesFailedPartThree": "• More trimming must be done to remove floating data.",
    "aiProccesFailedPartTwo": "• The scans were not saved in occlusion.",
    "aiProcessFailedCheckFiles": "We encountered an error while trying to read one or more of the files. Carefully check each scan to verify that you have uploaded the correct files, then click ‘Resubmit Files’ to reupload.",
    "aiProcessFailedCheckFilesTitle": "Check Files",
    "aiProcessFailedReUpload": "It looks like these scans may overlap. Check that scans are in occlusion and that you haven’t uploaded the same file for the upper and lower arch. Click ‘Resubmit Files’ to reupload.",
    "aiProcessFailedReUploadTitle": "Re-upload Upper & Lower",
    "aiProcessFailedRetakeBiteScan": "Night guard AI requires scans in occlusion to create a design. Click ‘Resubmit Files’ to reupload data with closed bite scans.",
    "aiProcessFailedRetakeBiteScanTitle": "Retake Bite Scan",
    "aiProcessFailedRetakeScans": "We detected issues with the integrity of the scan data that prevented us from designing a night guard. Retake scans slowly and click ‘Resubmit Files’ to upload new data.",
    "aiProcessFailedRetakeScansTitle": "Retake Scans",
    "aiProcessFailedSwitchToManualDesign": "This scan has missing teeth, partial crowns, prepped teeth, or other issues that increase the complexity of the design. Click ‘Manual Design’ to switch to a manual design for this patient.",
    "aiProcessFailedSwitchToManualDesignHeader": "Switch to Manual Design",
    "aiReviseFailedSwitchToManualDesign": "Looks like you’ve used your free AI revision, so we recommend changing this to a manual design. We’ll deliver a design within 6 hours of submission.",
    "aiTreatmentPartnerProcessing": "Your treatment has been submitted and is currently being processed by our partner AI pipeline.",
    "aiTreatmentProcessing": "Your treatment has been submitted and is currently being processed by our AI pipeline.",
    "aiTreatmentSwitchToManualDesignDescription": "This treatment has been moved to a new case. Click ‘Go to New Treatment’ below to find it.",
    "allSlotsAreFilledInPSTZone": "All slots are filled in <b>PST</b> zone",
    "alreadyConnectedTo3Shape": "Already connected with 3Shape!",
    "alreadyTaken": "is already taken!",
    "alreadyTakenActionOnRequest": "You have already taken action on this request!",
    "alreadyUploadedBilling": "Аn invoice has already been added for this month and year",
    "amountOfLengtheningIncisalEdge": "Amount of lengthening incisal edge",
    "anEmailConfirmationWillBeSentTo": "An email confirmation will be sent to",
    "ankerPinQuestion": "Anchor Pin Slots",
    "ankerPinToolTipInfo": "Edentulous cases will always be planned with anchor pins, regardless of selection.",
    "annotationFailedMessage": "The annotation couldn’t be added because the text is too large or it’s being placed on top of another annotation. Reduce the text size or try a different part of the model.",
    "annotationFailedTitle": "Try Again",
    "annotationMessage": "Limit 5 characters. To protect patient privacy, only first names or patient initials should be annotated.",
    "anyExtraInfoAboutThisCaseThatMightHelpOurDesigners": "Any extra info about this case that might help our designers.",
    "apartmentSuiteEtc": "Apartment, suite, unit, building floor, etc.",
    "applianceProfileExists": "This Print Profile name already exists.",
    "applianceScanSetUp": "Scan with the current appliance in the patient's mouth. Capture as much anatomy as possible around the current appliance, i.e., retromolar pad, tuberosities, buccal area.",
    "approval": "Approval",
    "approveDesignNote": "By approving these designs you also agree to the",
    "approveFilesToDownloadAll": "In order to download and print these designs, you must approve them first. You can still request revisions after approval.",
    "approveImagesToReceiveFilesAll": "These preview images are representative of the final design. Once you approve, you will receive the final STL files for printing.",
    "approvingTheseImagesIndicatesYourAgreement": "Approving these images indicates your agreement to the",
    "archKitDescription": "The Arch Kit allows you to print up to 2 arches in 20 minutes while reducing resin usage. It is sold separately from Pro S.",
    "areYouSure": "Are you sure?",
    "areYouSureActivateCampaign": "Are you sure you want to activate the campaign.",
    "areYouSureActivateDevice": "Are you sure you want to activate the device?",
    "areYouSureActivateGroup": "Are you sure you want to activate the group?",
    "areYouSureActivateUser": "Are you sure you want to activate the user?",
    "areYouSureArchiveCampaign": "Are you sure you want to archive the campaigns.",
    "areYouSureAssignTreatments": "Are you sure you want to assign the selected treatment(s) to you?",
    "areYouSureCloseTreatment": "Are you sure you want to close this treatment?",
    "areYouSureDeactivateCampaign": "Are you sure you want to deactivate the campaign.",
    "areYouSureDeactivateDevice": "Are you sure you want to deactivate the device?",
    "areYouSureDeactivateGroup": "Are you sure you want to deactivate the group?",
    "areYouSureDeactivateUser": "Are you sure you want to deactivate the user?",
    "areYouSureDelete": "Are you sure you want to delete",
    "areYouSureDeleteAccount": "Are you sure you want to delete your account? This action is irreversible and you won't be able to retrive your account and information!",
    "areYouSureDeleteDraft": "Are you sure you want to delete selected drafts?",
    "areYouSureDeleteDraftSingular": "Are you sure you want to delete draft?",
    "areYouSureDeleteExtLabRelations": "Are you sure you want to delete selected external lab relations?",
    "areYouSureDeleteInvoice": "Are you sure you want to delete invoice?",
    "areYouSureDeletePlatformJob": "Are you sure you would like to delete this platform and remove its files from the print job?",
    "areYouSureDeletePrintJob": "Are you sure you want to delete this print job? You don’t be able to access it after this is done.",
    "areYouSureDeleteTemplateTreatments": "Are you sure you want to delete selected treatment templates?",
    "areYouSureDeleteTreatments": "Are you sure you want to delete selected treatments?",
    "areYouSureRemove": "Are you sure you want to remove ",
    "areYouSureRemoveFile": "Are you sure you want to remove the file(s) from Print Job",
    "areYouSureReopenTreatment": "Are you sure you want to reopen the selected treatments?",
    "areYouSureSelectDefaultPaymentMethod": "Are you sure you want set this as your default payment method?",
    "areYouSureSelectDeletePaymentMethod": "Are you sure you want to delete this payment method?",
    "areYouSureToProceed": "Are you sure you want to proceed?",
    "areYouSureYouWantToCancelTheImportOf": "Are you sure you want to cancel the import of ",
    "areYouSureYouWantToCancelThisRevisionRequest": "Are you sure you want to cancel? If you click Yes, this treatment will close, and your redesign request will be cancelled.",
    "areYouSureYouWantToCancelThisTreatment": "Are you sure you want to cancel this treatment?",
    "areYouSureYouWantToCancelThisTreatmentByDoctor": "Are you sure you want to cancel this treatment? The cost of the treatment will be credited to your Cloud Design account balance, and the treatment will be closed.",
    "areYouSureYouWantToCancelYourFuturePlan": "Are you sure you want to cancel your future plan",
    "areYouSureYouWantToChangeYourPlan": "Are you sure you want to change your plan",
    "areYouSureYouWantToDeletePrintJob": "Are you sure you want to delete print job ",
    "areYouSureYouWantToFinishThisTreatment": "Are you sure you want to finish this treatment? This will move treatment to done.",
    "areYouSureYouWantToReOpenThisTreatment": "Are you sure you want to open this treatment? This will send treatment in previous status.",
    "redesignAndRemanufactureMessage": "This option will reopen this treatment case for redesign and remanufacture.\n Please select the reason for re-opening and provide details below.",
    "areYouSureYouWantToUnassignDevicesFromThisGroup": "Are you sure you want to unassign devices from this group",
    "autoLayoutFailedMessage": "Something went wrong!",
    "autoLayoutFailedNotEnoughSpaceFileTooLarge": "File Too Large! Reduce the size of the file you wish to import onto the print plate and try uploading it again.",
    "autoLayoutFailedNotEnoughSpaceMessage": "Would you like to move objects to new tab?",
    "autoLayoutFailedNotEnoughSpaceTitle": "Not enough space on new platform!",
    "autoLayoutFailedTitle": "Auto Layout Failed!",
    "autoLayoutProcessing": "Auto Layout processing...",
    "autoOrientFailedTitle": "Auto Orient Failed",
    "autopilotMessage": "These settings will affect which autopilot settings will be activated on print preview.",
    "automatedBatchPrintingRequires": "Automated Batch Printing requires",
    "assembledViewTooltipMessage": "Files are shown in an assembled view. You can view individual files by using the opacity tool.",
    "baseHeightDescription": "Increase the base height for more consistent thermoforming results and easier mounting or decrease it for faster print times.",
    "beforeAppointmentHybridDentures": "Before your appointment, you will need to capture and/or upload the following data:",
    "beforeYouReviseThisTreatment": "Before you revise this treatment",
    "bitePositionPinsDescription": "These pins will fixate the model in the bite position that the patient was scanned in.",
    "biteScanOfAppliance": "Bite scan of appliance (optional)",
    "biteScanSetUp": "If the upper & lower scan were not in bite relation, upload a bite scan here.",
    "biteScansConfirm": "By checking this box I confirm that:",
    "biteScansConfirm1": "I uploaded upper and lower scans as open shells.",
    "biteScansConfirm2": "The uploaded upper and lower scans are in occlusion and closed bite.",
    "biteScansConfirm3": "The scans include the surfaces of all teeth and some surrounding gum.",
    "biteScansConfirm4": "This patient does not require an occlusal guard with an anterior ramp or otherwise modified design.",
    "biteScansConfirm5": "I understand that no redesigns are possible for AI Upper Nightguards aside from adjusting the fit to be tighter or looser.",
    "biteScansContent": "If your scans are not exported in occlusion, you can upload a separate bite scan here.",
    "biteScansContentForImplantRestoration": "Most upper and lower scans contain occlusion data, so bite scans are not necessary. If your scanner exports a separate bite scan, you may include it here.",
    "bitmaskInvalid": "Can not select All and other regions.",
    "bitmaskInvalidRegion": "Can not select All and other regions.",
    "bitmaskInvalidSpecialty": "Can not select All and other specialties.",
    "boo": "BOO!",
    "bracketRemovalHelp": "Click to mark each bracket and a small part of the surrounding tooth. Adjust brush size with the slider. Confirm when finished.",
    "bracketRemovalTreatmentNotesPartOne": "Our expert designers will remove brackets from a patient’s scan files, then send you the 3D models.",
    "bracketRemovalTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>Upper and lower models of the patient’s scans with brackets removed, ready to be 3D printed in your office</li></ul>",
    "bridgeTypeTooltipContent": "Click this tool, then select which tooth will be the first crown. Click again to set the second crown. Everything in between will become a pontic. You can add as many bridges as you want.",
    "bridgesMinTeeths": "Min. selected teeth: 3",
    "buccalCoverageRequired": "Buccal coverage is required.",
    "businessCustomerVATRegistration": "By using SprintRay Cloud Design you are confirming that you are a business customer. Please enter your VAT registration number or Tax ID. By not providing either number you indicate that you are not VAT registered. In that case, please consult your tax advisor, as we would anticipate that the receipt of our services would obligate you to provide us with a VAT registration number.",
    "campaignChangedIsActive": "Campaign successfully changed active/inactive state!",
    "campaignCreatedStartGeneratingCodes": "Campaign created! You can start generating promo codes.",
    "campaignSaved": "Campaign successfully saved!",
    "campaignWarningStart": "Are you sure you want to start this campaign?",
    "campaignWarningStop": "Are you sure you want to stop this campaign?",
    "canChangeAfterRevision": "You can still request revision after approving the files",
    "cancelingEmailUpdate": "Clicking this will cancel any pending email update.",
    "cancelingSubscriptionYouWillLose": "Canceling your subscription means that you’ll lose:",
    "cancelingSubscriptionWillTakeEffectOn": "This change will take effect on {{effectiveDate}}, meaning you'll still have full access until then and won't be charged again afterward.",
    "cancelNewOrderConfirmation": "Clicking “Continue to Cancel” below will cancel this treatment order.",
    "cancelNewOrderFailed": "Unable to confirm cancellation. Please refresh the order list or contact support before trying again.",
    "cancelTreatmentTooltipMessage": "This treatment can be canceled since it hasn’t been started. Once it is In Progress, you will no longer be able to cancel.",
    "cancelTreatmentMessage": "You can cancel this treatment because our designers haven’t started working on it yet. Refunds are issued as Cloud Design credits.",
    "cancelTreatmentMessageForAiCrown": "The cost of this treatment will be credited to your Cloud Design account balance, and the treatment will be closed.",
    "candidatesForClearAlignersDescription": "Candidates for clear aligners should be at least 13 years of age \\n Please be aware we cannot treatment plan a case with a bonded retainer and records submitted must be up to date.",
    "caseCancelledOfAiProcessFailedDescription": "Your case was cancelled and design credit towards your next order was applied to your account.",
    "casesAreDesignedForEstheticImprovementrMessage": "Cases are designed for esthetic improvement and will only be aligning 2nd premolar to 2nd premolar",
    "caseMovedToNewTreatment": "This case has been moved to a new treatment.",
    "categoryChangedIsActive": "Category successfully changed active/inactive state!",
    "categorySaved": "Category successfully saved!",
    "cbctScanRequired": "This field is required. Please upload a CBCT scan.",
    "cbtDescriptionPartOne": "Our special CBT models come with a unique trench created between the gingival margin and teeth (Patent Pending). This special design helps the tray material (sheet) go into the trench space during vacuforming, and creates a ridge on the tray that is pushed in between the gingiva and teeth.",
    "cbtDescriptionPartTwo": "This ridge helps the tray make a tight seal with the teeth, which prevents both the bleaching material from coming out of the tray, and also prevents saliva from getting into the tray.",
    "cementedRestorationsTreatmentNotesPartOne": "Our expert designers can help you create aesthetic, long-lasting, functional restorations, including a mix of:<ul style=\"padding-left: 1.5rem;\"><li>Crown</li><li>Inlay</li><li>Onlay</li><li>Shell Temp</li><li>Bridge</li><li>Maryland Bridge</li></ul>",
    "cementedRestorationsTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>One file for each restoration to be 3D printed in your office</li><li>An upper and lower quad model + die that can be 3D printed for a fit check</li></ul>",
    "changeDefaultShippingAddressPrompt": "To change your default address please visit your user profile.",
    "changeOrCancel": "You can change or cancel your plan at your profile after registration is done.",
    "changeOrUpgradeYourPlan": "Change or upgrade your plan",
    "changePrinterTypeWarning": "Changing the printer type may cause some overflow files to move to a new print job.",
    "changesSuccessfullySaved": "Changes saved successfully.",
    "patientAgeMinimumRequired": "Patient’s age should be at least {{years}} years old.",
    "changesWillSaved": "Changes will be saved!",
    "changesWillNotBeSaved": "Changes will not be saved!",
    "changesYouMadeMayNotBeSaved": "Changes you made may not be saved.",
    "checkEmailFirst": "To continue please confirm your email.",
    "chooseClaspsToothNumber": "This is optional. Pick up to two",
    "chooseOneBillingOptionToContinue": "Choose one billing option to continue",
    "chooseOnSubscriptionPlanToContinue": "Choose one subscription option to continue",
    "choosePlanThatSuitsYouBest": "Choose the plan that suits you best.",
    "choosePonticToothNumber": "Pick at least one and maximum up to three",
    "chooseToothNumber": "Please choose teeth that need extra attention and include relevant comments.",
    "chooseToMakePurchasesWithNeer": "This information is securely stored and only used if you choose to make purchases with Neer.",
    "clearAlignersTreatmentNotesPartOne": "Our expert team of designers will plan and deliver a set of upper and lower dental models that match your patient’s orthodontic goals.",
    "clearAlignersTreatmentNotesPartThree": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li>Candidates must be 13 years or older</li><li>No bonded retainers</li></ul>",
    "clearAlignersTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>Dental models for each stage of treatment to be 3D printed and thermoformed in your office</li><li>Retainer models to be 3D printed and thermoformed in your office</li><li>A detailed treatment plan from our design team</li></ul>",
    "clickHereToSeeInRWC": "Click here to see it in RayWare Cloud",
    "clickHereToStartAHalloweenPrintJob": "Click here to start a Halloween print job",
    "clickLinkToSplitBridge": "Click a link to split a bridge in two and click again to link them back to a single bridge; you can add as many bridges as you like",
    "clickStartToCreateTreatment": "Click \"Start New Treatment\" to create a new patient treatment.",
    "clickToResend": "Click to resend",
    "closeTreatment": "Close Treatment",
    "closedBiteAutoAdjustWarning": "You submitted this design as a closed-bite guard, but the bite was open. We designed an open-bite night guard with respect to the bite relation in the scans. This case has been changed to an open bite design based on the file submitted.",
    "closedBiteDescription": "Select this option if the bite was scanned in the closed or resting position.\n\nYou can adjust the occlusal thickness to slightly increase the bite opening. ",
    "closedBiteScansContent": "Select this option if the bite was scanned in the closed or resting position.If the bite was taken in the open position,go back and choose Open Bite.",
    "cloudDriveHomeNoRecentActivityDescription": "When you start uploading files from scanner integrations, you will see them here",
    "cloudDriveNoIntegrationDescription": "Sync your scan files directly or upload files manually, then access them anywhere in the SprintRay Cloud ecosystem.",
    "cloudDriveNoIntegrationTitle": "Your Treatment Files, Anywhere",
    "cloudDriveNoPatients": "Files from Cloud Design will appear here, plus any local files you’ve synced that are associated with a patient.",
    "cloudDriveSettingIntegrationDescription": "Select one of our partners. You will be asked to authenticate your credentials in order to activate an integration.",
    "codesGeneraredOn": "Codes generated on",
    "codesGeneratedSuccessfully": "Codes generated successfully",
    "confirmDefault": "Please confirm your actions!",
    "connectDeviceDescription": "Follow the steps below to connect your device to SprintRay Cloud",
    "connectDeviceStep1Description": "<ul style=\"padding-left: 1.5rem;font-size: 16px;font-weight: 400;line-height: 24px;\"><li>From the home screen, tap on Settings, then Connectivity</li><li>Choose whether you’ll connect via Wi-Fi or Ethernet</li><li>If using Wi-Fi, enter your password; if using Ethernet, connect a LAN cable</li></ul>",
    "connectDeviceStep2Description": "<ul style=\"padding-left: 1.5rem;font-size: 16px;font-weight: 400;line-height: 24px;\"><li>From the home screen, tap on Account</li><li>Tap ‘Sign In’</li><li>Scan the QR code with your smartphone</li><li>Follow the onscreen instructions to sign in</li></ul>",
    "congratulationsForFunFileReward": "Congratulations! You’ve unlocked a fun printable file: a custom three-part widget designed for you to assemble and enjoy. This piece not only showcases the precision of your prints but also doubles as an engaging desk toy. Print your reward now!",
    "congratulationsForStarterBundleReward": "Congratulations! You’ve earned the {{printerType}} Starter Bundle!",
    "consentAsterisk": "By clicking Allow, you allow SprintRay to use your information in accordance with their respective terms of service and pricacy policies.",
    "contactsDistanceDescription": "Set the margin between surrounding contacts.",
    "copyDentureDescription": "Create an exact replica of a patient’s current denture and/or separate a monolithic design into teeth and base.",
    "copyingFilesToNewPlatform": "Copying files to new platform….",
    "costMismatch": "Cost Mismatch!",
    "confirmLocation": "Please confirm your location",
    "pinYourPracticeLocation": "Please confirm the pin is on your practice. If it isn't, click the map to move the pin, or go back and edit your address.",
    "addressNotFoundOnMap": "We couldn't find your address on the map. You can click the map to pin your practice, or continue without a pin.",
    "addressAutocompleteHint": "Start typing your street address, then pick a match to fill in city, state and zip.",
    "noAddressSuggestions": "No matching addresses. You can keep typing it in manually.",
    "countryChanged": "Country is in another region. Please select a country in your region.",
    "completeNeed": "Complete this section in order to continue.",
    "contour": "Contour",
    "shapeAdvanced": "Shape",
    "surfaceTexture": "Surface texture",
    "connectPinterMessage": "Connect your printer to start printing.",
    "correctionOfRotations": "Correction of rotations",
    "correctionOfRotationsFull": "Correction of rotations by adding thickness",
    "correctionOfRotationsIntermediate": "Partial correction of rotations",
    "correctionOfRotationsNone": "No correction of rotations, keep as thin as possible",
    "createAnExactReplica": "Create An Exact Replica Of A Patient’s Current Denture Or Separate A Monolithic Design Into Teeth And Base.",
    "createNewJobInstructions": "To create a print job send files you would like printed together from the treatment chat. To upload files browse or drag and drop files below.",
    "creditsRewardRedeemedDescription": "These credits have been added to your account and will automatically be redeemed during the payment step.",
    "creditsAppliedToOrder": "This amount will be taken from your <strong>{{appliedCredit}}</strong> credit",
    "creditsAppliedToOrderAndRestWillBeChargedToTheCreditCard": "This amount will be taken from your <strong>{{appliedCredit}}</strong> credit and the rest will be charged to the credit card ending in <strong>{{card}}</strong>",
    "crownAndBridgeTreatmentNotesPartFour": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li>Min 0.5 mm reduction on all surfaces. Ideally 1 mm reduction.</li></ul>",
    "crownAndBridgeTreatmentNotesPartOne": "Our expert designers can help you create aesthetic, long-lasting, functional restorations.",
    "crownAndBridgeTreatmentNotesPartThree": "Treatment options:<ul style=\"padding-left: 1.5rem;\"><li>Anterior or posterior crowns</li><li>Multi-unit bridges</li></ul>",
    "crownAndBridgeTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>One file for each restoration to be 3D printed in your office</li><li>An upper and lower quad model + die that can be 3D printed for a fit check</li></ul>",
    "crownKitDescription": "The Crown Kit allows you to print up to 6 crowns in 15 minutes while reducing resin usage. It is sold separately from Pro S.",
    "crownKitPlatformTooltipDescription": "Introducing Crown Kit, a new build platform and tank designed specifically for printing restorations.",
    "crownTypeTooltipContent": "Click this tool, then select which teeth are receiving crowns. You can select as many teeth as you want.",
    "crownsTip": "Crowns are designed to be 3D printed on Pro55. Pro95 may be used, but results may vary.",
    "customBleachingTreatmentNotesPartOne": "Our patent-pending bleaching tray models create a ridge on the tray that seals against the teeth, holding in the bleaching material to prevent saliva contamination.",
    "customBleachingTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>A dental model file with added ridges to be 3D printed and thermoformed in your office</li></ul>",
    "cutToolComingSoon": "Cut tool coming soon",
    "dayguardDescription": "A full-coverage splint without anterior coverage and with an even, flat occlusal surface providing contact for the opposing teeth.",
    "dayguardPoint1": "Increased airflow makes it easier for patients to breathe and speak",
    "dayguardPoint2": "Alleviates tightness on anterior teeth",
    "dayguardPoint3": "Even, flat occlusal surface",
    "dayguardPoint4": "Point contact for each opposing tooth",
    "defaultResinDescription": "SprintRay Print and Ship night guards are always fabricated with NightGuard Flex. This durable material becomes pliable at body temperature, creating a guard that fits comfortably for your patients.",
    "deleteAllPrintJobs": "Delete All Print Jobs?",
    "deleteFilesConfirmation": "Are you sure you want to delete this/these file(s)?",
    "deletePlatformJob": "Delete Platform?",
    "dentalModelTreatmentNotesPartOne": "Get the perfect dental models designed for case presentation, study, or thermoforming.",
    "dentalModelTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>Dental models designed according to your instructions</li><li>All of the noise or excess data cleaned from your scans</li><li>Options for attachments, dies, undercut blockout, and more</li></ul>",
    "dentalModelTreatmentNotesPartThree": "Options:<ul style=\"padding-left: 1.5rem;\"><li>Design only: STL files that you can 3D print in your office</li><li>Print and Ship: models are 3D printed and shipped directly to your office</li></ul>",
    "dentalModelTreatmentNotesForNgComPartOne": "Get the perfect dental models designed, printed, and shipped to your office. Perfect for case presentation, study, or thermoforming.",
    "dentalModelTreatmentNotesForNgComPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>Dental models designed according to your instructions</li><li>All of the noise or excess data cleaned from your scans</li><li>Options for attachments, dies, undercut blockout, and more</li><li>Models 3D are printed and shipped directly to your office</li></ul>",
    "dentureStyleBasicDescription": "<ul style=\"padding-left: 1.5rem;\"><li>Gender neutral tooth mold</li><li>Light gingival festooning</li></ul>",
    "dentureStyleProDescription": "<ul style=\"padding-left: 1.5rem;\"><li>Masculine or feminine tooth molds</li><li>High gingival festooning</li><li>Custom gengiva stippling</li><li>Choose from 7 libraries or request a custom library</li></ul>",
    "dentureStyleStandardDescription": "<ul style=\"padding-left: 1.5rem;\"><li>Masculine or feminine tooth molds</li><li>Medium gingival festooning</li><li>Choose from 2 libraries</li></ul>",
    "dentureWaxSetupScanTooltip": "If the patient has a denture, we will use a scan of the denture as a template to increase the accuracy of the surgical guide.",
    "dependingOnTheScopeAndReasonForThisRevisionYouMayBeChargedUpTo": "Depending on the scope and reason for this revision, you may be charged up to",
    "describeOutcomesWithThisCrown": "Please describe the outcomes you’d like to achieve with this crown design.",
    "describeOutcomesWithThisNightGuard": "Please describe the outcomes you’d like to achieve with this night guard design.",
    "designerWillBeAssignedToCreateThisTreatment": "An expert designer will be assigned to create this treatment. Estimated turnaround time under 24 hours.",
    "designerWillCreateThisTreatment": "An expert designer will be assigned to create this treatment.",
    "DesignFinishedDetails": "You have approved this treatment and the files are ready for printing in RayWare.",
    "DesignInProgressDetails": "When this design needs attention, we’ll let you know via email. Otherwise sit back, relax, and let us handle the designing.",
    "designPrintingDetails": "Your appliance is currently being printed. You will receive an email with the tracking number as soon as it is in the mail.",
    "designNowPayLater": "Design now, pay later. You'll only be charged after you approve the design.",
    "deviceIsNotConnected": "The device you chose isn’t currently connected to SprintRay Cloud. Check the Queue on your device to find this job. This requires an active internet connection.",
    "deviceSettingsSuccessfullyUpdated": "Device settings successfully updated!",
    "didntReceivedEmail": "Didn’t receive an email.",
    "disconnectIntegration": "Disconnecting from integration will stop your syncing process with the provider and you will have to reconnect fully with credentials to restart it!",
    "disconnectedFromIntegration": "Successfully disconnected from integration!",
    "discoverNeerRewardStatusDescription": "Every order you place moves you closer to the next status level. Surpass the required threshold, and you'll be upgraded!<br/>Unlocked discounts remain active until the following year, when statuses reset. Check them out below.",
    "ditchedModelDescription": "Ditched models allow you to visualize the prep-margin without having to print a separate die.",
    "doctorNPITooltip": "As a healthcare provider, we need your 10-digit NPI in compliance with the Health Insurance Portability and Accountability Act (HIPAA).",
    "doYouNeedHelp": "Do you need help?",
    "doYouWantToSaveThoseChanges": "Do you want to save these changes?",
    "doYouWishToUploadNewScans": "Do you wish to upload new scans?",
    "doctorCannotSendMessages": "You cannot send any messages before the designer team has taken any actions!",
    "doctorReviewSubmitted": "Review submitted!",
    "dontRefreshPaymentProcess": "Please do not refresh this page or close the browser while the payment is being processed.",
    "downgradeSuccessful": "Downgrade successful!",
    "downloadAndPrintFile": "To download and print this file, you have to approve it first.",
    "dragAndDropFileOr": "Drag & Drop your file here, or",
    "dragAndDropToUpload": "Drag and drop to upload your files to dashboard.",
    "dropYourFilesHere": "Drop your files here",
    "emailConfirmationSent": "An email has been sent to ",
    "emailRequired": "Please enter an email address.",
    "emailShouldBeValid": "Please enter a valid email address.",
    "emailVerificationFailed": "Email verification failed",
    "emailVerificationFailedContent": "Invalid confirmation link, please use the most recent verification link that was sent to the email used to register.",
    "enhancedPoint1": "Square shape",
    "enhancedPoint2": "Laterals are shorter than the central incisors and cuspids",
    "enterAdditionalInstructions": "Enter additional instructions",
    "enterAPromoCode": "Enter a promo code",
    "enterCorrectDatesErr": "Please go back and enter correct dates.",
    "enterEmailToResetPassword": "Please enter your email to reset your password.",
    "enterNotificationInfo": "Enter Notification Info",
    "enterPatientInfo": "Enter Patient info",
    "enterPersonalInfo": "Enter Personal Information",
    "enterPromoCode": "Enter Your Promo Code",
    "enterScrewName": "Enter Screw Type",
    "enterCode": "Enter the code displayed on your device",
    "errorCreatingMessage": "The message could not be sent!",
    "errorDeletingModels": "Error deleting models. Refreshing platform...",
    "errorOccurredTitle": "An error has occurred!",
    "errorOnCreatePaymentMethod": "An error has occurred!",
    "exceededNotesMessage": "We currently only offer this design for single tooth restorations. Please deselect the highlighted tooth in order to change the implant area.",
    "expeditedService": "For expedited service, you can use our automatic AI to design this occlusal guard. Includes up to one revision.",
    "exportSettingsForiTero": "<strong>Export Settings for iTero</strong>",
    "exportSettingsForiTeroOne": "iTero users must enable the following option when exporting scans:",
    "exportSettingsForiTeroThree": "If you do not select this option during the export,we will not be able to complete this design.",
    "exportSettingsForiTeroTwo": "<ul style=\"padding-left: 1.5rem;\"><li class=\"strong\"><strong>File Per Arch(Arches Oriented in Occlusion)</strong></li></ul>",
    "extContainsNumbers": "Ext. should contain only numbers.",
    "feedbackExperienceOne": "How would you rate your experience with SprintRay?",
    "feedbackExperienceTwo": "Tell us about your experience",
    "fieldIsInvalid": "is in invalid format",
    "fieldIsRequired": "is required.",
    "fieldNoNA": "should not contain NA, N/A or \"@\"",
    "fieldShouldBeDivisibleBy": "should be divisible by",
    "fieldShouldBeMaximum": "should be no more than {{number}} symbols.",
    "fieldShouldBeMinimum": "should be no less than {{number}} symbols.",
    "fileIsBeingProcessed": "This file is currently being processed.",
    "fileIsEmptyOrCorruptUploadDifferentFile": "File is empty or corrupt. Please upload a different file.",
    "fileProcessingFailed": "Processing for this file failed. Please check if the file is faulty!",
    "fileCanNotBeDuplicated": "This file can’t be duplicated because the platform is full.",
    "fileCanNotBeMoved": "This file can’t be moved to a different platform because they’re all full.",
    "filesCountAssignedToPatient": "{{selectedFilesCount}} {{files}} assigned to {{patientName}}",
    "filesUploadedToPrintJobShouldBeFor": "Files uploaded to this print job must be for",
    "firstAestheticRevisionIsFreeOfCharge": "This Aesthetic Revision is Free of Charge",
    "firstAestheticRevisionPromptContent": "This treatment includes one free revision powered by AI.",
    "fitmentNotes": "Indicate any special preference for the pressure relieved areas of the design.",
    "flaredTeeth": "Flared Teeth",
    "flatGuardDescription": "A full-coverage splint with an even, flat occlusal surface providing contact for the opposing teeth.",
    "flatGuardPoint1": "Even, flat occlusal surface",
    "flatGuardPoint2": "Point contact for each opposing tooth",
    "flatOcclusalGuardBullet1": "Full occlusal coverage",
    "flatOcclusalGuardBullet2": "Even, flat occlusal surface",
    "flatOcclusalGuardBullet3": "Point contact for each opposing tooth",
    "flatOcclusalGuardDescription": "Full-coverage splint with an even, flat occlusal surface providing contact for the opposing teeth. ",
    "folderAdded": "Folder {{name}} added",
    "followUpCaseContactSupport": "To follow-up your case, please contact {{email}} or submit an inquiry via our {{contactUsForm}}.",
    "followUpCaseContactUsForm": "Help Contact Us form",
    "forOptimalDesignResultsUploadPatientBiteScans": "For optimal design results, upload patient bite scans",
    "forVeneerUploadPatientArchScans": "If you selected no-prep veneers, upload patient scans from the consultation. If you selected prep veneers, upload scans taken after tooth prep is finished.",
    "freeOfChargeTreatment": "No Charges Due",
    "freePlanCardPrompt": "Please enter payment information for future purchases. Your information is not directly stored and all payments are tokenized for secure processing.",
    "fromPrintList": "from Print List?",
    "fullOcclusalCoverage": "Full occlusal coverage",
    "generateSupportsFailedMessage": "This model is too small or is oriented in a way that supports cannot be generated. Reorient the model and try again.",
    "generateSupportsFailedTitle": "Supports Not Generated",
    "gingivaCoverTip": "Choose how much gingival coverage will best suit your patient.",
    "gingivalEdgeTip1": "Gingival scalloping will follow the gumline peaks  between teeth. ",
    "gingivalEdgeTip2": "Straight cut aligners will be trimmed at the gingival in a straight line.",
    "groupJobArchivedMessage": "This job is archived and read-only. To edit, create an active copy",
    "groupJobNoAppropriatePlatform": "This multi-platform doesn't have appropritate platform for this file. Would you like to start a new Job?",
    "guideTypeDescription": "If we find that the inter-proximal space does not allow for a fully guided plan, we will design a pilot guided plan instead.",
    "halloweenNotificationLine1": "Want more jack-o-lanterns? CTRL/CMD + D = duplicate",
    "halloweenNotificationLine2": "Want fewer? Backspace/Delete = remove",
    "hasApprovedTheRevisionFee": "has approved the revision fee.",
    "hasRejectedTheRevisionFee": "has rejected the revision fee.",
    "hereWhyWeChargingYouForThisRevision": "Here’s why we’re charging you for this revision:",
    "highestAcceptedDate": "Highest accepted date is",
    "hingeDescription": "This hinge will allow you to simulate the occlusal relationship of the arches and attaches upper and lower arch to each other.",
    "hollywoodPoint1": "Perfectly shaped and aligned teeth",
    "hollywoodPoint2": "Rounded edges, more youthful",
    "howContactSupport": "Call our support line at 1-800-914-8004 (in EU Region 0800 7070 8000) or submit a request through our customer support widget at",
    "howContactSupportQuestion": "How do I reach customer support for additional assistance?",
    "howCreateTreatment": "First, create a patient in the Patient tab. Then, you can click on the button “Start New Treatment”. Then, go through the treatment creation flow: Select the type of treatment you want, the parameters of the design, upload relevant patient files, choose printer settings, choose your appointment date, and then submit your treatment. More details",
    "howCreateTreatmentQuestion": "How do I create a treatment?",
    "howGetHelp": "Please consult our frictionless workflow guide",
    "howGetHelpQuestion": "How can I get general help with my printing workflow?",
    "howMuchBuccal": "How much buccal coverage would you like?",
    "howPrintDesign": "Find all relevant printing and post-processing details",
    "howPrintDesignQuestion": "How do I print my designs?",
    "howPromoCode": "Click on the profile dropdown in the top right corner of your screen, and find the Plan page. You can change your Plan, or enter the promo code you received and Apply it.",
    "howPromoCodeQuestion": "How do I apply a Promo Code?",
    "howRevision": "Click on the specific patient and treatment you need a revision for, then send a message to the designer in the Communication tab regarding your revision request and any relevant details. More details",
    "howRevisionQuestion": "How do I ask for a revision?",
    "hybridDentureDescriptionPartOne": "Photogrammetry scan data is required for this design",
    "hybridDentureDescriptionPartTwo": "We currently only design long-term provisional full arches. This requires the patient to be fully healed from surgery and have a current temporary present.",
    "hybridDentureTreatmentNotesPartOne": "For this treatment, you’ll set up an appointment for the day of surgery.",
    "hybridDentureTreatmentNotesPartThree": "Treatment workflow:<ul style=\"padding-left: 1.5rem;\"><li>Today: upload pre-op scans, schedule appointment slot for day of surgery</li><li>3 days later: we’ll send a smile design setup for your review</li><li>Day of surgery: upload post-op and photogrammetry/Optisplint data, we’ll provide printable files within 45 mins</li></ul>",
    "hybridDentureTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>Upper and/or lower hybrid denture file(s) to be 3D printed in your office</li><li>A smile design setup for your review and approval</li><li>A conventional denture file you can 3D print as a backup</li></ul>",
    "iAauthorizeSprintRayToChargeMyCreditCardUpTo": "I authorize SprintRay to charge my credit card up to",
    "iWouldLikeToBeNotifiedBeforeChargesOccurEvenIfItDelaysTheDesign": "I would like to be notified before charges occur, even if it delays the design",
    "ifAdditionalChargesAreAssessed": "if additional charges are assessed",
    "ifYouConfirmItWillNotBeAddedToThisPrintJob": " If you confirm, it will not be added to this print job.",
    "ifYouWantTo": "if you want to",
    "immediateDentureDescription": "Create a temporary denture to be placed immediately after a patient has had their teeth extracted.",
    "implantPlanningAndSurgicalGuideOne": "Rush surgical guides (45 minutes) will be available during the hours of 8 am ET to 7 pm ET (5 am PT to 4 pm PT).",
    "implantPlanningAndSurgicalGuideTwo": "The design is limited to simple treatment plans for crowns and bridges. Complex treatment plans, especially for implant retained dentures can not be completed as rush cases.",
    "implantRestorationTreatmentNotesPartOne": "Our expert designers can help you create aesthetic, long-lasting, functional implant restorations, including a mix of:<ul style=\"padding-left: 1.5rem;\"><li>Crown</li><li>Bridge</li><li>Shell Temp</li></ul>",
    "implantRestorationTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>One file for each restoration to be 3D printed in your office</li><li>An upper and lower quad model</li></ul>",
    "implantRestorationTreatmentNotesPartThree": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li>The exact part numbers of implant components</li><li>If our software is missing an implant component, we’ll provide a shell temp</li><li>Implant bridges are max 5 units; for more, use the hybrid denture form</li></ul>",
    "includeInstructionsInTextBox": "Include instructions in text box",
    "includeLastDoctorMessage": "Include last message from doctor.",
    "includingAnyPostOrthodontics": "Including any post orthodontics restorative treatment plan.",
    "incorrectFileFormat": "Some files have been rejected. Naming convention isn't right.",
    "inlayTypeTooltipContent": "Click this tool, then select which teeth are receiving inlays. You can select as many teeth as you want.",
    "integrationsComment": "PMS, Scanner and other CAD Software",
    "invalidApprovalorAppointmentDate": "Approval date must be at least two days in the future and the next appointment date must be after the approval date!",
    "invalidClinicId": "Invalid Clinic ID",
    "invalidAmount": "Invalid amount",
    "invalidFileFormat": "Invalid file format. Only [{{fileTypes}}] files are accepted for this section.",
    "allFileFormats": "All",
    "supportedFileFormats": "Supported file formats:",
    "unsafeFileFormat": "This file type is not allowed for security reasons.",
    "inviteUsers": "Invite Additional Users",
    "jobNameCantUseCharacterYouInputted": "Job name can’t use a character you inputted. Please limit it to the following: A-Z, a-z, 0-9, (, ), [, ], _, -",
    "keyBindingsLanguage": "Keyboard language: English (United States)",
    "fullCoverageAnteriorDeprogrammerBullet1": "Relaxes jaw to settle into an ideal position",
    "fullCoverageAnteriorDeprogrammerBullet2": "Anterior-only contact point to retrain bruxers",
    "fullCoverageAnteriorDeprogrammerDescription": "Flat plane splint with a small anterior discluding element as point contact for opposing centrals.",
    "koisOcclusalGuardDescription": "A flat plane splint with a small anterior discluding element as point contact for opposing centrals.",
    "koisOcclusalGuardPoint1": "Relax patient’s jaw to settle into an ideal position",
    "koisOcclusalGuardPoint2": "Anterior-only contact point to retrain bruxers",
    "labelNameLimitaion": "Unsupported Character Used '='",
    "labelToolComingSoon": "Label tool coming soon",
    "learnMoreInOur": "Learn more in our",
    "learnHowToExport": "Learn how to export in occlusion",
    "lateralIncisorLength": "Length of upper lateral incisors relative to central incisors",
    "lineCutHelp": "This tool uses the cursor to select an area to cut. To begin, select a model you’d like to cut then Double-Click to set a starting point. Next, move the cursor drawing lines around the area you’d like to cut. Double-Click when done. You can create choose more than one area before Confirming changes.",
    "lineCutHelpNew": "Click to create anchor points that are connected by straight lines, building a shape around the area you’d like to cut. Click the first anchor to close the loop. Confirm to cut everything inside.",
    "linkExpiredContentPart1": "For security reasons, our recovery emails expire after 30 minutes. Visit the ",
    "linkExpiredContentPart2": " page to send another one.",
    "linkExpiredTitle": "The link has expired",
    "linkingAccount": "Linking accounts...",
    "loginExternally": "Logging in with external account...",
    "loginRequired": "Please log in again!",
    "lowestAcceptedDate": "Lowest accepted date is",
    "manualRetainerTreatmentNotesPartOne": "Let us design a directly-printable retainer according to your preferences. We  provide you with the files to print the retainer in your office, no model needed. Compatible only with SprintRay Retainer.",
    "manualRetainerTreatmentNotesPartThree": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li>2 mm of tissue data beyond the margin in the anterior buckle</li></ul>",
    "manualRetainerTreatmentNotesPartTwo": "You’ll get:<br>A retainer design that can be directly printed in your office. No thermoforming required.",
    "marylandBridgeTypeTooltipContent": "Click this tool, then select which tooth will be the first wing. Click again to select the second wing. You can add as many Maryland bridges as you want.\n\nNote: Only one pontic is recommended, except when being used as a short term temp. We cannot accept any cases with more than 3 pontics.",
    "maturePoint1": "Square-shaped anteriors",
    "maturePoint2": "Almost flat along the incisal edge",
    "maturePoint3": "Laterals slightly recessed",
    "maxFileReached": "Max files reached, not all files have been loaded",
    "maxFileSizeExceeded": "Cannot upload files larger than ",
    "maxFilesCountExceeded": "Cannot upload more than {{maxFilesCount}} files at a time. Only the first {{maxFilesCount}} files are uploaded. You can upload new set of files after these are processed.",
    "supportAttachmentsCountExceeded": "Attach up to {{count}} files.",
    "supportAttachmentsTotalSizeExceeded": "Attachments cannot exceed {{size}} in total.",
    "maximumAllowedImplantDimensionsWillBeUsed": "Maximum allowed implant dimensions will be used",
    "mayTakeUpToAMinuteStlFilesToBeAvailable": "It may take up to a minute for your STL files to be available.",
    "mayTakeUpToAMinuteToReceiveTheStlFiles": "Once you approve the treatment, it may take up to a minute to receive the STL files.",
    "meshRepairFailedTitle": "Mesh Repair Failed",
    "michiganSplintBullet1": "Thinner on the posterior occlusal surface",
    "michiganSplintBullet2": "Relieves muscle strain and prevents wear/chipping",
    "michiganSplintDescription": "Splint with a canine rise and reduced buccal coverage in the anterior to guide excursive and protrusive movements.",
    "michiganSplitDescription": "Splint appliance with a canine rise to guide excursive and protrusive movements. Reduced buccal coverage in the anterior.",
    "michiganSplitPoint1": "This splint is thinner on the posterior occlusal surface",
    "michiganSplitPoint2": "Relieves muscle strain and prevent wear/chipping",
    "multiplePlatformSentToPrint": "This job contains multiple platforms, all of which have been sent to your printer. The first platform has started printed. The remaining platforms have been sent to the Queue.",
    "multiplePlatformSentToQueue": "This job contains multiple platforms, all of which have been sent to your printer. Go to the Queue tab on your printer to start this print job.",
    "mixTeethSelectNotes": "Select a treatment type from the menu on the left, then choose which teeth will receive that treatment. You can mix and match as many different treatment types as you need.",
    "movingFilesFailedMessage": "Something went wrong when moving file(s)!",
    "mustHaveAtLeastOneSelection": "Must have at least 1 selection; can’t deselect everything",
    "needToRestartPrinter": "Need to Restart Printer If Already Logged In.",
    "needsFinishingImprovements": "Needs finishing improvements",
    "networkErrorTitle": "Network Error",
    "networkErrorContent": "Your network connection is unstable. Please check your internet connection and try again.",
    "newDentureDescription": "For an edentulous patient who does not currently have a denture. A wax rim impression is required for this treatment.",
    "newFilesUploaded": "New files uploaded",
    "newGroupCreatedWithDevices": "“{{groupName}}” created with {{deviceCount}} device(s)",
    "newPatientFiles": "New patient files are attached.",
    "nightGuardFlex2Description": "Second generation resin fresh from the SprintRay Biomaterial Innovation Lab. Improved mechanical properties. Prints and polishes translucent and clear.",
    "nightGuardFlex2OceanBlueDescription": "Second generation resin fresh from the SprintRay Biomaterial Innovation Lab. Improved mechanical properties. Prints and polishes translucent with a blue tint.",
    "nightGuardFlexDescription": "With over 300,000 night guards printed, Flex is the proven choice for 3D printed occlusal guards. Prints and polishes translucent with a blue tint.",
    "nightGuardTreatmentNotesPartOne": "Choose from many night guard options designed by our team of experts.",
    "nightGuardTreatmentNotesPartThree": "Guard types:<ul style=\"padding-left: 1.5rem;\"><li>Flat plane</li><li>Buccal raised anterior ramp</li><li>Lingual raised anterior ramp</li><li>Without anterior coverage</li><li>Michigan Splint</li><li>Full Coverage Anterior Deprogrammer</li></ul>",
    "nightGuardTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>One upper or lower night guard file to be 3D printed in your office</li><li>Supporting documentation, including occlusal contact heatmap</li></ul>",
    "nightGuardTreatmentNotesForNgComPartOne": "The design will be ready for approval within 24 hours. After approval, it will ship within 48 hours.",
    "nightGuardTreatmentNotesForNgComPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>A printed night guard shipped directly to your office</li><li>Night guard care instructions</li><li>One night guard file which you can 3D print it at any time</li><li>Supporting documentation, including occlusal contact heatmap</li></ul>",
    "no-prepVeneersDescription": "No enamel is removed; veneers are bonded to the patient’s current dentition",
    "noActiveTreatments": "No active treatments",
    "noAdditionalChargesWereRequired": "No additional charges were required.",
    "noAppropriatePlatforms": "There are no appropriate platforms!",
    "noBilling": "Add a billing.",
    "noBillingAfterFilter": "There are no billings that match your filter.",
    "noBillings": "No billings yet.",
    "noClinicsAddFirst": "Add a clinic.",
    "noClinicsAfterFilter": "There are no clinics that match your filter.",
    "noCreditCard": "No credit card!",
    "noCreditCardMessage": "There is no card payment linked to the account, please add credit card payment to continue.",
    "noDataForRevisionReason": "No data for revision reason!",
    "noDevices": "There are no added devices yet.",
    "noGroupDevices": "No group devices yet.",
    "noGroupDevicesAfterFilter": "There are no group devices that match your filter.",
    "noLabs": "No labs yet.",
    "noLabsAddFirst": "Add a lab.",
    "noLicenseCertificate": "No license certificate yet.",
    "noLabsAfterFilter": "There are no labs that match your filter.",
    "noPatientsAddFirst": "To start using Dashboard for treatment designs, first create a patient.",
    "noPatientsAfterFilter": "There are no patients that match your filter.",
    "noPrintJobSubtext": "Active print jobs are listed here. To start a print job, press 'Add to Print Job' on any completed design.",
    "noPrintersFound": "No printers found",
    "noPromoCodesAfterFilter": "There are no promo codes that match your filter.",
    "noRegions": "No regions yet.",
    "noRegionsAddFirst": "Add a region.",
    "noRegionsAfterFilter": "There are no regions that match your filter.",
    "noRegisteredPrinters": "There are no SprintRay printers registered to this account. Sign in with this account on your 3D printer to sent a print job.",
    "noResults": "No results",
    "noResultsAfterFilter": "There are no results that match your filter.",
    "noSelectedTeeth": "Once you select teeth for treatment, they'll appear here",
    "noViewMessage": "When you upload scans, you’ll see them here",
    "noResultMessage": "Try selecting a different date or clear selection and reset back to default.",
    "noPrintJobsMessage": "Once you start adding them,you’ll be able to see them here.",
    "npiFormatRequirement": "NPI must contain exactly 10 digits.",
    "notConnectedToSprintRayCloud": "Not connected to SprintRay Cloud",
    "notFoundError": "The requested resource was not found.",
    "notFoundErrorTitle": "Invalid resource!",
    "notIncludedInSubscription": "This is not included in your current plan. You will be charged this amount today",
    "notPrintable": "Missing supports/incomplete meshes detected/collisional/oversize",
    "notifyMeWhenCreatedOrUpdated": "Notify me when treatments are created and updated",
    "notifyMeWhenPrintJobIsFinished": "Nofity me when a print job finished",
    "occlusalDistanceDescription": "Set the distance of occlusion between this crown design and the opposing teeth.",
    "occlusalGuardWithAnteriorRampBullet1": "Upper guard - contacts from lower posterior buccal cusp tips",
    "occlusalGuardWithAnteriorRampBullet2": "Lower guard - contacts from upper posterior palatal cusp tips",
    "occlusalGuardWithAnteriorRampBullet3": "5 degrees greater than required to disclude posterior teeth",
    "occlusalGuardWithAnteriorRampBullet4": "Protrusive and lateral length extends from contacts to approx. 4-6 mm beyond the labial surface of upper anteriors",
    "occlusalGuardWithAnteriorRampDescription1": "Full-coverage splint with an anterior ramp that provides lateral and protrusive guidance.",
    "occlusalGuardWithAnteriorRampDescription2": "Anterior Ramp Spec:",
    "occlusalGuardWithoutAnteriorCoverageBullet1": "Increased airflow makes it easier for patients to breathe and speak",
    "occlusalGuardWithoutAnteriorCoverageBullet2": "Alleviates tightness on anterior teeth",
    "occlusalGuardWithoutAnteriorCoverageBullet3": "Upper Arch: Point of contact for each opposing tooth",
    "occlusalGuardWithoutAnteriorCoverageBullet4": "Lower Arch: Point of contact for molars and premolars. No contact for anterior teeth",
    "occlusalGuardWithoutAnteriorCoverageDescription": "Full-coverage splint without anterior coverage and an even, flat occlusal surface providing contact for the opposing teeth.",
    "occlusalPlaneSmoothnessDescription1": "A: Smooth flat plane, no indentations",
    "occlusalPlaneSmoothnessDescription2": "B: Anatomical occlusion, indentations",
    "occlusalThicknessAdjustmentDescription": "Increasing occlusal thickness adds material to the biting surface of the night guard. This results in a slight increase in the bite opening and a thicker overall guard.",
    "officeNotFoundErrorTitle": "Office not found",
    "officeNotFoundError": "Office not found. Please contact the system admin",
    "ofTheCurrentlySelectedModel": "of the currently-selected model.",
    "onceThisIsDone": "? Once this is done, you can’t bring it back",
    "onceYouStartTreatments": "Once you start treatments, you’ll be able to see them here.",
    "oneOrMoreOfTheseFilesIsEmpty": "One or more of these files is empty.",
    "oneOrMoreOfTheseFilesIsIncompatible": "One or more of these files is incompatible; you can upload {{fileExtensions}}",
    "oneOrMoreOfTheseFilesIsTooLarge": "One or more of these files is too large; the max size is {{size}}",
    "onlayTypeTooltipContent": "Click this tool, then select which teeth are receiving onlays. You can select as many teeth as you want.",
    "onlyAcceptedType": "is the only accepted file type(s). Some files may have been rejected.",
    "onlyOneFileCanBeUploaded": "Only one file can be uploaded. All files have been rejected.",
    "onlyOneSprCanBeImportedAtOneTime": "Only one spr can be imported at one time",
    "openBiteAutoAdjustWarning": "You submitted this design as a open-bite guard, but the bite was closed. We designed an closed-bite night guard with respect to the bite relation in the scans. This case has been changed to an closed-bite design based on the file submitted.",
    "openBiteDescription": "Select this option if you took an open bite scan for more control over the bite opening.\n\nAll bite scans opened less than 1.5 mm will be virtually opened to 1.5 mm. ",
    "openBiteScansContentOne": "All scans opened less than 1.5mm will be virually opened to 1.5mm.",
    "openBiteScansContentTwo": "If your scans was taken in closed bite but you want to increase the bite opening,go back and select closed bite,then use the occlusal thickness tool to virtually open the bite.",
    "operationTakingTooLong": "Looks like RayWare had a communication issue. Refresh the page to try again.",
    "overdentureCaseDescription": "For an overdenture case, your scans must have enough room for the retention cap after fabrication. When you attach and cure the teeth, you will also lute the cap onto the denture.",
    "palateTip": "Depending on your patient's case, extra retention in the palate may be desirable.",
    "passwordNotValid": "Password must follow 3 of the 4 criteria: at least one Uppercase character, at least one Lowercase character, at least one Special character (@, #, $, etc) and at least one number!",
    "passwordResetLinkSent": "A link has been sent to your email with instructions on how to reset your password",
    "passwordSuccessfullyChanged": "Password was successfully changed!",
    "passwordSuccessfullyGenerated": "Your new password has been generated and was just sent to your email address!",
    "passwordSuccessfullyReset": "Password was successfully reset!",
    "passwordsDontMatch": "doesn't match!",
    "patientAdded": "Patient {{name}} added",
    "practiceLeadSavingPatient": "Saving patient...",
    "practiceLeadUploadingPatientFiles": "Uploading patient files...",
    "practiceLeadSubmittingOrder": "Submitting order...",
    "practiceLeadWaitingForOrderSubmission": "Waiting for order submission...",
    "practiceLeadUpdatingLead": "Updating lead...",
    "practiceLeadPatientFileUploadFailedReuse": "Patient was saved, but file upload failed. Submit again to update the same patient.",
    "practiceLeadOrderSubmissionFailedReuse": "Patient and files were saved, but the order was not submitted. Submit again to continue with the same patient.",
    "practiceLeadMomentDirectOrderPending": "Moment Direct order is still being submitted.",
    "patientDesiredResult": "Patient Desired Result is required",
    "patientEditConfirmationNeededContent": "Below are the changes that were made to the patient",
    "patientEditConfirmationNeededTitle": "Patient edit confirmation needed",
    "patientInformationUpdated": "Patient {{name}} information updated",
    "patientPhotoRequired": "This field is required. Please upload at least one patient photo.",
    "patientPhotoSetUp": "Recommended angles: rest position, high smile line, retracted.",
    "patientRecordsAndFilesDescription": "All patient data must be ready before the scheduled appointment.",
    "patientSaved": "Patient saved",
    "patientWasNotCompliantWithClinicianSInstructions": "Patient was not compliant with clinician's instructions",
    "patientsEdited": "Patient edited successfully. New information is available on the patient screen.",
    "pauseIntegrationSync": "By pausing your sync you will no longer get updated with the latest changes in this provider",
    "pausedIntegrationSync": "Successfully paused integration syncing.",
    "paypalFail": "Failed to add payment method. Try again or use a different payment option.",
    "payAsYouGoCheckoutOptionDescription0": "Access to Studio and Cloud Design",
    "payAsYouGoCheckoutOptionDescription1": "Pay for each treatment individually",
    "payAsYouGoCheckoutOptionDescription2": "Flexibility to try our latest and greatest",
    "paymentFailed": "Payment failed!",
    "paymentInProgress": "Please wait while we process your payment ...",
    "phoneContainsNumbers": "Phone should contain only numbers.",
    "photogrammetrySetUp": "Upload entire folder of photogrammetry data, including implant position files and STLs.",
    "planeCutFailedMessage": "Sorry - it looks like we experienced a technical glitch. Please give that another try.",
    "planeCutFailedTitle": "Please Try Again!",
    "planeCutTooltip": "Drag your mouse cursor along the blue Z axis line or use the slider below to move the plane. Make fine adjustments by entering a value below or using the arrows.",
    "platformJobAdded": "Platform Job Added",
    "platformJobArchivedMessage": "This platform has been sent to the printer, so it is read-only. To edit, create an active copy of this print job",
    "platformJobDeleted": "Platform Job Deleted",
    "platformJobDifferentAlignerTypeError": "The aligner type assigned to this file does not match the aligner type assigned to this print job. Would you like to start a new Job?",
    "platformJobDifferentAlignerTypeErrorTitle": "Different Aligner Type",
    "platformJobDifferentApplianceTypeError": "The appliance type assigned to this file does not match the appliance type assigned to this print job. Would you like to start a new Job?",
    "platformJobDifferentApplianceTypeErrorTitle": "Different Appliance Type",
    "platformJobDifferentLayerThicknessError": "The layer thickness assigned to this file does not match the layer thickness assigned to this print job. Would you like to start a new Job?",
    "platformJobDifferentLayerThicknessErrorTitle": "Different Layer Thickness!",
    "platformJobDifferentMaterialError": "The file material does not match the material originally assigned to this appliance.",
    "platformJobDifferentMaterialErrorTitle": "Different Material!",
    "platformJobDifferentPrinterPlatformError": "The printer platform assigned to this file does not match the printer platform assigned to this print job. Would you like to start a new Job?",
    "platformJobDifferentPrinterPlatformErrorTitle": "Different Printer Platform!",
    "platformJobDifferentTreatmentTypeError": "The treatment type assigned to this file does not match the treatment type assigned to this print job. Would you like to start a new Job?",
    "platformJobDifferentTreatmentTypeErrorTitle": "Different Treatment Type!",
    "platformJobNotEnoughSpaceError": "There is not enough space in the print job to fit this file. Would you like to start a new print job?",
    "platformJobNotEnoughSpaceErrorTitle": "Not enough space!",
    "pleaseAddACard": "Please add a card.",
    "pleaseAddCreditCard": "No payment method available. Please go to \"Payment\" tab and add a new card.",
    "pleaseCheckThePrinter": "Check your printer’s touchscreen for further instructions.",
    "pleaseChooseABrandFromTheSupportedList": "Please choose a brand from the supported list.",
    "pleaseChooseAbutmentBrandFromTheSupportedList": "Please choose an abutment brand from the supported list.",
    "pleaseChooseAnImplantModelFromTheSupportedList": "Please choose an implant model from the supported list.",
    "pleaseLetUsKnowWhatDidntWork": "Please let us know what didn’t work",
    "pleaseProvideAdditionalNotes": "Please provide additional notes",
    "pleaseProvideTheReasonForTheAdditionalCharge": "Please provide the reason for the additional charge",
    "pleaseRequestManualNightGuard": "Please request a manual night guard if your case does not meet all of the following criteria:",
    "pleaseSelectADate": "Please select a date in the calendar above to see available timeslots.",
    "pleaseSelectAToothInTheChartAboveInOrderToEnterImplantDimensions": "Please select a tooth in the chart above in order to enter implant dimensions.",
    "pleaseUpdateYourCreditCard": "Please update your credit card.",
    "pleaseUploadCBCTinZip": "Please upload CBCT scans in a .zip file",
    "posteriorBarFailedMessage": "The posterior bar could not be created as the selected points are too close together. Please select two more distant points on the green areas of the hybrid denture.",
    "posteriorBarFailedTitle": "Try Again",
    "posteriorBarHelp": "Enhances print accuracy, especially for vertical models. Use the cursor to select two points on the green areas of the hybrid denture to create a posterior bar.",
    "postDamDescription": "Digital dentures are extremely accurate and dimensionally stable compared to conventional dentures, so post dam is usually not necessary unless the patient needs extra retention.",
    "posteriorBarDescription": "The posterior bar increases print accuracy, especially if the model is printed vertically.",
    "postOpUpperAndLowerTissueScans": "Post-op upper & lower tissue scans ",
    "postPrepScansContent": "Upload scans taken after the prep is complete. Include the prepped area in the scan.",
    "powerBiMessage": "View and analyse data to find actionable insights.",
    "preauthorizeAdditionalCharges": "Preauthorize additional charges",
    "preppedVeneersDescription": "Requires tooth enamel to be removed from the surface to create a perfect fit",
    "pricePerRevisionAboveThePlan": "per revision above the plan limit",
    "pricePerTreatmentAboveThePlan": "per treatment above the plan limit",
    "pricePerUserAboveThePlan": "per user above the plan limit",
    "printAndShipDescription": "Our designers will create a design for your approval, then our print print technicians will 3D print the appliance in our lab and ship it to you. This option adds 2-4 days of shipping time after you approve the design. Shipping time may vary.",
    "printAndShipServiceUSOnly": "US customers only",
    "printAndShipServiceSpecificCountriesOnly": "customers only",
    "printAndShipTimeNotes": ", +2-4 days to print and ship, ",
    "printItemAddedToJob": "Item added to Print Job",
    "printJobsTooltip": "View all your connected printers, check their status, and manage print queues",
    "printMessage": "The first platform is now printing. The others have been sent to Queue.",
    "printProfileTooltip": "This is the recommended setting for the chosen appliance type. You can create your own profiles by changing the settings below.",
    "printRemainTime": "Currently in use - {{remainTime}} min remaining",
    "printSettingsRemovalModalTextPart1": "To streamline the workflow, we’ve removed the <b>printer settings</b> step from this treatment order form.",
    "printSettingsRemovalModalTextPart2": "Why?",
    "printSettingsRemovalModalTextPart3": "We audited tens of thousands of designs and determined we no longer need printer information at this stage. You will now select your printer details when you transfer the design to RayWare.",
    "printSettingsRemovalModalTextPart4": "This change does not impact the outcome of your design files.",
    "printSettingsRemovalModalTitle": "Printer Settings Removed from Order Form",
    "printSetupFeedback": "How did this print setup go?",
    "printerModelsYouHaveRegistered": "Printer models you have registered",
    "printingTimeMessage": "Estimated print time for this job is",
    "printingWarning1": "Printing will begin immediately;",
    "printingWarning2": "I have performed the",
    "printingWarning3": "to verify that my 3D printer is ready",
    "printWithOutdatedResinWarning": "The resin selected for this treatment is no longer supported, so a default resin will be selected in RayWare.  Review the print settings before starting your print job.",
    "professionalSolutions": "Professional 3D Printing Solutions for Digital Dentistry - SprintRay Inc.",
    "promo": "Promo",
    "promoCodeAppliedSuccessfully": "Promo code was successfully applied!",
    "provideReasonForChargeAndOnlyProceedIfTheClientApproves": "Provide a reason for the charge and only proceed if the client approves.",
    "provideCustomTailored": "It is also used to provide a custom-tailored experience with our services.",
    "quantityTooltipContent": "Providing your patient with an extra guard can be an economical way to demonstrate the value of your clinic. If their original guard is damaged or lost, they won’t have to wait for another one.",
    "ratingQuestionsMsg": "Hi! This is SprintRay team. We just have a couple of questions about the quality of the designs. We would be very happy if you could answer them.",
    "readyToGetStartedText": "Ready to get started? Fill out some basic patient information, then order your first design.",
    "receivedYourMessage": "We received your message and will respond shortly.",
    "recommendedAnglesRestPositionHighSmileLineAndRetracted": "Recommended Angles: Rest Position, High Smile Line, and Retracted",
    "recordDeleted": "Record successfully deleted!",
    "referenceDentureDescription": "Use an existing denture as a reference to create a new prosthetic with improved retention and esthetics.",
    "refundRequestHasBeenProcessed": "Your request has been processed and you will receive a refund in 3-5 business days.",
    "rejectingDesignFeeWillCloseThisOrder": "Rejecting the design fee will close this order. You will still be able to review and approve the previous design.",
    "removableDenturesTreatmentNotesPartFive": "Treatment options:<ul style=\"padding-left: 1.5rem;\"><li>Copy and reference dentures</li><li>Temporary monolithic dentures</li><li>Definitive two-piece dentures from scratch</li></ul>",
    "removableDenturesTreatmentNotesPartFour": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>Upper and/or lower denture files to be 3D printed in your office</li><li>Teeth and base as separate files (except for monolithic temps)</li></ul>",
    "removableDenturesTreatmentNotesPartOne": "SprintRay denture design accommodates a wide variety of cases.",
    "removableDenturesTreatmentNotesPartThree": "<a href = 'https://vimeo.com/873131051' target='_blank' style = \"color: black; text-decoration: underline\">Click to learn the scan flow for dentures.</a>",
    "removableDenturesTreatmentNotesPartTwo": "<b>Scanning for dentures is unique.</b>",
    "removeAllPrintJobs": "This will remove all print jobs associated with this account. There is no way to undo this action.",
    "removeFile": "Remove file(s)",
    "removeGroupJob": "This will remove multi-platform with all print jobs. There is no way to undo this action.",
    "repeatPasswordDoesNotMatch": "does not match password.",
    "requestApproved": "Request Approved",
    "requestRejected": "Request Rejected",
    "requestRevision": "Requesting a revision applies to all files sent.",
    "requestRevisionApprovingDesigns": "Approving these designs indicates your agreement to the",
    "reservoirTooltip": "Reservoirs will be added to anterior teeth to help reduce leakage and improve the contact between the teeth and bleaching material.",
    "resumeIntegrationSync": "Integration sync active!",
    "retentionAndTightnessDescription": "Standard fitment is ideal for most occlusal guards. If you use a flexible resin or have issues with retention, try increasing tightness. For rigid resins, consider reducing tightness.",
    "retainerThicknessToolTip": "Choose how thick you’d like the retainer design to be.",
    "retainerTightnessToolTip": "Standard tightness is ideal for most AI Retainers. If you have issues with retention, try increasing tightness. For looser retainer, use less tight.",
    "revisionChargesApproved": "Revision charges approved",
    "rushDesignCloseTime": "Rush orders are accepted {{enabledHours}} {{timeZone}} on business days.",
    "rushDesignDescription": "Rush Cemented restorations are returned in 30-45 minutes for a single unit. Each additional unit adds 15 minutes.",
    "rushDesignDescriptionForNG": "Rush Occlusal Guards are returned within 45 minutes and cost",
    "rushServiceAvailableTime": "Rush service is available Pacific Time {{availableTimes}}",
    "rushServiceDisabledDescription": "It looks like rush hours have ended since you created this order! You can either toggle to regular turnaround on the Details step or wait until rush designs are available again.",
    "saveFailed": "Something went wrong while saving! Please try again.",
    "scanProcessingError": "Scan Processing Error",
    "scanWithTheCurrentApplianceInThePatientSMouthCaptureAsMuchAnatomyAsPossibleAroundTheCurrentApplianceIERetromolarPadTuberositiesBuccalArea": "Scan with the current appliance in the patient's mouth. Capture as much anatomy as possible around the current appliance, i.e., retromolar pad, tuberosities, buccal area.",
    "searchAndAddDevicesToGroup": "Search and add devices to group",
    "searchInDesignersList": "Search In Designer List",
    "searchInLabList": "Search In Lab List",
    "searchInPatientList": "Search In Patient List",
    "selectAFileToUseThisTool": "Select a file to use this tool",
    "selectAndApplyApllianceTypeToFile": "Select and apply the appliance type to the file(s). ",
    "selectAtLeastTeeth": "Select at least {{teeth}} teeth",
    "selectAtLeastOneTooth": "Please select at least one tooth",
    "selectAtMaxMarylandBridgeTeeth": "3 pontics max for this treatment",
    "selectAtNoSuggestMarylandBridgeTeeth": "Only 1 pontic is recommended except for short term temps",
    "selectFirstAndLastToothToCreateBridge": "Select the first and last tooth to create a bridge.",
    "selectFitVariations": "Select up to three fit variations and the printer type",
    "selectOneOrMoreTeeth": "Select one or more teeth to reprint",
    "selectPlan": "Select your plan",
    "selectPlatformsInfo": "You can select multiple platforms. Each platform will be sent to your printer as a separate job.",
    "selectTeethNumber": "Select teeth number",
    "selectTheThreeDotsToChangeToothFromPonticToCrown": "Select the three dots to change a tooth from pontic to crown",
    "selectToothForNotes": "Select the tooth number(s) that need extra attention",
    "selectToothMessage": "Select the tooth you’d like to design for. Our system has identified likely preps on the highlighted teeth. You can only select one prep per treatment.",
    "selectToothMessageTips": "Select one prepped tooth",
    "selectTreatmentSubTypeCrown": "Select the type of Crown",
    "selectTreatmentSubTypeNightGuard": "Select the type of Occlusal Guard",
    "selectTreatmentSubTypeSmileDesign": "Select a Design Style",
    "selectTreatmentSubTypeSmileDesignNote": "This catalog consists of a series of different smiles devised by the Las Vegas Institute for Advanced Dental Studies.",
    "selectTreatmentType": "Select the type of treatment",
    "selectWhichAppliance": "Select which appliance types you want to see in the menu:",
    "selectWhichIndications": "Select which indications you want to see in the menu:",
    "selectAtMaxImplantRestorationBridgeTeeth": "5 units max for this treatment, for more units use the Hybrid Denture order form",
    "selfPrintDescription": "Our designers will create a design file that you can 3D print in your office for maximum speed and efficiency.",
    "sentToPrinterMessage": "The designs were successfully sent to the printer.",
    "sentToPrinterTitle": "Sent to Printer",
    "sentToQueueMessage": "Make sure your printer is ready before printing.",
    "separateBiteScans": "Separate Bite Scans",
    "separateDieDescription": "For optimal visibility, print a separate crown to visualize the prep-margin and confirm the fit of the restoration.",
    "serverError": "Our team has been notified and is curently working on fixing the issue.",
    "sessionExpired": "Your session has expired :/",
    "setProfilePhoto": "Set profile photo",
    "settingsSuccessfullySaved": "Settings successfully saved!",
    "shadeIsSetFromTheOriginalOrder": "This shade is set based on the primary shade you selected from the original order.",
    "shellTempTypeTooltipContent": "Click this tool, then select which teeth are receiving shell temps. You can select as many teeth as you want.",
    "signInWithNewPassword": "You can sign in using your new password.",
    "singleImplantWithCrownTreatmentNotesPartOne": "Plan your implant cases with confidence.",
    "singleImplantWithCrownTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>A surgical guide design to be 3D printed in your office</li><li>A temporary crown design to be 3D printed in your office and placed at the time of surgery</li><li>A treatment plan, driling protocol, and video walkthrough from our designer</li></ul>",
    "singlePlatformSentToQueue": "Go to the Queue tab on your printer to start this print job.",
    "skipThisStep": "Skip this step?",
    "smileCorrectClinicalConditionDisclaimer": "This design is intended to address a small number of anterior teeth, with a specific goal.",
    "smileCorrectTeethNotMoveTooltip": "Cases are designed for esthetic improvement and will only be aligning 2nd premolar to 2nd premolar",
    "smileCorrectTreatmentNotesFour": "For more complex cases, choose ‘Models for Clear Aligner Fabrication.’",
    "smileCorrectTreatmentNotesOne": "This treatment is for patients with mild crowding, spacing, or rotations.",
    "smileCorrectTreatmentNotesThree": "Requirements:<ul style=\"padding-left: 1.5rem;\"><li><b>Canine-to-canine</b> treatment only</li><li>Maximum 7 aligner stages</li><li>No bonded retainer</li></ul>",
    "smileCorrectTreatmentNotesTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>Dental models for each stage of treatment to be 3D printed and thermoformed in your office</li><li>A treatment plan from our design team</li></ul>",
    "smileDesignTreatmentNotesPartOne": "Smile designs improve communication and increase case acceptance for restorative treatments.",
    "smileDesignTreatmentNotesPartTwo": "You’ll get a waxup dental model to be 3D printed in your office",
    "softenedPoint1": "Square-rounded shape",
    "softenedPoint2": "Laterals are slightly shorter than the central incisors and cuspids",
    "softwareVersionInformation": "Software version can be updated on the device.",
    "sorryToHearThat": "We’re sorry to hear that! Please let us know what went wrong so we can improve.",
    "spearGuardDescription": "A full-coverage splint with an anterior ramp that provides lateral and protrusive guidance. ",
    "spearGuardPoint1": "Anterior ramp",
    "spearGuardPoint1Sub1": "5 degrees greater than required to disclude posterior teeth",
    "spearGuardPoint1Sub2": "Protrusive and lateral length extends from contacts to approx. 4-6 mm beyond the labial surface of upper anteriors",
    "spearGuardPoint2": "Upper or lower available",
    "spearGuardPoint2Sub1": "Upper guard - contacts from lower posterior buccal cusp tips",
    "spearGuardPoint2Sub2": "Lower guard - contacts from upper posterior palatal cusp tips",
    "sprintRayConsent": "is requesting permission to access the following information.",
    "sprintRayDentalModelStoneDescription": "SprintRay Print and Ship dental models are fabricated with Dental Model Stone. This material is durable, highly accurate and biocompatible.",
    "standardTimeSetByOrganization": "Standard Time Set By Organization",
    "startTypingToSearchForPatientsOrFiles": "Start typing to search for patients or files",
    "startYourPrintingJourneyForMidasDescription": "Complete prints to unlock a bundle of Cloud Design restoration cases.",
    "stateProvince": "State/Province",
    "stateProvinceRegion": "State / Province / Region",
    "streetNumberBoxEtc": "Street and number, P.O box, c/o",
    "subCategoryChangedIsActive": "Subcategory successfully changed active/inactive state!",
    "subCategorySaved": "Subcategory successfully saved!",
    "submitUpperAndLower": "Submit Upper & Lower",
    "submitUpperAndLowerContent": "It looks like the scans that were submitted are from the same arch. Reupload upper and lower scan data files or click below to ignore and proceed anyway.",
    "subscriptionCancelledSurveyYouStillHaveFullAccessUntil": "You'll still have full access to AI Studio and your files until",
    "subscriptionCheckoutOptionDescription0": "Unlimited AI Studio & AI night guard designs",
    "subscriptionCheckoutOptionDescription1": "20% off all other Cloud Design orders",
    "subscriptionCheckoutOptionDescription2": "100 GB Cloud Drive storage",
    "subscriptionGetUnlimitedAccessTo": "Get unlimited access to AI Studio designs, AI Night Guard designs, and 100 GB Cloud Drive storage.",
    "subscriptionInactive": "You have to have an active subscription to be able to submit treatments!",
    "subscriptionEffectDescription": "This change will take effect at the end of your current subscription",
    "subscriptionPlanTrialPending": "All subscriptions, including trial, automatically renew as a monthly membership.",
    "subscriptionPlanSelectAnnotation": "All subscriptions renew automatically for the selected duration",
    "subscriptionPlanPrompt": "Unlimited access to AI Studio and AI night guards for one price",
    "subscriptionUnlimitedAccessTo": "Unlimited access to AI Studio and AI night guards for one price.",
    "subsequentAestheticRevisionsFor": "Subsequent aesthetic revisions for",
    "successfullScannerTip": "For successful scan please follow the guide provided by the scanner manufacturer.",
    "successfullyCopied": "Successfully copied.",
    "successfullyCreatedAccount": "You have successfully created your account.",
    "supportIssuesDetectedMessage": "This print job may fail due to insufficient supports. Use Automatic Fix to attempt to repair using RayWare AI.",
    "supportIssuesDetectedTitle": "Support Issues Detected",
    "supportPreferencesBalancedTooltip": "Balanced is recommended in most cases to achieve ideal print results.",
    "supportPreferencesMaxDensityTooltip": "Max Density will create many thin supports that can be more easily removed.",
    "supportPreferencesMaxStrengthTooltip": "Max Strength will create fewer supports but each post and contact point will be thicker.",
    "supportRaftTooltip": "You can now place your crown models on support rafts for easy handling.",
    "supportRequestSent": "Your request has been sent. We'll reply to the email address you provided.",
    "supportingImageRequired": "This field is required. Please upload a supporting image.",
    "surgicalGuideTreatmentNotesPartFour": "Guide types:<ul style=\"padding-left: 1.5rem;\"><li>Tooth supported</li><li>Bone supported</li><li>Edentulous tissue supported w/anchor pins</li></ul>",
    "surgicalGuideTreatmentNotesPartOne": "Plan your implant cases with confidence.",
    "surgicalGuideTreatmentNotesPartThree": "Treatment options:<ul style=\"padding-left: 1.5rem;\"><li>45-minute rush service<ul style=\"padding-left: 1.5rem; list-style-type: disc\"><li>5 AM - 4 PM Pacific Time</li></ul></li><li>Standard 2-day service</li></ul>",
    "surgicalGuideTreatmentNotesPartTwo": "You’ll get:<ul style=\"padding-left: 1.5rem;\"><li>A surgical guide design to be 3D printed in your office</li><li>A treatment plan, drilling protocol, and video walkthrough from our designer</li></ul>",
    "swapUpperAndLower": "Swap Upper & Lower",
    "swapUpperAndLowerContent": "It looks like the upper and lower jaw scans were submitted in the wrong order. Swap the upper and lower files and submit again.",
    "switchPaidPlanGetExtraDiscounts": "Switch to one of our paid plans to get extra discounts and features.",
    "switchToManualDesignToContinue": "Switch to manual design to continue.",
    "syncFolderCommenet": "Medit, 3shape, Needs Launcher, Curve dental, Cloud9, Ulabs",
    "takeOneMinuteSurvey": "<span>Take 1 Minute Survey</span><span class=\"icon-external-inside-link\" style=\"padding: 0 0 2px 6px;\"></span>",
    "taxNumberDisclaimer": "Please enter your TIN/VAT registration number above. If you are not TIN/VAT registered, please consult your tax advisor. SprintRay Cloud Design services are available to business customers only.",
    "teethLimitExceeded": "You can't add more teeth to this design. The limit is ",
    "teethMustBeExtractedDescription": "Digitally removing teeth requires advanced design and planning. This added surcharge gives our designers the time to approach it properly.",
    "teethNotes": "Select a treatment type first",
    "teethToExcludeAttachment": "Teeth to Exclude from Attachments",
    "teethToExcludeIPR": "Teeth to Exclude from IPR",
    "tellUsABitAboutWhatTypesOfDentistryArePracticedAtYourClinic": "Tell us a bit about what types of dentistry are practiced at your clinic.",
    "tellUsAboutYourPractice": "Tell us about your practice",
    "tellUsReason": "Tell us more about your experience.",
    "textAnnotationRequired": "Text Annotation is required!",
    "thankYouForFeedback": "Thank you for your feedback!",
    "thanksMidas": "Thank you for purchasing Midas! You’ve unlocked a full year of complimentary unlimited access to AI Studio and AI night guard.",
    "thankYouForDesignFeedback": "Great! Thank you for your feedback.",
    "thankYouForRegistration": "Thank you for registration on SprintRay Omega Platform. You can start creating patients and treatments.",
    "thankYouForOrder": "Thank you for your order!",
    "thanksForFeedback": "Thanks for your feedback!",
    "theClientMustApproveChargesBeforeYouReviseThisTreatment": "The client must approve charges before you revise this treatment.",
    "theFileSizeYouUploadedLimitTips": "Files must be between {{minFileSize}}-{{maxFileSize}} MB. Your file was not uploaded; try a different file.",
    "theFirstAestheticRevisionForThisTreatmentIsFree": "The first aesthetic revision for this treatment is free.",
    "theFitAdjustmentTool": "The Fit Adjustment tool affects every model in this print job and should only be used by advanced users or when operating under the guidance of a SprintRay technician.",
    "theFollowingRolesWillBeNotified": "The Following Roles Will Be Notified",
    "theTreatmentWasSuccessfullyCancelled": "The treatment was successfully cancelled.",
    "thereIsProblemWithPayment": "There is a problem with payment.",
    "thereIsProblemWithYourPaymentMethod": "There is a problem with your payment method.",
    "thisAiTreatmentIsReadyForToReview": "Your designs are ready for review. Approving these designs means you also agree to the <a class=\"link\" target=\"_blank\" href=\"https://sprintray.com/dental-appliance-design-service/waiver-of-liability/\">SprintRay Terms of Liability</a>.",
    "thisDeviceIsCurrentlyInsideGroups": "This device is currently inside groups:",
    "thisIsTakingLongerThanExpected": "This is taking longer than expected",
    "thisTreatmentIsReadyForToReview": "This treatment is ready for you to review. If you approve, the design will be printable immediately. If you’d like revisions, we’ll tackle them as quick as we can.",
    "thisWillTakeYouOutsideOfSprintRayCloud": "This will take you outside of SprintRay Cloud. Design to schedule your appointment. Once you finish scheduling, return to this page to continue.",
    "tinTooltip": "Your 9-digit TIN is required to comply with US Internal Revenue Service.",
    "tinVatFormatRequirement": "TIN/VAT # must contain 9 to 11 digits.",
    "tissueScanSetUp": "With healing caps seated over abutments.",
    "toChangeOrCancelYourAppointment": "To change or cancel your appointment, reach out to SprintRay Customer Support at 1-800-914-8004",
    "toConnectToPRO": "To connect SprintRay PRO to a network:",
    "toConnectToPRO1": "1. Select the \"Settings\" tab on your Pro’s touchscreen",
    "toConnectToPRO2": "2. Select \"Wireless Networks\"",
    "toConnectToPRO3": "3. Select your network from the list",
    "toConnectToPRO4": "4. Enter password for network and select \"Connect\"",
    "toConnectToPRO5": "5. Log into your SprintRay account located on the home screen of the Printer",
    "toConnectToPRO1ForV2": "1. Make sure that your printer is connected to the internet",
    "toConnectToPRO2ForV2": "2. Go to the account settings screen, then sign in",
    "toConnectToPRO3ForV2": "3. Scan the QR code on your printer",
    "toConnectToPRO4ForV2": "4. Once you’ve signed in, refresh this page",
    "toggleNewRayWareText": "The page will need to refresh itself and all changes may be lost.",
    "toothLibraryOtherDescription": "Don't see a library you want? Request a library to see if we have it available. We will either design it with the requested library or try to find an alternative one close to it.",
    "treatmentFinishRateQuestion": "How likely are you to recommend our service to your partners?",
    "treatmentHasBeenCanceled": "This treatment has been canceled.",
    "treatmentPlanInputLabel": "Provide as many details as you can - missing information can delay the design of the case.",
    "treatmentPlanInputLabelForOG": "Provide as many details as you can - missing information can delay the design of the case. This could include any special preferences for pressure relief in specific areas.",
    "treatmentPlanInputLabelForSmileDesign": "Provide as many details as you can - missing information can delay the design of the case. This should include the patients chief complaint and desired outcome.",
    "treatmentPlanInputLabelForBracketRemoval": "Provide as many details as you can - missing information can delay the design of the case. This could include instructions regarding brackets you would like to not be removed.",
    "treatmentPlanRequiredInputLabel": "Please provide a detailed description of the patients main complaints, treatment plan, planned outcome and any special considerations",
    "treatmentSent": "treatment you have requested has been sent. A designer will be contacting you soon requesting your approval or feedback.",
    "treatmentNotAllowReSelect": "Treatment setup cannot be changed; start a new treatment",
    "trialSmileNote": "Appropriate cases will also receive a complimentary Trial Smile appliance based on the complexity of the teeth",
    "turnOffAutopilotModeToUseTools": "Turn off autopilot mode to use tools",
    "unAbleToCopyFiles": "Unable to copy file(s). Please check your file(s) and try again.",
    "unauthorizedError": "You have no access to the requested resource.",
    "unauthorizedErrorTitle": "Unauthorized request!",
    "undercutBlockOutDescription": "Select undercut block-out if you are planning to use the models for thermoforming.",
    "unsavedChanges": "There are ",
    "unsavedInfo": "Are you sure you would like to leave this page? Any unsaved information will be lost!",
    "updateApllianceProfile": "Do you want to update the current print profile with the latest changes?",
    "upgradeSuccessful": "Upgrade successful!",
    "upgradeYourFreePlan": "Upgrade your free plan",
    "uploadBiteScans": "Upload bite scans",
    "uploadBiteScansHelper": "If your scans are not exported in occlusion, you can upload a separate bite scan here.",
    "uploadFile": "Drag and drop to upload your files",
    "uploadFileScanIssueFoundContent": "Our complementary Scan Quality Check analyzed this file to make sure there won’t be any issues with your design. Unfortunately we found that the file is corrupt and not usable. We recommend to upload a new file.",
    "uploadFolderPartOne": "Upload folder for automatic sorting of files",
    "uploadFolderPartTwo": "Or upload individually",
    "uploadJawScans": "Upload maxillary and mandibular scans",
    "uploadMessage": "Upload upper and lower <span style=\"color: white;\">post-op scans</span>. Make sure your scans are exported in bite relation and that the prep is cleanly scanned.",
    "uploadNotes": "Upload saved to Cloud Drive. If you are uploading files for a treatment, go back and use the ‘Browse’ option.",
    "uploadOptionalScans": "Optional supporting images",
    "uploadPracticeImages": "Upload practice images",
    "uploadProfilePhoto": "Upload your image or select from given list.",
    "uploadRequiredScans": "Please upload pictures of patient smiling *",
    "uploadScansAfterPreppingContent": "If the treatment you selected requires prep, make sure your scans include the prepped teeth with plenty of margin. ",
    "uploadScansAfterImplantPlacementContent": "Make sure the scans clearly show the abutment or scan flag.",
    "uploadZipFolderOfPhotogrammetryDataIncludingImplantPositionFilesAndStls": "Upload zip folder of photogrammetry data, including implant position files and STLs",
    "upperOcclusalLowerOcclusalLeftSideRightSidePatientNaturalSmile": "Upper occlusal, lower occlusal, left side, right side, patient natural smile",
    "upperLateralIncisorLength": "Upper lateral incisor length",
    "useAdditionalItemsForSettingFreeItems": "If you want to add free item, please add it from the section Additional Items",
    "useAnExistingDentureAsAReference": "Use An Existing Denture As A Reference To Create A New Prosthetic With Improved Retention And Esthetics.",
    "useAiStudioTitle": "Use AI Studio to Design a Case",
    "useAiStudioSubTitle": "Studio offers fast, AI-assisted design that’s fully integrated with your workflow.",
    "userPointStageDescription": {
      "bronze": "Unlock this status when signing up to Neer.",
      "silver": "Unlock this status upon completing",
      "gold": "Unlock this status upon completing",
      "diamond": "Unlock this status upon completing"
    },
    "uvBleedCompensationFailedTitle": "UV Bleed Compensation Failed",
    "veneersTreatmentNotesFour": "For best results, start with a ‘Smile Design’ treatment to improve communication and case acceptance.",
    "veneersTreatmentNotesOne": "Help your patient achieve their aesthetic goals with prep and no-prep options.",
    "veneersTreatmentNotesThree": "Treatment options:<ul style=\"padding-left: 1.5rem;\"><li>Prepped Neer</li><li>No-prep Neer</li></ul>",
    "veneersTreatmentNotesTwo": "What you’ll get:<ul style=\"padding-left: 1.5rem;\"><li>A set of veneers as individual files to be 3D printed in your office</li></ul>",
    "verificationExpired": "Verification Email has expired!",
    "verifiedEmail": "You have successfully verified your email address. <br/> Please make sure to click the <b>Save Email</b> button below to use the new email on your next Neer log-in.",
    "verifyYourCloudAccountDescribe": "Verification link sent! Check your email <b>Inbox</b> or <b>Spam</b> folder and click the link to verify your account.",
    "vigorousPoint1": "Flat along the incisal edge",
    "vigorousPoint2": "Slightly longer canines",
    "weCloudNotCompleteYourDesign": "We could not complete your design due to missing information, unusable files or other reasons. Please see the designers message to learn more and proceed with the design.",
    "weWillUseTheMaximumAllowedImplantDimensions": "We will use the maximum allowed implant dimensions unless you set them manually.",
    "weveBeenHardAtWorkRayware": "We’ve been hard at work making RayWare Cloud better.",
    "weUseThisInformation": "We use this information to verify that you are an active dental professional.",
    "whatAreYouLookingFor": "What are you looking for?",
    "whatShouldWeChange": "What should we change?",
    "whatWouldYouLikeToNameThisGroup": "What would you like to name this group?",
    "whenYouAssignFilesToThisPatientYouWillSeeThemHere": "When you assign files to this patient, you will see them here",
    "whereDoYouWantToUploadTheFiles": "Where do you want to upload the files?",
    "whyCancelYouSubscriptionText": "We’re always improving our service and your feedback matters. Why did you cancel your subscription? You can select multiple answers:",
    "willBeChargedUsingCreditCardEndingWith": "will be charged using credit card ending with",
    "willBeTakenFromYour": "will be taken from your ",
    "withHealingCapsSeatedOverMua": "With healing caps seated over MUA",
    "whichFilesDoYouWantToAdd": "Which files do you want to add?",
    "whichPrintJobDoYouWantToAddTo": "Which print job do you want to add to?",
    "wrongKit": "The print kit you selected doesn’t match what’s on this printer",
    "wrongKitAndResin": "The print kit and material you selected don’t match what’s on this printer",
    "wrongPrinterCompatibility": "Equipment mismatch possible - check your printer before starting",
    "wrongPrinterType": "You selected a different printer type",
    "wrongResin": "The material you selected doesn’t match what’s on this printer",
    "youCanAlwaysAccessTrainingPlatformViaProfileMenu": "You can always access the training platform via the profile menu.",
    "youCanAlwaysAddUserFromProfile": "You can always add user to your team from your profile page.",
    "youCanReviewTheRedesignPolicy": "You can review the redesign policy",
    "youChangedThe": "You changed the",
    "youHaveADifferentResinInstalledInYourPrinter": "You have a different resin installed in your printer",
    "youHaveAlreadyUsedYourFreeRevision": "You’ve already used your free revision.",
    "youHaveNoRegisteredPrinters": "You have no registered printers",
    "youMustRequestApprovalForTheAdditionalCharges": "you must request approval for the additional charges",
    "youWillPerformTheSurgeryOnTheSelectedDay": "You will perform the surgery on the selected day and capture post-op patient data. A SprintRay designer will be on standby to create the fixed denture.",
    "youWillReceiveAnUpdate": "You will receive an update in 24 hours.",
    "youWillStillBeAbleToReviewAndApproveThePreviousDesign": "You will still be able to review and approve the previous design.",
    "youSelectedSeveralApplianceTypes": "You've selected several appliance types, you'll be asked where you want to send each appliance in the following steps.",
    "yourClinicalReviewIsInProgress": "Your Clinical review is in progress.",
    "yourCreditCardHasExpired": "Your credit card has expired!",
    "yourCreditCardWillBeRefundedTheDifferenceInPriceBetweenAIAndManualTreatment": "Your credit card will be refunded the difference in price between AI and manual treatment.",
    "yourCreditCardWillExpireIn": "Your credit card will expire in",
    "yourDesignIsBeingProcessedYouWillReceiveYourFilesMomentarily": "Your design is being processed; you will receive your files momentarily. This process can take up to a minute. If 5 minutes have elapsed and you still have not received your STLs, contact support.",
    "yourExistingPlan": "Your existing plan",
    "yourFilesAreReadyForApproval": "Your files are ready for approval.",
    "yourPrintJobIsSliced1": "Your print job is being sliced and saved. Depending on the volume of your print job, ",
    "yourPrintJobIsSliced2": "this may take up to 5 minutes.",
    "yourRevisionRequestIsInProgress": "Your revision request is in progress.",
    "yourSmileDesign3days": "Your smile design will be sent within 3 business days.",
    "yourSubscriptionCanceled": "Your {{interval}} subscription has been canceled and will end on",
    "yourNextSubscriptionStart": "Your {{interval}} subscription will start on",
    "yourNextPaymentIsOn": "Your next payment is on",
    "youthfulPoint1": "Scalloped along the incisal edge",
    "youthfulPoint2": "Laterals are shorter than the central incisors and cuspids",
    "invitationCodeAccessRefreshing": "Your invitation code was redeemed, but your account access is still refreshing. Please continue again.",
    "invitationCodeAccountRefreshFailed": "Your invitation code was redeemed, but your account could not be refreshed. Please continue again.",
    "providerPaymentRefreshing": "Your payment is complete. Refreshing your account...",
    "providerPaymentRefreshFailed": "Your payment is complete, but account access could not be refreshed. Please retry.",
    "invitationCodeApplyFailed": "Unable to apply invitation code",
    "invitationCodeInvalidFormat": "Enter a valid invitation code or clear it to continue to payment.",
    "invitationCodeInvalidOrUnavailable": "This invitation code is invalid or unavailable.",
    "invitationCodeNetworkError": "Unable to reach the invitation code service. Please check your connection and try again.",
    "invitationCodeRedeemFailed": "Unable to redeem this invitation code. Please try again.",
    "invitationCodeRequired": "Enter an invitation code.",
    "invitationCodeServiceUnavailable": "Invitation code redemption is temporarily unavailable. Please try again later.",
    "invitationCodeSessionCannotRedeem": "Your session cannot redeem this invitation code. Please sign in again.",
    "invitationCodeSessionRefreshRequired": "Your invitation code was redeemed, but your session must be refreshed. Please sign in again.",
    "invitationCodeTooManyAttempts": "Too many invitation code attempts. Please try again later."
  },
  "months": {
    "april": "April",
    "august": "August",
    "december": "December",
    "february": "February",
    "january": "January",
    "july": "July",
    "june": "June",
    "march": "March",
    "may": "May",
    "november": "November",
    "october": "October",
    "september": "September"
  },
  "shortDays": {
    "friday": "Fr",
    "monday": "Mo",
    "saturday": "Sa",
    "sunday": "Su",
    "thursday": "Th",
    "tuesday": "Tu",
    "wednesday": "We"
  },
  "shortMonths": {
    "april": "Apr",
    "august": "Aug",
    "december": "Dec",
    "february": "Feb",
    "january": "Jan",
    "july": "Jul",
    "june": "Jun",
    "march": "Mar",
    "may": "May",
    "november": "Nov",
    "october": "Oct",
    "september": "Sep"
  }
}
